{
  "account-deletion": {
    "disclaimer": "La eliminación de tu cuenta es permanente.",
    "primaryButtonText": "Eliminar cuenta",
    "subtitle": "Tu perfil, tus ofertas, tus necesidades, tus datos y tus conversaciones con los miembros serán eliminados permanentemente.",
    "title": "Eliminar cuenta",
    "backButtonText": "Cancelar"
  },
  "accordion": {
    "showMore": "Ver más",
    "showLess": "Ver menos"
  },
  "accessibility": {
    "favourite": {
      "add": "Agregar a favoritos",
      "remove": "Quitar de favoritos"
    },
    "close": "Cerrar",
    "goBack": "Volver",
    "shareListing": "Compartir anuncio",
    "resetPassword": {
      "close": "Cerrar restablecimiento de contraseña"
    },
    "forgotPassword": {
      "close": "Cerrar recuperación de contraseña"
    },
    "request": {
      "hide": "Ocultar",
      "hideHint": "Oculta esta solicitud de tu lista",
      "restore": "Restaurar"
    },
    "imagePicker": {
      "addImage": "Agregar una foto",
      "addImageHint": "Agrega otra foto a tu anuncio",
      "removeImage": "Eliminar foto",
      "removeImageHint": "Quita esta foto de tu anuncio",
      "openCamera": "Cámara",
      "openLibrary": "Galería de fotos"
    },
    "imageSwiper": {
      "previous": "Imagen anterior",
      "next": "Imagen siguiente"
    },
    "avatar": {
      "edit": "Modificar mi foto"
    },
    "chat": {
      "minimizeConversation": "Minimizar conversación",
      "messageActions": "Acciones del mensaje",
      "newConversation": "Nueva conversación",
      "moreActions": "Más acciones",
      "moreActionsHint": "Abre un menú con acciones para silenciar, marcar como no leída, renombrar, salir y eliminar",
      "toolbar": {
        "openCamera": "Abrir la cámara",
        "openLibrary": "Abrir la galería de fotos",
        "sendLike": "Enviar un pulgar arriba",
        "sendMessage": "Enviar el mensaje"
      }
    },
    "list": {
      "toggleViewMode": "Cambiar modo de vista"
    },
    "carousel": {
      "previousSlide": "Diapositiva anterior",
      "previousSlideHint": "Desplaza la lista hacia la izquierda",
      "nextSlide": "Diapositiva siguiente",
      "nextSlideHint": "Desplaza la lista hacia la derecha"
    },
    "search": {
      "clearSearch": "Limpiar búsqueda",
      "clearSearchHint": "Borra el texto de búsqueda actual"
    },
    "profile": {
      "moreActions": "Más acciones del perfil",
      "editUnavailabilityStatus": "Editar estado de no disponibilidad",
      "viewMember": "Ver el perfil de {{name}}"
    }
  },
  "download": {
    "download": "Descargar",
    "the_app": "la aplicación"
  },
  "loginAsPrompt": {
    "title": "¿Iniciar sesión como {{userName}}?",
    "message": "¿Quieres iniciar sesión como {{userName}}?",
    "no": "No",
    "yes": "Sí"
  },
  "all-channels": {
    "sharedListing": "{{sender}} compartió un anuncio",
    "sharedProfile": "{{sender}} compartió un perfil",
    "tabBarLabel": "Mensajes",
    "title": "Conversaciones",
    "headerWithUnreadCount": "Mensajes ({{count}}) - No leídos {{unreadCount}}",
    "archive": "Archivar",
    "archived": "Archivada",
    "archivedConfirmation": "Conversación archivada",
    "archivedUndo": "Desarchivar",
    "markAsUnreadButton": "Marcar como no leído",
    "archiveButton": "Archivar",
    "cancelSelection": "Cancelar",
    "markAsUnreadSwipe": "Marcar no leído",
    "silence": "Silenciar",
    "unsilence": "Activar",
    "markingAsRead": "Conversación marcada como no leída.",
    "lookingForArchive": "Para archivar, desliza hacia la derecha.",
    "empty": {
      "secondLine": {
        "recent": "No has intercambiado mensajes con un miembro recientemente.",
        "archived": "No hay conversaciones archivadas.\nDesliza una conversación para archivarla."
      }
    },
    "footer": {
      "title": "¿Dónde están mis otras conversaciones?",
      "text": "Las conversaciones antiguas se archivan automáticamente. Haz clic en la pestaña Archivadas para verlas.",
      "button": "Ver conversaciones archivadas"
    },
    "file": "[Foto]",
    "filters": {
      "listing": "Por objeto",
      "personal": "Por miembro"
    },
    "loan": {
      "accepted": "Propuesta de préstamo - aceptada",
      "completed": "Préstamo completado",
      "pending": "Propuesta de préstamo - pendiente",
      "rejected": "Propuesta de préstamo - rechazada"
    },
    "service": {
      "accepted": "Oferta de servicio - aceptada",
      "completed": "Servicio realizado",
      "pending": "Oferta de servicio - pendiente",
      "rejected": "Oferta de servicio - rechazada"
    },
    "donation": {
      "accepted": "Oferta de donación - aceptada",
      "completed": "Donación completada",
      "pending": "Oferta de donación - pendiente",
      "rejected": "Oferta de donación - rechazada"
    },
    "sell": {
      "accepted": "Propuesta de venta - aceptada",
      "completed": "Venta completada",
      "pending": "Propuesta de venta - pendiente",
      "rejected": "Propuesta de venta - rechazada"
    },
    "noResponse": "Recibido hace {{ago}}. ¿Responder?",
    "tabs": {
      "recent": "Recientes",
      "archived": "Archivadas"
    },
    "noChannelSelected": "Ninguna conversación seleccionada",
    "groupConversationCount_one": "{{count}} conversación",
    "groupConversationCount": "{{count}} conversaciones"
  },
  "landing-page": {
    "tabs": {
      "explore": "Explorar",
      "home": "Inicio",
      "feed": "Comunidad",
      "catalog": "Explorar"
    },
    "manageMyInterests": "Gestionar mis intereses",
    "recentSearches": "Búsquedas recientes",
    "popularTags": "Intereses populares",
    "viewAllListings": "Ver todas las ofertas",
    "quickActions": {
      "loanOutgoing_one": "1 préstamo",
      "loanOutgoing_other": "{{count}} préstamos",
      "loanIncoming_one": "1 préstamo tomado",
      "loanIncoming_other": "{{count}} préstamos tomados",
      "noActivity": "Sin actividad",
      "activity": "Actividad",
      "messages": "Mensajes",
      "pendingRatings": "Evaluaciones",
      "pendingRatingsSubtitle_one": "1 pendiente",
      "pendingRatingsSubtitle_other": "{{count}} pendientes",
      "unread": "no leído(s)",
      "noUnread": "Todo leído",
      "createPost": "Compartir una experiencia",
      "createPostSubtitle_one": "1 intercambio para compartir",
      "createPostSubtitle_other": "{{count}} intercambios para compartir"
    },
    "upcomingActivity": {
      "title": "Próxima actividad",
      "allTitle": "Actividad de préstamos",
      "window": "Tus próximos 3 días",
      "allWindow": "Todos tus préstamos activos",
      "filteredWindow": "Actividad en {{period}}",
      "viewAll": "Ver todo",
      "openDetails": "Abre los detalles del préstamo",
      "deletedUser": "Usuario eliminado",
      "calendar": {
        "addLabel": "Añadir esta fecha a mi calendario",
        "addedLabel": "Añadido a mi calendario",
        "added": "{{item}} se añadió a tu calendario"
      },
      "filters": {
        "all": "Todo",
        "threeDays": "3 días",
        "oneWeek": "1 semana",
        "oneMonth": "1 mes",
        "threeMonths": "3 meses",
        "sixMonths": "6 meses",
        "empty": "No hay actividad en este período"
      },
      "roles": {
        "lending": "Prestando",
        "borrowing": "Pidiendo prestado"
      },
      "donationRoles": {
        "lending": "Donación ofrecida",
        "borrowing": "Donación recibida"
      },
      "saleRoles": {
        "lending": "Venta",
        "borrowing": "Compra"
      },
      "actions": {
        "completePurchase": "Confirmar recepción de {{name}}",
        "completeSale": "Confirmar venta a {{name}}",
        "handOff": "Entregar a {{name}}",
        "pickUp": "Recoger de {{name}}",
        "returnItem": "Devolver a {{name}}",
        "expectReturn": "Esperar devolución de {{name}}",
        "confirmReturn": "Confirmar devolución de {{name}}",
        "confirmSale": "Confirmar venta con {{name}}"
      },
      "relative": {
        "actionRequired": "Acción necesaria",
        "overdue_one": "1 día de retraso",
        "overdue_other": "{{count}} días de retraso",
        "today": "Hoy",
        "tomorrow": "Mañana",
        "inDays_one": "En 1 día",
        "inDays_other": "En {{count}} días"
      },
      "empty": {
        "title": "Todo está al día",
        "subtitle": "Nada requiere tu atención en los próximos 3 días."
      }
    },
    "stepsToComplete": {
      "stepsCompleted": "{{completed}} de {{total}} paso(s) completado(s)",
      "nextStep": "Siguiente paso: {{step}}",
      "title": "Completa tu perfil",
      "description": "Genera confianza entre los miembros completando tu perfil...",
      "completedTitle": "¡Perfil completado, bien hecho! 🎉",
      "completedSubtitle": "Inspiras confianza entre los miembros de la comunidad",
      "addPicture": "Agregar una foto",
      "addBio": "Agregar una biografía",
      "setInterests": "Establecer tus intereses",
      "addListings": "Agregar ({{count}}/5) objetos para prestar"
    },
    "popularInterests": "Intereses populares 📈",
    "myInterests": "Mis intereses 🎯",
    "noInterestsTitle": "Personaliza tu descubrimiento",
    "noInterestsSubtitle": "Elige tus intereses y recibe sugerencias adaptadas a ti.",
    "addInterestsCta": "Añadir mis intereses",
    "greeting": {
      "morning": "Buenos días",
      "afternoon": "Buenas tardes",
      "evening": "Buenas noches"
    },
    "subscription": {
      "discovery": "Descubrimiento"
    },
    "unlockFullExperience": {
      "accessibilityLabel": "Desbloquear la experiencia completa",
      "title": "¡Desbloquea la experiencia completa!",
      "discount": "-25 %",
      "discountDeadline": "hasta el {{date}}"
    },
    "requests": {
      "emptyState": {
        "title": "Nada que mostrar por el momento.",
        "subtitle": "Te avisaremos si tus vecinos necesitan ayuda",
        "cta": "Ver todas las necesidades"
      }
    },
    "theme": "Tema de la semana",
    "multipleOfferCard": {
      "new": "Nuevo",
      "quickOffers": "Publicar objetos",
      "desktopBadge": "Oferta rápida ⚡",
      "title": "Seguro que tienes estos objetos en casa",
      "desktopSubtitle": "Buenas noticias: las ofertas ya están listas para publicar",
      "subtitle": "Buenas noticias: las ofertas ya están listas para publicar",
      "button": "Publicar en un instante",
      "desktopButton": "Publicar en un instante"
    },
    "viewMore": "Ver más",
    "viewLess": "Ver menos",
    "carousel": {
      "previousSlide": "Diapositiva anterior",
      "nextSlide": "Diapositiva siguiente",
      "previousSlideHint": "Desplaza la lista hacia la izquierda",
      "nextSlideHint": "Desplaza la lista hacia la derecha"
    },
    "immature": {
      "defricheur": {
        "title": "Oferta pionera",
        "text": "Hay pocos objetos en tu barrio. <strong>Suscripción gratuita para los 5 primeros</strong> que publiquen un objeto.",
        "button": "Publica una oferta"
      },
      "referral": {
        "title": "Ayúdanos a hacer crecer la comunidad. Invita a <strong>5 personas</strong> y gana <strong>¡un regalo por valor de 25 $!</strong>",
        "progress": "{{current}} de {{total}}",
        "button": "Invita a tus vecinos",
        "seeConditions": "Ver condiciones"
      },
      "writeToMayor": {
        "title": "Pide a tu ciudad que ofrezca Partage Club a sus ciudadanos",
        "text": "Hemos redactado una carta que puedes enviar directamente. Solo tienes que rellenar el formulario de solicitud en nuestro sitio web",
        "button": "Escribir al alcalde",
        "textLetter": "Hemos redactado una carta que puedes personalizar y enviar al alcalde de tu ciudad."
      },
      "socialMedia": {
        "title": "¡Síguenos en las redes sociales!",
        "text": "Únete a miles de personas de confianza que comparten"
      }
    }
  },
  "my-interests": {
    "title": "Mis intereses",
    "subtitle": "Selecciona tus intereses para personalizar tu experiencia de descubrimiento",
    "searchPlaceholder": "Buscar un interés…",
    "selectedSection": "Seleccionados ({{count}})",
    "exploreSection": "Todos los intereses",
    "noResults": "Sin resultados para \"{{query}}\"",
    "emptyTitle": "Ningún interés seleccionado",
    "emptySubtitle": "Toca un interés a continuación para añadirlo a tu perfil"
  },
  "all-listings": {
    "map": {
      "signInToExplore": "Inicia sesión para explorar el mapa.",
      "approximateLocation": "Ubicación aproximada",
      "switchToMap": "Cambiar a la vista de mapa",
      "switchToList": "Cambiar a la vista de lista"
    },
    "emptyRequests": {
      "title": "Las necesidades más recientes aparecen aquí",
      "secondTitle": "Nada que mostrar por el momento. ¡Sé el primero en agregar una necesidad!",
      "button": "Agregar una necesidad"
    },
    "bonificationPrompt": {
      "title_one": "Un objeto para bonificar",
      "title": "{{numListings}} objetos para bonificar",
      "text_one": "Tienes <strong>un objeto</strong> con una foto genérica o sin descripción. ¡Los objetos con foto tienen más probabilidades de ser prestados!",
      "text": "Tienes <strong>{{numListings}} objetos</strong> con una foto genérica o sin descripción. ¡Los objetos con foto tienen más probabilidades de ser prestados!",
      "button_one": "Completar la ficha del objeto",
      "button": "Ver mis anuncios",
      "dismiss": "Cerrar"
    },
    "pendingBonificationsBanner": {
      "title_one": "1 sugerencia por revisar",
      "title": "{{count}} sugerencias por revisar",
      "subtitle": "Un prestatario ha sugerido mejoras para tu anuncio.",
      "item": "Ver sugerencia"
    },
    "bonificationBadge": "A mejorar",
    "bonificationBadge2": "Calidad",
    "numComments_one": "1 comentario",
    "numComments_other": "{{count}} comentarios",
    "hasAcceptedLoan": "ha prestado el objeto",
    "hasAcceptedLoanAgo": "ha prestado el objeto hace {{ago}}",
    "addAddressPrompt": {
      "button": "Agregar un barrio",
      "text": "En la oficina, en la escuela, en la cabaña o en casa de tus padres: si vas frecuentemente, vale la pena ampliar tu búsqueda.",
      "title": "Agrega una dirección"
    },
    "addPhoneNumberPrompt": {
      "banner": {
        "button": "Agregar mi número de teléfono",
        "text": "Agregar <strong>tu número de teléfono</strong> ayuda a los miembros a contactarte más fácilmente para organizar préstamos.",
        "title": "Tu perfil está completo al {{percent}}%"
      },
      "bottom-sheet": {
        "button": "Agregar mi número de teléfono",
        "text": "Agregar <strong>mi número de teléfono</strong> ayuda a los miembros a contactarme más fácilmente para organizar préstamos.",
        "title": "Mi perfil está completo al {{percent}}%"
      }
    },
    "addressAddedToast": {
      "text": "Para modificarlo o agregar otros, ve a Perfil > Mis clubs",
      "title": "Nuevo club creado"
    },
    "allCategories": "Todas",
    "peopleSearch": {
      "title": "Personas",
      "empty": "Ningún miembro coincide con esta búsqueda.",
      "viewAll": "Ver todo",
      "subtitle": "{{count}} miembro encontrado cerca de ti",
      "subtitle_other": "{{count}} miembros encontrados cerca de ti"
    },
    "filters": {
      "all": "Todas",
      "name": "Filtros"
    },
    "guest": {
      "locationHint": "Indica tu ubicación para ver los objetos disponibles cerca de ti.",
      "addressError": "No pudimos encontrar esa dirección o código postal.",
      "apply": "Aplicar",
      "bannerCta": "Obtener la app",
      "bannerText": "La forma más rápida de añadir equipo a tu perfil.",
      "bannerTitle": "Publica tus objetos en un instante con la aplicación móvil",
      "categories": "Categorías",
      "distance": "En un radio de {{distance}} km",
      "distanceTitle": "En un radio de:",
      "locating": "Buscando tu posición…",
      "location": "Ubicación",
      "locationError": "No pudimos acceder a tu ubicación. La ubicación predeterminada sigue seleccionada.",
      "locationTitle": "Ubicación",
      "maximumDistance": "Máximo ({{distance}} km)",
      "mobileBannerTitle": "Abrir con la aplicación móvil de {{appName}}",
      "myPosition": "Mi ubicación",
      "myPositionHint": "Descubre ofertas cercanas",
      "postalCode": "Dirección o código postal",
      "reset": "Restablecer",
      "tags": "Etiquetas"
    },
    "banner": {
      "halloween": {
        "title": "¡Abracadabra!",
        "text": "¡Propón tus disfraces con un solo clic ☞",
        "button": "Compártelos"
      },
      "xmas": {
        "text": "¡Se acercan las fiestas! Ayuda a tus vecinos a encontrar estos objetos tan solicitados.",
        "button": "Ver sugerencias"
      }
    },
    "canOffer": "Puedo prestar",
    "createYourNeed": "Agrega tu necesidad",
    "createYourOffer": "Agrega tu oferta",
    "dateRange": "Del {{start}} al {{end}}",
    "disconnected": {
      "text": "Crea tu cuenta o inicia sesión para ver las ofertas cerca de ti.",
      "buttonSignUp": "Crear mi cuenta",
      "buttonLogIn": "Ya tengo una cuenta",
      "buttonCode": "¿Tienes un código de invitación?"
    },
    "empty": {
      "offer": {
        "firstLine": "¡Comienza tu aventura aquí!",
        "primaryButtonText": "Crea una primera oferta",
        "secondLine": "Los miembros podrán verla y enviarte una solicitud para tomarla prestada."
      },
      "request": {
        "firstLine": "¿No encuentras lo que buscas?",
        "primaryButtonText": "¡Publica una necesidad!",
        "secondLine": "Los miembros pueden ayudarte a encontrar lo que buscas."
      },
      "invite": {
        "firstLine": "¡Comienza tu aventura aquí!",
        "primaryButtonText": "Invita a tus vecinos",
        "secondLine": "Invita a tus vecinos o publica una oferta en tu barrio."
      },
      "nothing": {
        "firstLine": "No hay anuncios por el momento.",
        "secondLine": "¡No debería tardar!"
      },
      "nothingServicesOnly": {
        "firstLine": "Nada que recoger por el momento.",
        "secondLine": "¡Mantén los ojos abiertos: las solicitudes llegan con las estaciones!"
      }
    },
    "filter": {
      "neighborhoodClubCheckbox": "<strong>Club del barrio</strong>{{suffix}}",
      "neighborhoodClub": "Club del barrio"
    },
    "found": "¡Encontrado!",
    "groupingMembers": "{{count}} miembros",
    "groupingMembersMany": "{{count}}+ miembros",
    "headline": "Nuevo",
    "inviteOthersPrompt": {
      "title": "¡Ayúdanos a hacer crecer la comunidad en tu barrio!",
      "description": "Tu barrio parece tener pocos miembros cerca, ¡pero tú puedes cambiar eso!",
      "ctaButton": "Invita a tus vecinos"
    },
    "levelUpModal": {
      "primaryButtonText": "Ver mi impacto",
      "secondaryButtonText": "Cerrar",
      "text": "Has aumentado tu impacto publicando tu primera oferta. Ahora accedes a un nivel superior: <strong>Colaborador</strong>.",
      "title": "¡Bravo!"
    },
    "moreResultsWithoutDistanceFilter": "Buscar más lejos de <strong>{{distance}}</strong>",
    "nearYou": "Nuevas ofertas",
    "needLogin": {
      "firstLine": "¡Comienza tu aventura aquí!",
      "primaryButtonText": "Iniciar sesión",
      "secondLine": "Inicia sesión para ver los objetos disponibles en tu barrio."
    },
    "needsAppUpdateTitle": "Actualización requerida",
    "needsAppUpdateText": "Para disfrutar de las últimas funcionalidades, debes actualizar la aplicación usando el App Store de Apple o Google Play Store.",
    "needsAppUpdateButtonTextIOS": "Abrir el App Store",
    "needsAppUpdateButtonTextAndroid": "Abrir el Play Store",
    "neighborOffer": "Oferta de un miembro",
    "neighborRequest": "Necesidad de un miembro",
    "noDateRange": "Fechas flexibles",
    "flexibleLabel": "(flexibles)",
    "new": "Nuevo",
    "nearby": "Cerca de ti",
    "noResults": {
      "firstLine": "Los miembros aún no han publicado objetos aquí.",
      "primaryButtonText": "Publicar",
      "secondLine": "¡Sé el primero en hacerlo!"
    },
    "numResults": {
      "default_zero": "No se encontraron elementos",
      "default_one": "{{count}} elemento encontrado",
      "default": "{{count}} elementos encontrados",
      "offer_zero": "Objetos para prestar",
      "offer_one": "{{count}} objeto para prestar",
      "offer": "{{count}} objetos para prestar",
      "request_zero": "Necesidades",
      "request_one": "{{count}} necesidad",
      "request": "{{count}} necesidades",
      "publicDonations_zero": "Donaciones ofrecidas",
      "publicDonations_one": "{{count}} donación ofrecida",
      "publicDonations": "{{count}} donaciones ofrecidas"
    },
    "offeredBy": "Prestado por {{firstName}} {{lastName}}",
    "postNeedPrompt": {
      "afterResults": {
        "button": "Publicar una necesidad",
        "text": "¡Pregunta a tu comunidad!\n<strong>1 de cada 3 necesidades</strong> se cubre en menos de <strong>24 horas</strong>.",
        "title": "🥳"
      },
      "noResults": {
        "button": "Publicar una necesidad",
        "text": "¡Pregunta a tu comunidad!\n<strong>1 de cada 3 necesidades</strong> se cubre en menos de <strong>24 horas</strong>.",
        "title": "🥳"
      }
    },
    "searchAssistant": {
      "title": "¡Podemos buscar por ti!",
      "body": "¿Quieres que nuestro asistente inteligente contacte a prestamistas que puedan tener <strong>{{itemName}}</strong>?",
      "bodyNote": "Podrás ajustar los detalles de la búsqueda justo después.",
      "dismiss": "Ahora no",
      "confirm": "Sí, iniciar la búsqueda",
      "close": "Cerrar"
    },
    "postOfferPrompt": {
      "first": {
        "button": "¡Publicar una oferta!",
        "text": "¡Publica 5 objetos y gana tu <strong>suscripción anual</strong>!",
        "title": "¡Gana tu suscripción!"
      },
      "firstAfter": {
        "button": "Invitar a mis vecinos",
        "text": "¡Contribuye a hacer crecer esta cadena de generosidad!",
        "title": "¡Invita a tus vecinos!"
      },
      "second": {
        "button": "¡Publicar una oferta!",
        "text": "Con la oferta múltiple, publica más rápido que el rayo.",
        "title": "Publicar en 10 segundos"
      },
      "third": {
        "button": "Publier un besoin !",
        "text": "Les membres ont souvent plus d'objets à prêter que ce qui est affiché. Demande, on ne sait jamais.",
        "title": "Demande à tes voisins"
      }
    },
    "promoDragonText": "<strong>Promoción</strong> «En el ojo del dragón». Disfruta de una <strong>suscripción anual</strong> a 30 $ en lugar de 60 $.",
    "promoDragonText2": "⌛ Hasta el 24 de abril de 2024 a las 23:59",
    "promoDragonButtonText": "Aprovechar el 50 % de descuento (30 $)",
    "promoFreeSub": {
      "defricheur": {
        "text": "⏳ Solo quedan {{numDays}} días para aprovechar tu prueba gratuita. ¡Publica ofertas para ganar tu suscripción!",
        "text1": "⏳ Último día para aprovechar tu prueba gratuita. ¡Publica ofertas para ganar tu suscripción!",
        "button": "¡Ganar mi suscripción anual!"
      },
      "trial": {
        "text": "⏳ Solo quedan {{numDays}} días para aprovechar tu prueba gratuita. ¡Descubre nuestra oferta y obtén tu suscripción gratuita!",
        "text1": "⏳ Último día para aprovechar tu período de prueba. ¡Obtén tu suscripción gratuita con nuestra oferta especial!",
        "button": "¡Aprovechar la oferta!"
      }
    },
    "quickOffer": {
      "text": "¡Publica en 10 segundos!",
      "title": "Publicación rápida"
    },
    "partialSearchBar": {
      "placeholder": "Buscar en esta lista",
      "empty": "Ningún elemento coincide con esta búsqueda."
    },
    "sortTitle": "Ordenar por",
    "sortBy": {
      "distance": "Distancia",
      "date": "Novedades",
      "startDate": "Fecha",
      "popularity": "Popularidad",
      "random": "Aleatorio",
      "relevance": "Relevancia",
      "urgency": "Urgencia"
    },
    "subtype": {
      "object": "Objeto",
      "service": "Servicio"
    },
    "tabs": {
      "offer": "Ofertas",
      "people": "Personas",
      "request": "Necesidades",
      "donations": "Donaciones",
      "services": "Servicios"
    },
    "topListings": {
      "title": "Ofertas populares",
      "viewMore": {
        "details": "Ver todas las ofertas clasificadas por popularidad.",
        "cta": "¡Vamos!"
      }
    },
    "featured": {
      "title": "Destacado"
    },
    "recommended": {
      "title": "Recomendado para ti"
    },
    "urgent": "Urgente",
    "dateTag": {
      "from": "A partir del {{date}}",
      "until": "Hasta el {{date}}",
      "range": "Del {{start}} al {{end}}",
      "remaining_one": "Queda {{count}} día",
      "remaining_other": "Quedan {{count}} días",
      "urgent": "Urgente",
      "urgentRemaining_one": "Urgente · queda {{count}} día",
      "urgentRemaining_other": "Urgente · quedan {{count}} días"
    },
    "mode": {
      "lend": "Préstamo",
      "sell": "Venta",
      "give": "Donación"
    },
    "requestMode": {
      "lend": "Préstamo",
      "sell": "Compra",
      "give": "Donación"
    },
    "activeSearch": "Búsqueda activa",
    "dismissAction": "Ocultar",
    "dismissAccessibilityHint": "Oculta esta solicitud de tu lista",
    "undismissAction": "Restaurar",
    "dismissToast": {
      "title": "Necesidad oculta",
      "undo": "Deshacer"
    },
    "focused-user-listings": "Mostrando los anuncios de {{userName}}",
    "user-display-name-fallback": "Este miembro",
    "userMetaModal": {
      "polymtl_segment_user_type": {
        "prompt": "¡Ayúdanos a entender mejor el uso de la aplicación en Poly! Soy…",
        "options": {
          "student": "Estudiante",
          "staff": "Profesor/a o miembro del personal"
        }
      }
    }
  },
  "api-errors": {
    "Municipal activation code already active": "Este código ya está activo en tu cuenta.",
    "Social sign-in failed": "No se pudo iniciar sesión con este servicio. Inténtalo de nuevo o inicia sesión con tu correo electrónico y contraseña. Si no tienes contraseña o la has olvidado, utiliza la opción para restablecerla en el formulario de inicio de sesión.",
    "generic-title": "Error de conexión a la API",
    "An account cannot move into or out of the United States by changing its address.": "Una vez creada la cuenta, su dirección no puede trasladarse hacia o desde Estados Unidos.",
    "The last admin cannot leave or be removed before another member is promoted.": "Debes nombrar a otro administrador antes de poder salir de esta conversación.",
    "Attempt limit exceeded, please try after some time.": "Demasiados intentos; por favor inténtalo de nuevo más tarde.",
    "An account already exists for this email address. Please use the log in form.": "Ya existe una cuenta con esta dirección de correo electrónico. Por favor utiliza el formulario de inicio de sesión.",
    "Can't delete listing that has accepted loan.": {
      "offer": "No puedes eliminar una oferta cuyo préstamo está actualmente en curso o atrasado. Debes cancelar este préstamo o confirmar la devolución del objeto.",
      "request": "No puedes eliminar una necesidad cuyo préstamo está actualmente en curso o atrasado. Primero debe confirmarse la devolución por parte del propietario."
    },
    "Date is required": "Por favor elige una fecha",
    "Failed to apply invite code.": "Error con el código de invitación.",
    "Incorrect email or password": "El correo electrónico o la contraseña no son válidos",
    "Network Error": "Red no disponible",
    "Outside geofence": "No es posible usar este código fuera de la zona autorizada.",
    "Please complete your profile before creating a listing.": "Por favor completa tu perfil antes de crear un anuncio.",
    "Please enter a valid activation code.": "Por favor ingresa un código de invitación válido.",
    "No user exists with the specified email.": "Ninguna cuenta utiliza esta dirección de correo electrónico.",
    "The provided address was not found.": "La dirección especificada no fue encontrada.",
    "The provided password is incorrect": "La contraseña (actual) es incorrecta.",
    "You already created a listing for this item in this category": "Ya publicaste una oferta con este nombre en esta categoría.",
    "You are not authorized to use this code": "No estás autorizado a usar este código.",
    "You need a valid license to post a need.": "Debes tener una licencia válida para publicar una necesidad."
  },
  "app_update": {
    "button_cancel": "Cancelar",
    "button_ok": "Aceptar",
    "question": "¿Deseas actualizar?",
    "title": "Hay una nueva actualización disponible."
  },
  "billboard": {
    "tabBarLabel": "Inicio",
    "title": "Trouvez facilement",
    "title_2": "l’objet qu’il vous faut!",
    "unauthenticatedTitle": "Crée un compte ou connecte-toi",
    "unauthenticatedTitle_2": "pour voir les offres près de chez toi.",
    "invitationCode": "Tu as un code d'invitation ?",
    "buttonSignUp": "Créer mon compte",
    "buttonLogIn": "J'ai déjà un compte",
    "requestTitle": "Besoins",
    "publishOfferButton": "Publier une offre",
    "publishNeedButton": "Ajouter un besoin",
    "viewAllCatalogButton": "Voir tout le catalogue",
    "browseByCategories": "Parcourir par catégories",
    "needsTitle": "Ces membres ont besoin d'aide"
  },
  "calendar": {
    "disabled": "No puedes modificar las fechas de una necesidad cuyo préstamo está actualmente en curso o atrasado."
  },
  "calendar-settings": {
    "calendarModal": {
      "primaryButtonText": "Ir a Configuración",
      "secondaryButtonText": "Cancelar",
      "text": "Para permitirnos agregar eventos en el calendario de tu teléfono, ve a la configuración de tu dispositivo y autoriza el acceso completo al calendario.",
      "title": "Autorizar el calendario"
    },
    "title": "Agregar al calendario"
  },
  "change-password": {
    "newPasswordConfirmationFieldLabel": "Confirmación de la nueva contraseña",
    "newPasswordConfirmationFieldPlaceholder": "",
    "newPasswordFieldLabel": "Nueva contraseña",
    "newPasswordFieldPlaceholder": "",
    "passwordFieldLabel": "Contraseña actual",
    "passwordFieldPlaceholder": "",
    "primaryButtonText": "Guardar",
    "title": "Cambiar mi contraseña"
  },
  "chooseUserType": {
    "title": "¡Bienvenido!",
    "alreadyHaveAccount": "¿Ya tienes una cuenta?",
    "clickHere": "Iniciar sesión",
    "loggedIn": "¡Has iniciado sesión!",
    "loggedInRedirect": "Serás redirigido automáticamente.",
    "instructionsLoggedIn": "Elige tu perfil a continuación para finalizar tu cuenta:",
    "instructions": "O elige tu perfil a continuación:",
    "type": {
      "desc": {
        "pro": "Acceso reservado a granjas, formadores y organismos involucrados en la horticultura de proximidad.\n\n<strong>Se requiere código de invitación.</strong>",
        "public": "Para los ciudadanos que desean participar."
      },
      "button": {
        "pro": "Profesionales",
        "public": "Público general"
      }
    }
  },
  "closestListingsModal": {
    "breadcrumb": {
      "first": "Tus intereses",
      "second": "Tu selección",
      "third": "Enviar"
    },
    "title": "¡Rompe el hielo y haz tu primer préstamo!",
    "instructions": "Selecciona las categorías que te interesan y te propondremos grandes hallazgos.",
    "buttonText": "Continuar"
  },
  "closestListingsChoose": {
    "instructions": "Elige el objeto que deseas tomar prestado, nosotros nos encargamos del resto.",
    "buttonText": "Verificar disponibilidades",
    "messageToSend": "Hola {{name}},\nEstoy interesado/a en tu oferta. ¿Tienes disponibilidad próximamente?",
    "chatToast": "Saludamos al prestador por ti. ¡Ahora propón fechas de préstamo!"
  },
  "collection": {
    "title": "Colección: {{name}}",
    "iHaveThis": "¡Tengo esto!",
    "iNeedThis": "Busco esto",
    "itemHasListingsIStillNeedThisPrompt": "Si las ofertas anteriores no te convienen, siempre puedes publicar una necesidad con este botón.",
    "moreMembers": "+ {{num}} más",
    "nobodyOfferedYet": "⭐️ ¡Sé el primero en ofrecerlo!",
    "postNeedPrompt": {
      "button": "¡Publicar una necesidad!",
      "text": "Los miembros pueden ayudarte a encontrar lo que buscas.",
      "title": "¿Necesidad especial?"
    },
    "subscribe": "Suscribirme",
    "subscriptionSuccess": "Estás suscrito. Recibirás una notificación cuando un miembro publique una oferta para este objeto.",
    "successfullyAddedNeed": "Necesidad publicada",
    "successfullyAddedOffer": "Oferta publicada",
    "successfullyAddedOfferNow": "¡Genial!",
    "unsubscribe": "Suscrito",
    "unsubscriptionSuccess": "Te has dado de baja. Ya no recibirás notificaciones para este objeto."
  },
  "common": {
    "perishable": "Perecedero",
    "goBack": "Volver",
    "ambassador": "<color>Embajador·a</color>",
    "ambassadorAndSuper": "Super Compartidor |\n<color>Embajador·a</color>",
    "appName": "Partage Club",
    "appDownloadPrompt": {
      "title": "Descarga la aplicación",
      "guest": "¿Te gusta lo que ves? Lleva Partage Club en tu teléfono y recibe nuevas disponibilidades cerca de ti",
      "dateProposal": "Descarga la aplicación para recibir una notificación cuando {{firstName}} responda",
      "listingPublished": "¡Descarga la aplicación para publicar ofertas y necesidades aún más fácilmente!",
      "thisMember": "este miembro",
      "qrCodeAccessibilityLabel": "Código QR para descargar la aplicación Partage Club",
      "openStore": "Abrir {{store}}"
    },
    "applicationError": {
      "firstLine": "¡Ups, esto no estaba previsto! Estamos trabajando para resolver este problema.",
      "secondLine": "Aquí hay algunas cosas que puedes intentar:\n\n• Espera unos segundos, luego usa el botón 'Reintentar' a continuación.\n\n• Cierra la aplicación completamente y vuelve a abrirla.\n\n• Ve a la pantalla de Perfil, cierra sesión y vuelve a iniciarla {{connectHow}}\n\n• Desinstala la aplicación de tu dispositivo y vuelve a instalarla.\n\n• Si nada de esto te ayuda, escríbenos lo antes posible a support@partage.club.",
      "connectHow": {
        "empty": "",
        "email": "con la dirección {{email}}",
        "loginWithApple": "con el botón 'Iniciar sesión con Apple'"
      },
      "primaryButtonText": "Reintentar"
    },
    "applyUpdateLabel": "Actualizar",
    "archived": "Archivada",
    "available": "Disponible",
    "back": "Volver",
    "cancel": "Cancelar",
    "cityRequiredError": "Por favor ingresa una ciudad.",
    "dateFormat_MMMd": "d MMM",
    "dateFormat_MMMMd": "d MMMM",
    "dateFormat_EEEEMMMMd": "EEEE, d 'de' MMMM",
    "dateFormat_MMMYYYY": "MMM yyyy",
    "dateFormat_MMMdYYYY": "d MMM yyyy",
    "dateFormat_MMMMdYYYY": "d MMMM yyyy",
    "deleted": "Eliminada",
    "deletedUser": "Usuario eliminado",
    "donation": {
      "label": "<strong>Donación</strong>",
      "lastDay": "<strong>Último día</strong>",
      "numDays_one": "<strong>1 día</strong> restante",
      "numDays": "<strong>{{count}} días</strong> restantes",
      "numMonths_one": "> <strong>1 mes</strong> restante",
      "numMonths": "> <strong>{{count}} meses</strong> restantes"
    },
    "expiredLoans": {
      "firstParagraph": "<strong>{{item}}</strong> de <strong>{{firstName}} {{lastName}}</strong> debía devolverse el {{date}}.",
      "secondParagraph": "Confirma la devolución o modifica las fechas de préstamo haciendo clic aquí.",
      "sectionTitle_one": "{{count}} préstamo atrasado",
      "sectionTitle": "{{count}} préstamos atrasados",
      "title": "¿Has devuelto el objeto prestado?"
    },
    "expiredService": {
      "firstParagraph": "<strong>{{firstName}} {{lastName}}</strong> debía ayudarte con <strong>{{item}}</strong> el {{date}}.",
      "secondParagraph": "Confirma que el servicio fue realizado o modifica las fechas haciendo clic aquí.",
      "sectionTitle_one": "{{count}} servicio atrasado",
      "sectionTitle": "{{count}} servicios atrasados",
      "title": "¿Se realizó el servicio?"
    },
    "expiredDonation": {
      "firstParagraph": "Debías recoger <strong>{{item}}</strong> el {{date}} en casa de <strong>{{firstName}} {{lastName}}</strong>.",
      "secondParagraph": "Confirma que la recogida fue realizada o modifica la fecha haciendo clic aquí.",
      "sectionTitle_one": "{{count}} donación atrasada",
      "sectionTitle": "{{count}} donaciones atrasadas",
      "title": "¿Se recogió la donación?"
    },
    "expiredSale": {
      "firstParagraph": "La venta de <strong>{{item}}</strong> con <strong>{{firstName}} {{lastName}}</strong> estaba prevista para el {{date}}.",
      "secondParagraph": "Confirma la venta o modifica la fecha de recogida haciendo clic aquí.",
      "sectionTitle_one": "{{count}} venta atrasada",
      "sectionTitle": "{{count}} ventas atrasadas",
      "title": "¿Se completó la venta?"
    },
    "expiredItems": {
      "sectionTitle_one": "{{count}} elemento atrasado",
      "sectionTitle": "{{count}} elementos atrasados"
    },
    "favourites": "Favoritos",
    "fieldErrorDefault": "Este campo no es válido",
    "fieldErrorLength": "Este campo debe contener exactamente {{length}} caracteres",
    "fieldErrorPatternEmail": "Este campo debe ser una dirección de correo electrónico válida",
    "fieldErrorRequired": "Este campo es obligatorio",
    "fieldErrorTooLong": "Este campo debe contener como máximo {{max}} caracteres",
    "fieldErrorTooShort": "Este campo debe contener al menos {{min}} caracteres",
    "genericError": "Se produjo un error",
    "lastActiveAgo": "Activo/a hace {{ago}}",
    "lastActiveAgoShort": "hace {{ago}}",
    "lateSince": "Con {{days}} día(s) de retraso",
    "loaned": "Prestado",
    "manageOffer": "Gestionar esta oferta",
    "mandatory": "obligatorio",
    "noResults": "Sin resultados",
    "noResultsFor": "Sin resultados para:\n<strong>{{query}}</strong>",
    "afterResultsFor": "¿No encuentras lo que buscas?",
    "offer": "Préstamo",
    "optional": "opcional",
    "optionals": "opcionales",
    "optionale": "opcional",
    "optionales": "opcionales",
    "or": "o",
    "otherCountries": "Todos los países",
    "passwordErrorDigit": "Este campo debe contener al menos un número",
    "passwordErrorLowercase": "Este campo debe contener al menos una letra minúscula",
    "passwordErrorMatching": "Este campo debe ser igual a tu contraseña",
    "passwordErrorSpecial": "Este campo debe contener al menos un carácter especial",
    "passwordErrorUppercase": "Este campo debe contener al menos una letra mayúscula",
    "postalCodeRequiredError": "Por favor ingresa un código postal",
    "postedOn": "Publicado el {{date}}",
    "request": "Necesidad",
    "search": "Búsqueda",
    "searchPlaceholder": "Buscar anuncios, usuarios y objetos...",
    "serviceCategories": {
      "general_help_outside_bf": {
        "name": "Ayuda exterior a domicilio",
        "desc": "Ejemplo: rellenar el líquido limpiaparabrisas del auto, inflar neumáticos, sacar los contenedores…"
      },
      "urgency_help_bf": {
        "name": "Ayuda de urgencia",
        "desc": "Ejemplo: ayudar a encontrar un veterinario para un animal herido, ayudar a encontrar una farmacia de guardia…"
      },
      "companionship_bf": {
        "name": "Compañía y ocio",
        "desc": "Ejemplo: practicar un idioma, compañero/a de paseos…"
      },
      "know_how_bf": {
        "name": "Transferencia de conocimientos",
        "desc": "Ejemplo: consejos de jardinería, reparaciones…"
      },
      "landscaping_bf": {
        "name": "Mantenimiento del terreno",
        "desc": "Ejemplo: rastrillar, preparar el terreno, la piscina, sacar los muebles de jardín…"
      },
      "public_tessier": {
        "name": "Necesidad de servicio",
        "desc": ""
      }
    },
    "streetRequiredError": "Por favor ingresa una dirección",
    "suggested": "sugerido",
    "suggestede": "sugerida",
    "superPartageur": "Super Compartidor",
    "unavailable": "No disponible",
    "updateAvailable": "¡Hola! Tenemos una actualización para ti 🥳 🎉.",
    "version": {
      "copied": "Versión copiada",
      "update_label": "Actualización",
      "version_label": "Versión"
    },
    "year": "Año",
    "x$": "{{amount}} $"
  },
  "contact-information": {
    "title": "Tu código postal",
    "prompt": "¡Agrega tu código postal para descubrir todo lo que puedes tomar prestado cerca de ti!",
    "mapMarkerPrompt": "Define la ubicación de tu domicilio colocando el marcador en el mapa.",
    "mapStatsPrompt": "Cambia el radio de búsqueda para visualizar el número de miembros y objetos disponibles para tomar prestado cerca de ti.",
    "invalidAddressError": "Código postal inválido. Por favor inténtalo de nuevo.",
    "changePostalCode": "Cambiar mi código postal"
  },
  "help": {
    "title": "¿Cómo funciona?",
    "roleBorrow": "Tomo prestado",
    "roleLend": "Presto",
    "assistanceQuestion": "¿Necesitas más ayuda?",
    "visitHelpCenter": "Visitar el centro de ayuda",
    "guestCta": {
      "title": "¿Listo para empezar?",
      "text": "Únete a tu vecindario y descubre todo lo que puedes pedir prestado cerca de ti.",
      "button": "Crear mi cuenta"
    },
    "compensation": {
      "title": "Compensación por objetos",
      "text": "Estás cubierto en los objetos que prestas y tomas prestados",
      "subscribeText": "Con la suscripción, Partage Club te compensa hasta 300 $ en los objetos que prestas y tomas prestados.",
      "subscribeCta": "Suscribirme",
      "learnMore": "Saber más"
    },
    "borrower": {
      "steps": {
        "catalog": {
          "title": "Explora el catálogo",
          "text": "Busca un objeto en el catálogo o publica una necesidad visible para tus vecinos",
          "exploreLink": "Explorar el catálogo",
          "needLink": "Publicar una necesidad"
        },
        "meeting": {
          "title": "Acordar un encuentro",
          "text": "Propón y confirma las fechas de préstamo y recogida con tu vecino"
        },
        "pickup": {
          "title": "Recoge el objeto y úsalo",
          "text": "Reúnete con tu vecino en su domicilio o en un lugar público seguro. <strong>¡Sin intercambio de dinero, es gratis!</strong>"
        },
        "return": {
          "title": "Devuelve el objeto",
          "text": "Devuelve el objeto en buen estado a su propietario y comparte tu experiencia"
        }
      }
    },
    "lender": {
      "steps": {
        "photo": {
          "title": "Toma una foto del objeto",
          "text": "Toma algunas fotos que destaquen tu objeto"
        },
        "publish": {
          "title": "Publica una oferta",
          "text": "Añade detalles de uso sobre tu objeto y publica tu oferta. Si te falta tiempo, elige anuncios ya preparados por nosotros para objetos muy solicitados.",
          "offerLink": "Publicar una oferta específica",
          "suggestedLink": "Elegir entre los objetos sugeridos"
        },
        "share": {
          "title": "Comparte el objeto",
          "text": "Reúnete con tu vecino en tu domicilio o en un lugar público seguro para entregarle el objeto. <strong>¡Sin intercambio de dinero, es gratis!</strong>"
        },
        "return": {
          "title": "Recupera el objeto",
          "text": "Recupera el objeto al final del préstamo y comparte tu experiencia. <strong>Menos del 1%</strong> de los objetos prestados se dañan. Y a menudo vuelven aún más limpios. Es mágico."
        }
      }
    }
  },
  "contact-us": {
    "title": "Ayuda",
    "firstParagraph": "El servicio a los miembros del Partage Club está disponible por correo electrónico y mensajería. Te responderemos a la brevedad posible.",
    "chatCTALabel": "Mensajería",
    "transportCTALabel": "Asistencia de transporte",
    "emailCTALabel": "Correo electrónico",
    "faqCTALabel": "Preguntas frecuentes (FAQ)",
    "bugReportCTALabel": "Reportar un problema",
    "suggestionCTALabel": "Sugerencia de funcionalidad",
    "faqLink": "https://www.partage.club/fr-ca/about/frequently-asked-questions",
    "chatPrompt": {
      "bugReport": "¡Hola {{name}} 😊!\n\nGracias por explicarnos qué está fallando.",
      "suggestion": "¡Hola {{name}} 😊!\n\nSiempre estamos abiertos a sugerencias. Gracias por ayudarnos a mejorar nuestro servicio.\n\n¡Gracias!"
    }
  },
  "choose-sharer-type": {
    "title": "Motivaciones",
    "subtitle": "Con {{appName}},\npiensas más en...",
    "borrower": "Tomar prestado",
    "lender": "Prestar",
    "both": "Ambos",
    "borrowerEmoji": "🙋",
    "lenderEmoji": "🤝",
    "bothEmoji": "🔁"
  },
  "credentials": {
    "emailFieldLabel": "Dirección de correo electrónico",
    "emailFieldPlaceholder": "Dirección de correo electrónico",
    "errors": {
      "resource-already-exists": "El correo ingresado ya está asociado a una cuenta"
    },
    "activationCodeFieldLabel": "Código de invitación",
    "activationCodeFieldPlaceholder": "Ingresa el código que te fue compartido",
    "inviteCodeFieldLabel": "Código de invitación (opcional)",
    "inviteCodeFieldPlaceholder": "ej: XYZ1234",
    "passwordConfirmationFieldLabel": "Confirmación de contraseña",
    "passwordConfirmationFieldPlaceholder": "Contraseña",
    "passwordFieldLabel": "Contraseña",
    "passwordFieldPlaceholder": "Contraseña",
    "title": "Información de cuenta",
    "loadingPleaseWait": "Cargando, por favor espera...",
    "validate": "Validar"
  },
  "email-verification": {
    "codeFieldLabel": "Código de confirmación",
    "codeFieldPlaceholder": "ej: 123456",
    "errors": {
      "invalid-code": "El código ingresado no es válido, por favor inténtalo de nuevo"
    },
    "subtitle": "Se ha enviado un correo electrónico con un código de seguridad. Por favor ingresa este código antes de continuar.",
    "title": "Validación del correo electrónico"
  },
  "favourites": {
    "empty": {
      "filtered": "Ningún favorito coincide con este filtro.",
      "firstLine": "¡Agrega tu primer favorito!",
      "primaryButtonText": "Explorar ofertas",
      "secondLine": "Tus favoritos aparecerán aquí"
    },
    "filters": {
      "all": "Todo"
    },
    "title": "Mis favoritos"
  },
  "forgot-password": {
    "emailFieldLabel": "Dirección de correo electrónico",
    "emailFieldPlaceholder": "Dirección de correo electrónico",
    "forgotPassword": {
      "close": "Cerrar recuperación de contraseña",
      "goBack": "Volver"
    },
    "primaryButtonText": "Restablecer mi contraseña",
    "subtitle": "Ingresa tu dirección de correo electrónico a continuación y te enviaremos un correo con las instrucciones para crear una nueva contraseña.",
    "title": "Recuperar tu contraseña"
  },
  "free-sub": {
    "billboardButtonText": "Ir al tablón de anuncios",
    "headerText": "Has publicado tu primera oferta.",
    "headerTextFiveOffers": "¡Has publicado 5 ofertas!",
    "headerTextNotYet": "¡Contribuyes a hacer crecer el catálogo del <strong>Partage Club</strong>!",
    "headerTextTutorial": "Ahora dominas el arte de compartir objetos.",
    "headerTitle": "¡Bravo!",
    "headerTitleNotYet": "¡Gracias!",
    "inviteButtonText": "Invitar a mis vecinos",
    "myImpactLevelButtonText": "Ver mi impacto",
    "createOfferButtonText": "Publicar otra oferta",
    "spreadTheLoveText": "¡Cuéntaselo a tus vecinos para que ellos también puedan aprovechar la oferta especial!",
    "subHeaderTextTutorial": "Gracias por publicar un objeto. Nos complace anunciarte que tu suscripción anual gratuita ya está activada.",
    "subscriptionActivatedText": {
      "CAD": "<strong>Suscripción anual activada</strong> (valor de 60 $)",
      "EUR": "<strong>Suscripción anual activada</strong> (valor de 72 €)",
      "USD": "<strong>Suscripción anual activada</strong> (valor de 72 USD)"
    },
    "subscriptionNotYetActivatedText": "<strong>¡Sigue publicando ofertas para ganar tu suscripción!</strong>",
    "userNowContributorText": "Accedes a un nivel superior: <strong>Colaborador</strong>. Al publicar tu primera oferta, has aumentado tu impacto."
  },
  "group-members": {
    "headerTitle": "Membres",
    "Members": "Miembros",
    "filter": {
      "apply": "Aplicar",
      "neighborhoodClub": "Club del barrio",
      "title": "Filtro"
    }
  },
  "grouped-listing": {
    "concierge": {
      "title": "Una solicitud. Nosotros preguntamos.",
      "description": "Publica una solicitud en tu comunidad. Contactaremos a prestadores cercanos por ti.",
      "action": "Enviar una solicitud",
      "publishing": "Publicando tu solicitud…",
      "successTitle": "¡Tu solicitud está publicada!",
      "successDescription": "Contactaremos a posibles prestadores. Sigue sus respuestas en tu solicitud.",
      "viewRequest": "Ver mi solicitud",
      "retry": "Reintentar",
      "message": "¡Hola! Quisiera pedir prestado {{item}}. ¿Podrías prestármelo? Podemos acordar las fechas juntos. ¡Gracias!",
      "queued_one": "Envío en {{count}} segundo…",
      "queued_other": "Envío en {{count}} segundos…",
      "undo": "Deshacer envío",
      "undone": "No se publicó nada ni se contactó a ningún prestador.",
      "pausedTitle": "Contactos en pausa",
      "pausedDescription": "Tu solicitud sigue visible en tu comunidad. Reanuda cuando quieras.",
      "activeDescription": "Tu solicitud es visible en tu comunidad. Contactaremos a prestadores cercanos por ti.",
      "waitingDescription": "Tu solicitud es visible en tu comunidad. Sigue las respuestas en tu solicitud.",
      "found": "Un prestador puede ayudarte",
      "foundDescription": "Abre tu solicitud para hablar con el prestador.",
      "contacted_zero": "Aún no se ha contactado a ningún prestador.",
      "contacted_one": "{{count}} prestador contactado.",
      "contacted_other": "{{count}} prestadores contactados."
    },
    "headerSection": {
      "numOffers": "Número de prestadores: {{numOffers}}",
      "lenders_one": "{{number}} prestador cercano",
      "lenders_other": "{{number}} prestadores cercanos",
      "available": "Disponible cerca"
    },
    "listHeader": "Contacta directamente a un/a prestador/a",
    "listHeaderLegacy": "Elige un/a prestador/a:"
  },
  "guidelines": {
    "firstParagraph": "<strong>Ser siempre respetuoso/a</strong> con los miembros, tanto virtualmente como en persona.",
    "secondParagraph": "<strong>Devolver los objetos prestados</strong> en el mismo estado en que fueron prestados. Si ocurre algún daño, recomendamos al prestatario reparar o reemplazar el objeto en cuestión.",
    "secondParagraphInsured": "<strong>Devolver los objetos prestados</strong> en el mismo estado en que fueron prestados. Con tu suscripción, si ocurre algún daño a los objetos que prestas o tomas prestados por un valor de 25 $ o más, <strong>nos comprometemos a indemnizarte hasta 300 $ al año</strong>. No dudes en contactarnos a través de la mensajería de la app o por correo electrónico a info@partage.club.",
    "secondParagraphPublic": "<strong>Respetar las fechas y horarios de encuentro</strong> acordados con los miembros.",
    "thirdParagraph": "<strong>Respetar las fechas de devolución de los préstamos.</strong>",
    "thirdParagraphPublic": "<strong>Respetar las instrucciones</strong> de recogida de los miembros.",
    "fourthParagraph": "<strong>Ser generoso/a</strong> respondiendo proactivamente a las necesidades de los miembros.",
    "fifthParagraph": "No utilizar el Partage Club para alquilar o vender objetos.",
    "conditionsCheckboxText": "Acepto los <Link1>términos de uso</Link1> y la <Link2>política de privacidad</Link2>.",
    "guidelinesCheckboxText": "Me comprometo a respetar las reglas de oro.",
    "primaryButtonText": "Guardar",
    "startingKit": "Quiero recibir el <startingKitLink>Kit de inicio</startingKitLink> por correo para reclutar a mis vecinos (opcional)",
    "title": "Las reglas de oro"
  },
  "image-picker": {
    "add": "Agregar",
    "camera": "Cámara",
    "cancel": "Cancelar",
    "fileTooLarge": {
      "title": "Archivo demasiado grande",
      "text": "Elige un archivo de menos de {{max}} MB."
    },
    "library": "Galería de fotos",
    "manage": "Administrar fotos",
    "save": "Guardar"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Se unió al Partage Club",
        "title": "Explorador"
      },
      "1": {
        "button": "Publicar",
        "description": "Publica una oferta",
        "description-completed": "Publicó una oferta",
        "title": "Colaborador"
      },
      "2": {
        "button": "Explorar",
        "description": "Realiza un intercambio (préstamo o toma prestado)",
        "description-completed": "Realizó un intercambio",
        "title": "Compartidor"
      },
      "3": {
        "button": "Explorar",
        "description": "Realiza 5 intercambios (préstamo o toma prestado)",
        "description-completed": "Realizó 5 intercambios",
        "title": "Super Compartidor"
      }
    }
  },
  "header": {
    "publishButton": "Publicar",
    "helpButtonAccessibilityLabel": "Ayuda sobre el proceso de intercambio"
  },
  "introModal": {
    "pageTitle": {
      "intro": "¡Bueno saberlo!",
      "b2c_paid": "Suscripción activada",
      "b2b_activated": "Suscripción activada",
      "newly_insured": "La Responsabilidad Partage Club",
      "offre_defricheur": "Oferta del Pionero",
      "custom": "Información"
    },
    "title": "¡Hola\n{{name}}!",
    "titleNewFeature": "¡Partage Club es responsable!",
    "codeFullWarning": "Todas las suscripciones ofrecidas por {{groupName}} han sido distribuidas, pero aún puedes aprovechar una oferta gratuita. →",
    "welcome": {
      "b2b": "<strong>¡Bienvenido al Club!</strong>\nGracias a {{groupName}}, tu suscripción es gratuita. 🎉 ¡Aprovecha para compartir de forma ilimitada con {{withWho}}!",
      "withWho": {
        "education": "los miembros de tu comunidad",
        "enterprise": "tus colegas y vecinos",
        "municipal": "tus vecinos",
        "municipal_closed": "tus vecinos",
        "realestate": "tus vecinos"
      },
      "trial": {
        "CAD": "<strong>¡Tu primer préstamo es gratis!\n</strong><padding/>¿Prestar tus objetos?\nGratis de por vida.\n<padding/><smaller>Después de tu crédito gratuito, suscríbete para seguir tomando prestado:\n<padding/><strong>• 60 $/año</strong>\n<padding/><underline>Ningún pago sin tu consentimiento.</underline></smaller>",
        "EUR": "<strong>¡Tu primer préstamo es gratis!\n</strong><padding/>¿Prestar tus objetos?\nGratis de por vida.\n<padding/><smaller>Después de tu crédito gratuito, suscríbete para seguir tomando prestado:\n<padding/><strong>• 72 €/año</strong>\n<padding/><underline>Ningún pago sin tu consentimiento.</underline></smaller>",
        "USD": "<strong>¡Tu primer préstamo es gratis!\n</strong><padding/>¿Prestar tus objetos?\nGratis de por vida.\n<padding/><smaller>Después de tu crédito gratuito, suscríbete para seguir tomando prestado:\n<padding/><strong>• 72 USD/año</strong>\n<padding/><underline>Ningún pago sin tu consentimiento.</underline></smaller>"
      },
      "regular": "<strong>¡Bienvenido al Club!</strong>\nComo miembro oficial del Partage Club, tu suscripción te da acceso a nuevas ventajas."
    },
    "insurable": {
      "insurance": {
        "trial": "Con tu suscripción, si ocurre algún daño a los objetos que prestas o tomas prestados por un valor de 25 $ o más, <strong>nos comprometemos a indemnizarte hasta 300 $ al año</strong>.",
        "regular": "Gracias a tu suscripción, si ocurre algún daño a tus objetos por un valor de 25 $ o más durante un préstamo, <strong>nos comprometemos a indemnizarte hasta 300 $ al año</strong>."
      },
      "zeroOnePercent": "Tranquilo/a, menos del 0,1 % de los intercambios generan algún daño. ¡Es completamente normal que un objeto muestre signos de desgaste cuando es compartido y usado por varias personas!"
    },
    "notInsurable": {
      "savings": "<strong>¡Tomar prestado es mucho más económico que comprar!</strong> Echa un vistazo a la aplicación antes de comprar, puede que te lleves una sorpresa.",
      "community": "<strong>Es la oportunidad perfecta para conocer a tus vecinos</strong> y dar un paso hacia un mundo más sostenible."
    },
    "cleaner": "E imagina… <strong>los objetos a menudo vuelven incluso más limpios que antes</strong>. ¡Es mágico!",
    "referralPromo": "<strong>¡Refiere a alguien y obtén un mes gratis!</strong>\nCada nueva referencia extiende tu suscripción un mes.\n\nEjemplo: 12 referencias = 12 meses gratis.",
    "offreDefricheur": "Hay pocos objetos en tu barrio. <strong>Suscripción anual gratuita para los 5 primeros</strong> que publiquen un objeto.",
    "borrow": "<strong>Ahora puedes tomar prestado</strong> de un amplio catálogo de objetos disponibles a dos pasos de tu casa.",
    "custom": {
      "support": "<strong>¿Un daño? ¿Un problema? Partage Club te garantiza atención a los miembros en todo momento.</strong>",
      "supportButtons": {
        "inAppMessaging": "Mensajería",
        "email": "Correo electrónico"
      }
    },
    "continueButton": "Siguiente →",
    "backButton": "← Anterior",
    "doneButton": "Entendido"
  },
  "insured": {
    "landing-page": {
      "title": "Responsabilidad Partage Club",
      "text": "Estás protegido en caso de daños"
    },
    "listing": {
      "title": "Comparte con total confianza.",
      "text": {
        "own": "Con tu suscripción, disfrutas de la Responsabilidad Partage Club en caso de daño a tus objetos.",
        "other": "Con su suscripción, {{name}} disfruta de la Responsabilidad Partage Club en caso de daño a sus objetos."
      }
    },
    "link": {
      "more_details": "Saber más"
    },
    "myPlan": {
      "title": "Partage Club es responsable",
      "text": "Al suscribirte, disfrutas de la Responsabilidad Partage Club si un objeto que prestas o tomas prestado resulta dañado."
    },
    "profile": {
      "title": "{{name}} disfruta de la <strong>Responsabilidad Partage Club</strong> en caso de <strong>daño</strong> a sus objetos."
    },
    "help": {
      "button": "Reportar un daño"
    },
    "details": {
      "title": "Responsabilidad Partage Club",
      "text": {
        "own": "Con tu suscripción, si ocurre algún daño a los objetos que prestas o tomas prestados por un valor de 25 $ o más, nos comprometemos a indemnizarte hasta <strong>300 $ al año</strong>.",
        "other": "Con su suscripción, si ocurre algún daño a los objetos que {{name}} te presta o te toma prestados por un valor de 25 $ o más, nos comprometemos a indemnizarle hasta <strong>300 $ al año</strong>."
      },
      "how": {
        "intro": "¿Cómo funciona?",
        "step1": "El prestador o el prestatario nos contacta a través de la mensajería de la app o por correo electrónico.",
        "step2": "Evaluamos la situación rápidamente.",
        "step3": "Si la solicitud es admisible, se indemniza al prestamista."
      },
      "link": "Leer la política de responsabilidad"
    }
  },
  "invite": {
    "headerAction": "Invitar",
    "headerTitle": "Invitar amigos",
    "codeCopied": "El código de invitación ha sido copiado.",
    "details": "Has invitado a {{numInvited}} personas.\n¡Cuanto más invitas, más contribuyes a hacer crecer esta cadena de generosidad!",
    "details2": "",
    "referralProgram": {
      "title": "¿Te gusta Partage Club?\n<color>Por cada referencia</color> te ofrecemos <color>¡1 mes gratis!</color>",
      "details": "Cada vez que un amigo se suscribe con tu enlace de referencia, recibes 1 mes gratis en Partage Club.",
      "details2": "",
      "referrals": {
        "title_zero": "¿Listo para comenzar? 🚀",
        "title": "¡Tus referencias! 🎉",
        "subTitle_zero": "¡Haz tu primera referencia para obtener tu primer mes gratis!",
        "subTitle_one": "<strong>{{count}} persona</strong> se unió a Partage Club gracias a <strong>ti</strong> 🥳",
        "subTitle": "<strong>{{count}} personas</strong> se unieron a Partage Club gracias a <strong>ti</strong> 🥳",
        "rewardMessage_one": "Gracias a tu referencia, ganaste <strong>1 mes de suscripción gratis</strong> 😊",
        "rewardMessage": "Gracias a tus referencias, ganaste <strong>{{count}} meses de suscripción gratis</strong> 😊",
        "1referral": "Una referencia",
        "1monthFree": "Un mes gratis",
        "1monthFreeWithEmoji": "1 mes gratis 🎉"
      },
      "subscription": "Ver mi suscripción",
      "howItWorks": {
        "title": "¿Cómo funciona?",
        "subtitle": "1 miembro referido = 1 persona que descarga la aplicación y crea una cuenta",
        "step1": "Envía tu código de invitación",
        "step2": "Tus amigos se registran con tu código",
        "step3": "¡Recibe tu recompensa!"
      },
      "gift": {
        "prefix": "Por cada persona referida, recibes automáticamente un mes gratis en Partage Club.",
        "prefix2": "<strong>1 mes gratis</strong>"
      },
      "shareYourCode": "Comparte tu código",
      "shareText": "¡Hola!\n\nUso Partage Club, una app genial para prestar y tomar prestados objetos cotidianos entre vecinos: herramientas, juegos, material deportivo… ¡todo lo que quieras!\nEstoy seguro/a de que te va a encantar. Únete aquí:\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "¿Te gusta Partage Club?\n<color>Invita a 5 personas</color> y te damos <color>¡un regalo de 25 $!</color>",
      "details": "Cada vez que 5 de tus amigos se suscriben gracias a tu enlace de referencia, recibes un regalo de 25 $.",
      "details2": "",
      "currentStep": {
        "progress": "{{numInvites}} de 5",
        "0": "¿Listo para comenzar? 🚀",
        "1": "¡Allá vamos! 🎯",
        "2": "¡Buen comienzo! ✌️",
        "3": "¡Casi llegas! 🔥",
        "4": "¡Solo falta uno! ⏳",
        "5": "🎉 Bravo y gracias.\n¡Has ganado tu recompensa!"
      },
      "howItWorks": {
        "title": "¿Cómo funciona?",
        "subtitle": "1 miembro referido = 1 persona que descarga la app y crea una cuenta",
        "step1": "Envía tu código de invitación",
        "step2": "Tus amigos se registran con tu código",
        "step3": "¡Obtén tu recompensa!"
      },
      "gift": {
        "prefix": "En cuanto alcances <strong>5 miembros referidos</strong>, obtienes <strong>25 $</strong> a elegir:",
        "gift1": "Tarjeta de regalo en el supermercado de tu elección",
        "gift2": "Tarjeta de regalo para el transporte público",
        "gift3": "Donación a una organización, hecha en tu nombre"
      },
      "shareText": "¡Hola!\n\nUso Partage Club, una app genial para prestar y tomar prestados objetos entre vecinos: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy seguro/a de que te va a interesar. Únete aquí:\n\n{{url}}"
    },
    "primaryButtonText": "Enviar la invitación",
    "secondaryButtonText": "Copiar el código",
    "shareText": "¡Hola!\n\nUso Partage Club, una app genial para prestar y tomar prestados objetos entre vecinos: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy seguro/a de que te va a interesar. Únete aquí:\n\n{{url}}",
    "subtitle": "Comparte tu código",
    "title": "¡Invita a tus vecinos o personas cercanas!",
    "referrals": {
      "title_zero": "¿Listo para comenzar? 🚀",
      "title": "¡Tus referencias! 🎉",
      "subTitle_zero": "¡Haz tu primera referencia compartiendo tu código!",
      "subTitle_one": "<strong>{{count}} persona</strong> se unió a Partage Club gracias a <strong>ti</strong> 🥳",
      "subTitle": "<strong>{{count}} personas</strong> se unieron a Partage Club gracias a <strong>ti</strong> 🥳"
    }
  },
  "landing": {
    "signin": "Iniciar sesión",
    "signup": "Registrarme",
    "welcome": "¡Bienvenido!"
  },
  "language": {
    "options": {
      "en": "Anglais",
      "fr": "Français",
      "es": "Espagnol"
    },
    "title": "Idioma de comunicación"
  },
  "listings-filters": {
    "title": {
      "request": "Filtrar las necesidades por",
      "offer": "Filtrar las ofertas por"
    },
    "titleClubs": "Clubs",
    "titleType": "Tipo",
    "transactionMode": {
      "lend": "Préstamos",
      "give": "Donaciones",
      "sell": "Ventas"
    },
    "titleFoundRequests": "Necesidades",
    "foundRequestsLabel": "¿Mostrar necesidades encontradas?",
    "dismissedRequestsLabel": "¿Mostrar necesidades descartadas?",
    "hideFoundRequestsTag": "Necesidades no encontradas",
    "showDismissedOnlyTag": "Necesidades descartadas",
    "titleOffersWithFee": "Ofertas",
    "offersWithFeeLabel": "¿Mostrar con cargo de intercambio?",
    "hideOffersWithFeeTag": "Ofertas sin cargo",
    "showOffersWithFeeTag": "Offres avec frais",
    "titleCategories": "Categorías",
    "close": "Cerrar",
    "titleTags": "Etiquetas",
    "tagsPlaceholder": "Filtrar por etiqueta",
    "titleSubtypes": "Tipos",
    "subtype": {
      "object": "Objetos",
      "service": "Servicios",
      "donation": "Donaciones"
    },
    "searchDistance": "Distancia",
    "distanceTag": "{{distance}} {{unit}}"
  },
  "loanDatesPicker": {
    "endFieldPlaceholder": "Fecha de fin",
    "informationTextAsBorrower": "Propón fechas al prestador para realizar la reserva y hacer seguimiento del objeto hasta su devolución.",
    "informationTextAsLender": "Propón fechas al prestatario para realizar la reserva y hacer seguimiento de tu objeto hasta su devolución.",
    "informationTextAsService": "Propón una fecha al miembro para este servicio y así confirmar la reserva.",
    "informationTextAsDonation": "Propón una fecha de recogida al miembro para esta donación.",
    "informationTextAsSell": "Propón una fecha de recogida al vendedor para realizar la reserva.",
    "informationTextForExistingLoanAsBorrower": "Propón nuevas fechas al prestador. Las fechas aceptadas anteriormente seguirán siendo válidas hasta que se acepten estas nuevas fechas.",
    "informationTextForExistingLoanAsLender": "Propón nuevas fechas al prestatario. Las fechas aceptadas anteriormente seguirán siendo válidas hasta que se acepten estas nuevas fechas.",
    "informationTextForExistingLoanAsService": "Propón una nueva fecha al miembro para este servicio. La fecha aceptada anteriormente seguirá siendo válida hasta que se acepte esta nueva fecha.",
    "informationTextForExistingLoanAsDonation": "Propón una nueva fecha al miembro para la recogida de esta donación. La fecha aceptada anteriormente seguirá siendo válida hasta que se acepte esta nueva fecha.",
    "informationTextForExistingLoanAsSell": "Propón una nueva fecha de recogida al vendedor. La fecha aceptada anteriormente seguirá siendo válida hasta que se acepte esta nueva fecha.",
    "offerDates": "Fechas de la oferta",
    "offerDateRange": "{{start}} - {{end}}",
    "plannedSalePeriodReminder": "Recordatorio: el período definido al crear la oferta es del {{start}} al {{end}}.",
    "flexibleDates": "¿Son flexibles las fechas?",
    "primaryButtonTextAsBorrower": "Enviar la solicitud",
    "primaryButtonTextBeforeReminder": "Continuar",
    "primaryButtonTextAsLender": "Proponer estas fechas",
    "primaryButtonTextAsLenderSingleDate": "Proponer esta fecha",
    "promptIntroduceYourself": "¡No olvides escribirle un mensaje al miembro para presentarte y expresarle tu interés!",
    "startFieldPlaceholder": "Fecha de inicio",
    "title": "Propuesta de fechas"
  },
  "loanFee": {
    "document": {
      "label": "Documento de la tarifa de préstamo",
      "help": "PDF, PNG o JPEG — hasta 10 MB. Visible para los miembros que consulten esta oferta.",
      "choose": "Elegir un documento",
      "replace": "Reemplazar documento",
      "remove": "Quitar documento",
      "view": "Ver",
      "preview": "Vista previa: {{name}}",
      "open": "Abrir documento",
      "uploading": "Subiendo documento…",
      "invalid": "Elige un archivo PDF, PNG o JPEG de hasta 10 MB.",
      "uploadError": "No se pudo subir el documento. Inténtalo de nuevo.",
      "previewError": "No se pudo abrir el documento. Inténtalo de nuevo."
    },
    "selectionTitle": "Modificar los cargos de intercambio de la selección ({{count}})",
    "title": "Modificar el cargo de intercambio",
    "saveButton": "Guardar el cargo de intercambio",
    "fields": {
      "loanFeePrompt": "¿Se requiere cargo para este préstamo?",
      "loanFeeDescriptionLabel": "Motivo del cargo de intercambio",
      "loanFeeDescriptionPlaceholder": "Explica en pocas palabras qué cubre este cargo. Ej. 1 persona para montaje/desmontaje, transporte del material e instalación, etc.",
      "loanFeeLabel": "Cargo de intercambio",
      "loanFeePlaceholder": "0",
      "loanFeePaymentMethodLabel": "Método de pago"
    },
    "listingCard": {
      "loanFee": "Cargo de intercambio"
    },
    "modals": {
      "loanFee": {
        "title": "Cargo de intercambio",
        "text": "<strong>¿Qué es un cargo de intercambio?</strong>\n\nUn cargo de intercambio es aplicado a discreción del prestador en diferentes casos. Por ejemplo para cubrir:\n  • Los gastos de manipulación o transporte.\n  • El tiempo dedicado a la preparación, montaje o desmontaje.\n  • etc.",
        "detailsForLender": "Este cargo es opcional. Se recomienda indicar claramente el motivo del cargo para garantizar transparencia con el prestatario."
      },
      "amount": {
        "title": "Cargo de intercambio",
        "text": "<strong>¿Cuánto cobrar?</strong>\n\nAquí hay algunas referencias para estimar un cargo de intercambio:\n\n  • Préstamo pequeño (herramientas, accesorios, etc.)\n<strong>5 % del valor de mercado</strong>\n\n  • Préstamo que requiere montaje/desmontaje\n<strong>5 a 10 % según el esfuerzo requerido</strong>\n\n  • Préstamo con transporte o desplazamiento\n<strong>Agregar un monto fijo (ej. 10 $)</strong>\n\n  • Préstamo que implica tiempo o coordinación\n<strong>Estimar según el tiempo invertido (ej. 10 $/h)</strong>\n\nEstos montos son orientativos, adáptalos según tu criterio y las particularidades de cada préstamo."
      },
      "paymentMethod": {
        "title": "Método de pago",
        "text": "<strong>Pago del cargo de intercambio</strong>\n\n  • Si no se indica el método de pago, se recomienda acordarlo con el prestador antes del intercambio.\n  • El pago del cargo de intercambio puede realizarse antes o después del intercambio, según convenga al prestador y al prestatario.\n  • El pago se realiza fuera de la aplicación."
      },
      "other": {
        "title": "Cargo de intercambio"
      }
    },
    "paymentMethods": {
      "cash": "Efectivo",
      "interac": "Transferencia Interac",
      "eft": "Transferencia bancaria",
      "other": "Otro"
    }
  },
  "loanParticipants": {
    "title": "Participantes"
  },
  "loans": {
    "services": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus préstamos recibidos o servicios por recibir aparecerán aquí."
        },
        "pastTitle": "Servicio recibido",
        "subtitle": "Préstamos en curso y servicios por recibir",
        "title": "Recibo"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus préstamos o servicios por prestar aparecerán aquí."
        },
        "pastTitle": "Servicio prestado",
        "subtitle": "Préstamos en curso y servicios por prestar",
        "title": "Ofrezco"
      },
      "past": {
        "tabs": {
          "borrowing": "Recibidos",
          "lending": "Ofrecidos"
        }
      }
    },
    "donations": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus préstamos o donaciones por recibir aparecerán aquí."
        },
        "pastTitle": "Donación recibida",
        "subtitle": "Préstamos en curso y donaciones por recibir",
        "title": "Recibo"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus préstamos o donaciones ofrecidas aparecerán aquí."
        },
        "pastTitle": "Donación ofrecida",
        "subtitle": "Préstamos en curso y donaciones ofrecidas",
        "title": "Ofrezco"
      },
      "past": {
        "tabs": {
          "borrowing": "Recibidos",
          "lending": "Ofrecidos"
        }
      }
    },
    "sales": {
      "borrowing": {
        "pastTitle": "Compra"
      },
      "lending": {
        "pastTitle": "Venta"
      }
    },
    "services+donations": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus préstamos, servicios por recibir y donaciones por recibir aparecerán aquí."
        },
        "subtitle": "Préstamos en curso, servicios por recibir y donaciones por recibir",
        "title": "Recibo"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus préstamos, servicios por prestar y donaciones ofrecidas aparecerán aquí."
        },
        "subtitle": "Préstamos en curso, servicios por prestar y donaciones ofrecidas",
        "title": "Ofrezco"
      },
      "past": {
        "tabs": {
          "borrowing": "Recibidos",
          "lending": "Ofrecidos"
        }
      }
    },
    "services+donations-ro": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus donaciones por recibir aparecerán aquí."
        },
        "subtitle": "Donaciones por recibir",
        "title": "Recibo"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tus servicios por prestar aparecerán aquí."
        },
        "subtitle": "Servicios por prestar",
        "title": "Ofrezco"
      },
      "past": {
        "tabs": {
          "borrowing": "Recibidos",
          "lending": "Ofrecidos"
        }
      }
    },
    "borrowing": {
      "empty": {
        "firstLine": "Ningún objeto tomado prestado",
        "secondLine": "Todos tus préstamos recibidos aparecerán aquí."
      },
      "pastTitle": "Préstamo recibido",
      "subtitle": "Los objetos que tomo prestados",
      "title": "Mis préstamos recibidos"
    },
    "calendar": {
      "activitySummary_one": "{{count}} actividad en {{month}}",
      "activitySummary_other": "{{count}} actividades en {{month}}",
      "activityTitle": "Actividad del mes",
      "close": "Cerrar los detalles de la fecha",
      "dateAccessibility_one": "{{date}}, {{count}} actividad",
      "dateAccessibility_other": "{{date}}, {{count}} actividades",
      "emptyPeriod": {
        "closestActivity": "Ir a {{month}}",
        "description": "Elige otro mes o ve a la actividad más cercana.",
        "title": "No hay actividad este mes"
      },
      "emptyRange": {
        "description": "Desliza el calendario o usa las flechas para ver otro período.",
        "title": "No hay actividad en este período"
      },
      "legend": {
        "late": "Requiere atención",
        "ongoing": "En curso",
        "returned": "Pendiente de confirmación",
        "scheduled": "Próximo"
      },
      "loading": "Cargando préstamos",
      "nextMonth": "Mes siguiente",
      "nextPeriod": "Período siguiente",
      "noActivityOnDate": "No hay actividad en esta fecha.",
      "planner": {
        "attentionSummary_one": "{{count}} elemento requiere atención",
        "attentionSummary_other": "{{count}} elementos requieren atención",
        "compact": {
          "attention": "Alerta",
          "completed": "Finalizado",
          "loanCount_one": "{{count}} préstamo",
          "loanCount_other": "{{count}} préstamos",
          "ongoing": "En curso",
          "periodSummary_one": "{{count}} actividad",
          "periodSummary_other": "{{count}} actividades"
        },
        "due": "vence",
        "groups": {
          "attention": "Requiere atención",
          "completed": "Finalizados",
          "ongoing": "En curso",
          "upcoming": "Próximos"
        },
        "loanColumn": "Préstamos",
        "returned": "devuelto",
        "starts": "empieza",
        "views": {
          "month": "Mes",
          "planner": "Intercambios"
        }
      },
      "previousMonth": "Mes anterior",
      "previousPeriod": "Período anterior",
      "sheetSummary_one": "{{count}} actividad en esta fecha",
      "sheetSummary_other": "{{count}} actividades en esta fecha",
      "tabs": {
        "borrowing": "Lista",
        "calendar": "Calendario",
        "lending": "Lista"
      },
      "today": "Hoy"
    },
    "card": {
      "status": {
        "cancelled": "Cancelado",
        "late": "Con retraso",
        "ongoing": "En curso",
        "past": "Finalizado",
        "pending": "En espera",
        "returned": "Devuelto",
        "returnedSale": "Vendido",
        "returnedService": "Prestado",
        "returnedDonation": "Recogido",
        "scheduled": "Programado"
      },
      "type": {
        "offer": {
          "mine": "Tu oferta",
          "notMine": "Oferta de un miembro"
        },
        "request": {
          "mine": "Tu necesidad",
          "notMine": "Necesidad de un miembro"
        }
      },
      "when": {
        "late": {
          "x_days": "Con {{numDays}} días de retraso",
          "yesterday": "Con retraso desde ayer"
        },
        "ongoing": {
          "today": "Devolución prevista hoy",
          "tomorrow": "Devolución prevista mañana",
          "x_days": "Devolución prevista en {{numDays}} días"
        },
        "past": {
          "today": "Devuelto hoy",
          "x_days": "Devuelto el {{date}}",
          "yesterday": "Devuelto ayer"
        },
        "pending": {
          "today": "En espera de confirmación",
          "tomorrow": "En espera de confirmación",
          "x_days": "En espera de confirmación"
        },
        "returned": {
          "today": "Devuelto hoy",
          "x_days": "Devuelto el {{date}}",
          "yesterday": "Devuelto ayer"
        },
        "scheduled": {
          "today": "Programado para hoy",
          "tomorrow": "Programado para mañana",
          "x_days": "Previsto en {{numDays}} días"
        }
      },
      "whenService": {
        "late": {
          "x_days": "Con {{numDays}} días de retraso",
          "yesterday": "Con retraso desde ayer"
        },
        "ongoing": {
          "today": "Previsto para hoy",
          "tomorrow": "Previsto para mañana",
          "x_days": "Previsto en {{numDays}} días"
        },
        "past": {
          "today": "Prestado hoy",
          "x_days": "Prestado el {{date}}",
          "yesterday": "Prestado ayer"
        },
        "pending": {
          "today": "En espera de confirmación",
          "tomorrow": "En espera de confirmación",
          "x_days": "En espera de confirmación"
        },
        "returned": {
          "today": "Prestado hoy",
          "x_days": "Prestado el {{date}}",
          "yesterday": "Prestado ayer"
        },
        "scheduled": {
          "today": "Previsto para hoy",
          "tomorrow": "Previsto para mañana",
          "x_days": "Previsto en {{numDays}} días"
        }
      },
      "whenDonation": {
        "late": {
          "x_days": "Con {{numDays}} días de retraso",
          "yesterday": "Con retraso desde ayer"
        },
        "ongoing": {
          "today": "Previsto para hoy",
          "tomorrow": "Previsto para mañana",
          "x_days": "Previsto en {{numDays}} días"
        },
        "past": {
          "today": "Recogido hoy",
          "x_days": "Recogido el {{date}}",
          "yesterday": "Recogido ayer"
        },
        "pending": {
          "today": "En espera de confirmación",
          "tomorrow": "En espera de confirmación",
          "x_days": "En espera de confirmación"
        },
        "returned": {
          "today": "Recogido hoy",
          "x_days": "Recogido el {{date}}",
          "yesterday": "Recogido ayer"
        },
        "scheduled": {
          "today": "Previsto para hoy",
          "tomorrow": "Previsto para mañana",
          "x_days": "Previsto en {{numDays}} días"
        }
      },
      "whenSale": {
        "late": {
          "x_days": "Venta atrasada {{numDays}} días",
          "yesterday": "Venta atrasada desde ayer"
        },
        "ongoing": {
          "today": "Venta prevista hoy",
          "tomorrow": "Venta prevista mañana",
          "x_days": "Venta prevista en {{numDays}} días"
        },
        "past": {
          "today": "Venta completada hoy",
          "x_days": "Venta completada el {{date}}",
          "yesterday": "Venta completada ayer"
        },
        "pending": {
          "today": "Pendiente de confirmación",
          "tomorrow": "Pendiente de confirmación",
          "x_days": "Pendiente de confirmación"
        },
        "returned": {
          "today": "Recepción confirmada hoy",
          "x_days": "Recepción confirmada el {{date}}",
          "yesterday": "Recepción confirmada ayer"
        },
        "scheduled": {
          "today": "Venta prevista hoy",
          "tomorrow": "Venta prevista mañana",
          "x_days": "Venta prevista en {{numDays}} días"
        }
      }
    },
    "lending": {
      "empty": {
        "firstLine": "Ningún objeto prestado",
        "secondLine": "Todos tus préstamos aparecerán aquí."
      },
      "pastTitle": "Préstamo",
      "subtitle": "Los objetos que presto",
      "title": "Mis préstamos"
    },
    "past": {
      "empty": {
        "filtered": "Ningún historial coincide con este filtro.",
        "firstLine": "Tu historial de intercambios está vacío",
        "secondLine": "Todos los préstamos y préstamos recibidos finalizados aparecerán aquí."
      },
      "filters": {
        "all": "Todo"
      },
      "savings": {
        "header": {
          "borrowing": "Ahorrados al pedir prestado en vez de comprar",
          "lending": "Ahorrados por tus vecinos gracias a ti"
        }
      },
      "cards": {
        "date": "{{end}}",
        "dates": "{{start}} al {{end}}"
      },
      "rating": {
        "mine": "Mi evaluación:",
        "recommended": "Recomendado",
        "notRecommended": "No recomendado"
      },
      "tabs": {
        "borrowing": "Recibidos",
        "lending": "Prestados"
      },
      "title": "Mi historial"
    }
  },
  "login": {
    "signUpOrLogin": "Registrarse / Iniciar sesión",
    "title": "Inicia sesión",
    "emailFieldLabel": "Dirección de correo electrónico",
    "emailFieldPlaceholder": "Dirección de correo electrónico",
    "passwordFieldLabel": "Contraseña",
    "passwordFieldPlaceholder": "Contraseña",
    "forgotPassword": "Olvidé mi contraseña",
    "guestPrimaryButtonText": "Continuar",
    "primaryButtonText": "Iniciar sesión",
    "lastUsedMethod": "Usado recientemente",
    "noAccountYetPrefix": "¿No tienes una cuenta?",
    "noAccountYet": "Registrarse",
    "downloadApp": "¡Descarga la aplicación!",
    "errors": {
      "incorrect-credentials": "Tu correo electrónico o contraseña no son válidos."
    }
  },
  "management": {
    "bonificationPrompt": {
      "text": "Algunos de tus objetos están disponibles, pero sin foto o descripción."
    },
    "tabBarLabel": "Intercambios",
    "title": "Mis intercambios",
    "ongoing": "Intercambios en curso",
    "publications": "Mis publicaciones",
    "moreOptions": "Más opciones"
  },
  "my-address": {
    "administrativeAreaFieldLabel": "Provincia",
    "administrativeAreaFieldPlaceholder": "Elegir la provincia",
    "cityFieldLabel": "Ciudad",
    "countryFieldLabel": "País",
    "countryRegionLockedHelp": "Una vez creada la cuenta, su dirección no puede trasladarse hacia o desde Estados Unidos.",
    "postalCodeFieldLabel": "Código postal",
    "primaryButtonText": "Guardar",
    "streetFieldLabel": "Número y nombre de calle",
    "title": "Mi dirección",
    "unitFieldLabel": "Apartamento (opcional)"
  },
  "my-clubs": {
    "createClubButton": "Agregar un barrio",
    "addProClubButton": "Unirse a un club",
    "infoButtonLabel": "Más información sobre mis clubs",
    "help": {
      "neighbourhoods": {
        "title": "Clubs de barrio",
        "paragraph1": "Agrega clubs para los barrios que frecuentas para acceder a más ofertas y ampliar tus ofertas a más miembros.",
        "paragraph2": "La escuela de tu hijo, tu cabaña, etc."
      },
      "pro": {
        "title": "Clubs asociados",
        "paragraph1": "Un club asociado es gestionado por una organización como tu ciudad, empleador, asociación o universidad. Agrega uno si recibiste un código de invitación."
      }
    },
    "neighbourhoodClubName": "Domicilio",
    "neighbourhoodTitle": "Clubs de barrio",
    "sharingPlaceTitle": "Lugares de intercambio",
    "proTitle": "Clubs asociados",
    "title": "Mis clubs"
  },
  "activity-sectors": {
    "title": "Mis sectores de actividad",
    "fieldLabel": "Sector de actividad (obligatorio)*",
    "subtitle": "Selecciona los sectores que mejor describen tu actividad. Puedes elegir varios.",
    "empty": "No hay sectores disponibles por el momento",
    "errorToast": "Ocurrió un error. Inténtalo de nuevo.",
    "minOneToast": "Debes mantener al menos un sector de actividad.",
    "addCta": "Añadir un sector",
    "overflowTitle": "Mis otros sectores"
  },
  "my-impact-financial": {
    "ctaButtonText": {
      "borrowing": "Ver la lista de mis préstamos recibidos",
      "lending": "Ver la lista de mis préstamos"
    },
    "ctaButtonTextByTransaction": {
      "lend": {
        "borrowing": "Ver mis préstamos recibidos",
        "lending": "Ver mis préstamos"
      },
      "sell": {
        "borrowing": "Ver mis compras",
        "lending": "Ver mis ventas"
      },
      "give": {
        "borrowing": "Ver mis donaciones recibidas",
        "lending": "Ver mis donaciones"
      }
    },
    "empty": {
      "borrowing": {
        "firstLine": "El monto que ahorras al tomar prestado aparecerá aquí.",
        "primaryButtonText": "Ver las ofertas de otros miembros",
        "secondLine": "¡Empieza a tomar prestado y mira cuánto dinero ahorras!"
      },
      "lending": {
        "firstLine": "El monto que otros miembros ahorran al tomar prestados tus objetos aparecerá aquí.",
        "primaryButtonText": "Ver las necesidades de otros miembros",
        "secondLine": "¡Comparte tus objetos y mira cuánto dinero permites ahorrar a los miembros!"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "borrowing": {
          "firstLine": "El monto que ahorras al tomar prestado aparecerá aquí.",
          "primaryButtonText": "Ver las ofertas de otros miembros",
          "secondLine": "¡Empieza a tomar prestado y mira cuánto dinero ahorras!"
        },
        "lending": {
          "firstLine": "El monto que otros miembros ahorran al tomar prestados tus objetos aparecerá aquí.",
          "primaryButtonText": "Ver las necesidades de otros miembros",
          "secondLine": "¡Comparte tus objetos y mira cuánto dinero permites ahorrar a los miembros!"
        }
      },
      "sell": {
        "borrowing": {
          "firstLine": "El valor de tus compras aparecerá aquí.",
          "primaryButtonText": "Ver objetos en venta",
          "secondLine": "¡Empieza a comprar y sigue el valor de tus compras!"
        },
        "lending": {
          "firstLine": "El valor de tus ventas aparecerá aquí.",
          "primaryButtonText": "Ver las necesidades de otros miembros",
          "secondLine": "¡Empieza a vender y sigue el valor de tus ventas!"
        }
      },
      "give": {
        "borrowing": {
          "firstLine": "El valor de los objetos que recibes aparecerá aquí.",
          "primaryButtonText": "Ver objetos para recibir",
          "secondLine": "¡Recibe objetos y sigue el valor de las donaciones recibidas!"
        },
        "lending": {
          "firstLine": "El valor de los objetos que donas aparecerá aquí.",
          "primaryButtonText": "Ver las necesidades de otros miembros",
          "secondLine": "¡Dona objetos y sigue el valor de tus donaciones!"
        }
      }
    },
    "howItWorks": {
      "title": "¿Cómo se calcula?",
      "body": "Utilizamos una herramienta de inteligencia artificial para determinar el precio de cada objeto tomado prestado",
      "bodyByTransaction": {
        "lend": "Utilizamos una herramienta de inteligencia artificial para determinar el precio de cada objeto tomado prestado",
        "sell": "Utilizamos una herramienta de inteligencia artificial para estimar el valor de cada objeto vendido",
        "give": "Utilizamos una herramienta de inteligencia artificial para estimar el valor de cada objeto donado"
      }
    },
    "subtext": {
      "borrowing": "tomando prestados objetos",
      "lending": "prestando mis objetos"
    },
    "subtextByTransaction": {
      "lend": {
        "borrowing": "tomando prestados objetos",
        "lending": "prestando mis objetos"
      },
      "sell": {
        "borrowing": "comprando objetos",
        "lending": "vendiendo mis objetos"
      },
      "give": {
        "borrowing": "recibiendo objetos",
        "lending": "donando mis objetos"
      }
    },
    "roleTabs": {
      "lend": {
        "borrowing": "He ahorrado",
        "lending": "He hecho ahorrar"
      },
      "sell": {
        "borrowing": "He comprado",
        "lending": "He vendido"
      },
      "give": {
        "borrowing": "He recibido",
        "lending": "He donado"
      }
    },
    "tabs": {
      "borrowing": "He ahorrado",
      "lending": "He hecho ahorrar"
    },
    "transactionTabs": {
      "lend": "Intercambio",
      "sell": "Venta",
      "give": "Donación"
    },
    "title": "Mi impacto económico"
  },
  "my-information": {
    "credentialInformationText": "La información a continuación <strong>no será accesible</strong> para otros miembros.",
    "credentialInformationTitle": "Cuenta y seguridad",
    "edit": "Modificar",
    "editAvatarButtonLabel": "Modificar mi foto",
    "emailFieldLabel": "Correo electrónico",
    "firstNameFieldLabel": "Nombre",
    "groupMemberCountFieldLabel": "Número de miembros",
    "groupNameFieldLabel": "Empresa",
    "groupsTitle": "Mi club de intercambio",
    "lastNameFieldLabel": "Apellido",
    "my-neighborhood-club": "Mi club de barrio",
    "passwordFieldLabel": "Contraseña",
    "passwordFieldCTA": "Modificar mi contraseña",
    "personalInformationText": "La información a continuación será <strong>visible</strong> para otros miembros.",
    "personalInformationTitle": "Información personal",
    "phoneFieldLabel": "Número de teléfono",
    "phoneFieldError": "El número de teléfono no es válido.",
    "search-radius": "Radio de búsqueda*",
    "title": "Mis informaciones",
    "visibilityRadiusSection": {
      "title": "Mi dirección"
    }
  },
  "my-listings": {
    "title": {
      "offer": "Mis ofertas",
      "request": "Mis necesidades"
    },
    "editButton": "Seleccionar",
    "selectAllButton": "Seleccionar todo",
    "deselectAllButton": "Deseleccionar todo",
    "cancelButton": "Cancelar",
    "modifyListingsButton": "Modificar",
    "modifyListingsCountButton": "Modificar ({{count}})",
    "modifyListingsTitle": "Modificar",
    "blockDatesButton": "Reservar",
    "changeLoanFeeButton": "Modificar el cargo de intercambio",
    "duplicateButton": "Duplicar",
    "changePriceButton": "Modificar el precio",
    "duplicateModal": {
      "title": "Duplicar",
      "copies": "Copias",
      "confirm": "Confirmar"
    },
    "priceModal": {
      "title": "Modificar el precio de la selección ({{count}})",
      "label": "Precio",
      "placeholder": "50 $/kg",
      "save": "Guardar"
    },
    "hideButton": "Ocultar",
    "hideAlert": {
      "title": "Confirmar ocultamiento",
      "message": "Estos objetos ya no serán visibles para los demás, pero podrás restaurarlos más tarde aquí.",
      "confirmButton": "Ocultar",
      "cancelButton": "Cancelar"
    },
    "unhideButton": "Mostrar",
    "unhideAlert": {
      "title": "Confirmar visualización",
      "message": "Estos objetos volverán a ser visibles para los demás.",
      "confirmButton": "Mostrar",
      "cancelButton": "Cancelar"
    },
    "deleteButton": "Eliminar",
    "deleteAlert": {
      "title": "Confirmar eliminación",
      "message": "¿Estás seguro/a de querer eliminar estos objetos? Esta acción es irreversible.",
      "confirmButton": "Eliminar",
      "cancelButton": "Cancelar"
    },
    "hideToast": {
      "title": "Objetos ocultos",
      "text": "Ya no serán visibles para los demás."
    },
    "unhideToast": {
      "title": "Objetos visibles",
      "text": "Volverán a ser visibles para los demás."
    },
    "deleteToast": {
      "title": "Objetos eliminados",
      "text": "Se eliminaron definitivamente."
    },
    "duplicateToast": {
      "title": "Objetos duplicados",
      "text": "Las copias se añadieron a tus ofertas."
    },
    "priceUpdatedToast": {
      "title": "Precio actualizado",
      "text": "Se modificó el precio de la selección."
    },
    "transactionModeTabs": {
      "all": "Todo",
      "lend": "Préstamos",
      "sell": "Ventas",
      "give": "Donaciones"
    },
    "emptyState": {
      "all": "Tus ofertas aparecerán aquí",
      "lend": "Tus ofertas para prestar aparecerán aquí",
      "sell": "Tus ofertas para vender aparecerán aquí",
      "give": "Tus ofertas para donar aparecerán aquí"
    }
  },
  "my-neighbourhood": {
    "addAddressHelp": "Tener más de un club de barrio (varias direcciones) te permite acceder a más ofertas.",
    "addressLabel": "Dirección",
    "audience": "Miembros en la zona",
    "clubName": "Club {{clubName}}",
    "clubNameLabel": "Nombre del club",
    "createClubButton": "Agregar este barrio",
    "completeAddress": "Completar la dirección",
    "deleteButton": "Eliminar",
    "deleteConfirmation": "¿Eliminar este club de barrio?",
    "edit": "Modificar",
    "iconLabel": "Ícono del club",
    "neighborhoodClub": "Club del barrio",
    "noteBelowMap": "Ajusta tu zona de intercambio moviéndola en el mapa.",
    "postalCodeLabel": "Código postal",
    "radiusLabel": "Radio de intercambio",
    "radiusDescription": "Tu radio te permite compartir tus anuncios dentro de un perímetro limitado de tu barrio. Los vecinos que vivan fuera de esta zona no podrán ver tus anuncios.",
    "saveClubButton": "Guardar",
    "titleNew": "Agregar un barrio",
    "viewMembersList": "Ver la lista de miembros"
  },
  "travel-distance": {
    "title": "Distancia de búsqueda",
    "noteBelowMap": "Ajusta tu zona de búsqueda moviéndola en el mapa.",
    "potentialAudience": "Audiencia potencial",
    "neighbours": "Miembros",
    "neighboursRecentOnly": "Miembros activos",
    "neighbourListings": "Ofertas disponibles",
    "describeStatsRecentOnly": "Durante los últimos 3 meses.",
    "noLimit": "Máximo ({{max}} {{unit}})",
    "noLimitWhiteLabel": "Sin límite - Todos los miembros",
    "save": "Guardar",
    "reset": "Réinitialiser",
    "text": "La distancia de búsqueda se aplica únicamente a los anuncios de tu Club de barrio."
  },
  "my-personal-information": {
    "additionalNameFieldLabel": "Nombre adicional",
    "bioFieldLabel": "Sobre mí",
    "bioFieldPlaceholder": "Cuéntanos un poco sobre ti.",
    "firstNameFieldLabel": "Nombre",
    "firstNameFieldPlaceholder": "Nombre",
    "lastNameFieldLabel": "Apellido",
    "lastNameFieldPlaceholder": "Apellido",
    "primaryButtonText": "Guardar",
    "title": "Información general"
  },
  "my-plan": {
    "addCodeButton": "Usar mi código de invitación",
    "design": {
      "activeSubscription": "Actualmente tienes una suscripción Partage+.",
      "available": "Disponible",
      "billingNote": {
        "monthly": "*Se te facturarán {{price}} / mes en la fecha de renovación. Cancela hasta 24 horas antes de la fecha de tu próximo pago.",
        "yearly": "*Se te facturarán {{price}} / año en la fecha de renovación. Cancela hasta 24 horas antes de la fecha de tu próximo pago."
      },
      "cancelAnytime": "Cancela en cualquier momento",
      "cancelAnytimeShort": "Cancela en cualquier momento",
      "cancelDescription": "Puedes cancelar tu suscripción hasta 24 horas antes de la fecha de tu próximo pago. Tu suscripción se renovará automáticamente.",
      "codeCopied": "Se copió el código de invitación.",
      "current": "Actual",
      "damageCoverage": "Cobertura para objetos compartidos",
      "discovery": "Descubrimiento",
      "free": "gratis",
      "freeBorrowDescription": "Pide prestado tu primer objeto a tus vecinos gratis",
      "frequency": {
        "monthly": "Mensual",
        "no": "Ofrecido",
        "yearly": "Anual"
      },
      "goFurther": "Para ir más lejos",
      "invitationCode": "Tu código de invitación",
      "learnMore": "Más información",
      "manageTitle": "Gestionar mi suscripción",
      "nextPayment": "Próximo pago",
      "oneBorrow": "1 préstamo",
      "offeredBy": "Ofrecido por:",
      "planType": {
        "citizen": "Ciudadano",
        "employee": "Empleado"
      },
      "referralBenefit": "Una referencia = 1 mes adicional",
      "referralTitle": "1 referencia = 1 mes adicional",
      "shareReferral": "Únete a mí en Partage Club: {{url}}",
      "renewalCancelled": "Cancelaste la renovación de tu suscripción Partage+.",
      "resubscribe": "Volver a suscribirme",
      "subscribeNow": "Suscribirme ahora",
      "subscriptionEnd": "Fecha de finalización de la suscripción",
      "unlimitedBorrowing": "Préstamos ilimitados",
      "unlimitedLending": "Préstamos de objetos ilimitados",
      "unlimitedLendingDescription": "Publica ofertas y presta tus objetos a tus vecinos tantas veces como quieras",
      "useActivationCode": "Usar mi código de activación",
      "usedOn": "Usado el {{date}}",
      "yourBenefits": "Tus ventajas"
    },
    "businessPlan": {
      "firstParagraph": {
        "education": "Tu suscripción es ofrecida por {{planName}}.",
        "enterprise": "Tu suscripción es ofrecida por {{planName}}.",
        "generic": "Tu suscripción es ofrecida por {{planName}}.",
        "municipal": "Tu suscripción es ofrecida por {{planName}}.",
        "municipal_closed": "Tu suscripción es ofrecida por {{planName}}.",
        "realestate": "Tu suscripción es ofrecida por {{planName}}."
      },
      "title": {
        "education": "Suscripción educativa",
        "enterprise": "Suscripción empleado",
        "generic": "Suscripción corporativa",
        "municipal": "Suscripción Partage+",
        "municipal_closed": "Suscripción Partage+",
        "realestate": "Suscripción residente"
      }
    },
    "defricheurPlan": {
      "firstParagraph": "Recibiste una suscripción gratuita gracias a la Oferta del Pionero.",
      "title": "Suscripción <strong>anual gratuita</strong>"
    },
    "dragonPlan": {
      "firstParagraph": "Actualmente tienes una suscripción para {{planName}}.",
      "title": "Suscripción <strong>anual</strong>"
    },
    "end": "Termina el {{date}}",
    "extraGroups": "Tus otros Clubs",
    "freeSubButtonText": "Crear un anuncio",
    "freeSubText": {
      "defricheur": "Hay pocos objetos en tu barrio. <strong>Suscripción anual gratuita para los 5 primeros</strong> que publiquen un objeto.",
      "trial": "¡Contribuye a hacer crecer el catálogo del <strong>Partage Club</strong>! ¡Publica 5 objetos y gana tu <strong>suscripción anual</strong>!"
    },
    "giftPlan": {
      "firstParagraph": "Recibiste una suscripción de regalo.",
      "title": "Suscripción <strong>anual</strong>"
    },
    "modal": {
      "codeFieldLabel": "Código de invitación",
      "codeFieldPlaceholder": "Ej: 4D86DJ",
      "error": {
        "codeLimitReached": "Ya no hay suscripciones disponibles para este código de invitación. Sin embargo, aún puedes probar la aplicación durante nuestro período de prueba gratuito.",
        "forbidden": "No estás autorizado a usar este código",
        "invalidCode": "El código que ingresaste no es válido",
        "missingCode": "Por favor ingresa un código"
      },
      "firstParagraph": "Por favor ingresa el código de invitación que te fue enviado.",
      "primaryButtonText": "Activar",
      "secondaryButtonText": "Cancelar",
      "title": "Activar tu suscripción"
    },
    "noEnd": "Suscripción de por vida",
    "offreTrialPlan": {
      "firstParagraph": "Recibiste una suscripción gratuita por publicar 5 ofertas.",
      "title": "Suscripción <strong>anual gratuita</strong>"
    },
    "planExpired": {
      "advantages": "Las ventajas de ser miembro",
      "title": {
        "regular": "Tu suscripción ha expirado.",
        "trial": "Tu período de prueba gratuito ha terminado."
      },
      "text": {
        "regular": "Puedes seguir prestando sin suscripción, pero para tomar prestado, debes suscribirte.",
        "trial": "Puedes seguir prestando sin suscripción, pero para tomar prestado, debes suscribirte."
      }
    },
    "promoDragonText": "<strong>Promoción</strong> «En el ojo del dragón». Disfruta de una <strong>suscripción anual</strong> a 30 $ en lugar de 60 $.",
    "promoDragonText2": "⌛ Hasta el 24 de abril de 2024 a las 23:59",
    "promoDragonButtonText": "Aprovechar el 50 % de descuento (30 $)",
    "recurrenceWhen": "Fecha del próximo pago",
    "endsWhen": "Fecha de fin de suscripción",
    "trialEndsWhen": "Fin del período de prueba",
    "referralPrizePlan": {
      "firstParagraph": "Recibiste una suscripción anual gratuita por invitar a una persona a registrarse.",
      "title": "Suscripción <strong>anual gratuita</strong>"
    },
    "regularPlan": {
      "firstParagraph": "Actualmente tienes una suscripción regular.",
      "title": "Suscripción <strong>regular</strong>"
    },
    "regularMonthlyPlan": {
      "firstParagraph": "Actualmente estás suscrito/a a un plan mensual.",
      "title": "Suscripción <strong>mensual</strong>"
    },
    "regularYearlyPlan": {
      "firstParagraph": "Actualmente estás suscrito/a a un plan anual.",
      "title": "Suscripción <strong>anual</strong>"
    },
    "startRecurrenceButtonText": "Renovar",
    "stopRecurrenceButtonText": "Cancelar suscripción",
    "stopRecurrenceModal": {
      "title": "Cancelación de suscripción",
      "text": "Tu próximo pago no será cobrado y la renovación automática será cancelada. Podrás seguir disfrutando de tu suscripción hasta el {{date}}.",
      "ctaPositive": "Cancelar suscripción",
      "ctaNegative": "No hacer nada"
    },
    "subscribeButton": "Elegir mi suscripción",
    "title": "Mi suscripción",
    "trialPlan": {
      "firstParagraph": "Tienes <strong>1 crédito de préstamo gratuito</strong>.",
      "title": "Descubrimiento"
    },
    "viewReferralProgramButton": "Ganar una suscripción anual gratuita",
    "referralProgram": {
      "title": "¿Quieres extender tu suscripción gratuitamente?",
      "subtitle": "Por cada persona referida, obtienes automáticamente un mes gratis en Partage Club."
    }
  },
  "my-preferences": {
    "addToCalendar": {
      "always": "Sí, para todos los préstamos",
      "never": "No, nunca",
      "once": "Preguntarme de nuevo en cada préstamo"
    },
    "calendarButtonText": "Calendario",
    "deleteAccountButtonText": "Eliminar la cuenta",
    "languageButtonText": "Idioma de comunicación",
    "notificationsButtonText": "Notificaciones",
    "title": "Mis preferencias"
  },
  "my-profile": {
    "clubName": "Club {{clubName}}",
    "memberSince": "Miembro desde {{date}}",
    "subscribedMemberSince": {
      "1": "Miembro",
      "2": "suscrito",
      "3": "desde"
    },
    "city": "Ciudad",
    "location": {
      "profileTitle_one": "Zona aproximada de recogida",
      "profileTitle_other": "Zonas aproximadas de recogida",
      "privacyHint": "El círculo muestra la zona aproximada donde pueden realizarse las recogidas.",
      "securityMessage": "Este mapa nunca revela una dirección exacta. Los detalles de recogida que se compartan más adelante permanecen fuera de este mapa."
    },
    "offers": {
      "empty": "No has publicado ninguna oferta",
      "subtitle": "{{amount}} ofertas",
      "title": "Mis ofertas",
      "count_title": "Mis {{count}} ofertas"
    },
    "requests": {
      "empty": "No has publicado ninguna necesidad",
      "subtitle": "{{amount}} necesidades",
      "title": "Mis necesidades",
      "count_title": "Mis {{count}} necesidades"
    },
    "title": "Mi perfil",
    "titleSharingPlace": "Mi lugar de intercambio",
    "tabs": {
      "offers": "Ofertas",
      "requests": "Necesidades",
      "reviews": "Reseñas",
      "places": "Lugares",
      "available": "Disponible",
      "regulars": "Habituales"
    }
  },
  "neighbour-listings": {
    "title": {
      "offer": "Sus ofertas",
      "request": "Sus necesidades"
    }
  },
  "neighbour-profile": {
    "empty": {
      "offers": "Las ofertas publicadas en este perfil aparecerán aquí.",
      "requests": "Las necesidades publicadas en este perfil aparecerán aquí.",
      "places": "Los lugares de intercambio añadidos a este perfil aparecerán aquí.",
      "onSite": "Los objetos disponibles para recoger en este lugar aparecerán aquí."
    },
    "clubName": "Club {{clubName}}",
    "contactButtonTextMember": "Contactar al miembro",
    "contactButtonTextPlace": "Contactar al lugar",
    "memberSince": "Miembro desde {{date}}",
    "currentlyUnavailable": "No disponible",
    "unavailabilityBannerMessage": "Este miembro no está disponible actualmente y podría no responder a tus mensajes.",
    "subscribedMemberSince": {
      "1": "Miembro",
      "2": "suscrito",
      "3": "desde"
    },
    "city": "Ciudad",
    "sectorActivity": "Sector(es) de actividad",
    "location": {
      "profileTitle_one": "Zona aproximada de recogida",
      "profileTitle_other": "Zonas aproximadas de recogida",
      "privacyHint": "El círculo muestra la zona aproximada donde pueden realizarse las recogidas. La dirección exacta no se muestra."
    },
    "offers": {
      "empty": "Este miembro no ha publicado ninguna oferta",
      "subtitle": "{{amount}} ofertas",
      "title": "Sus ofertas",
      "count_title": "Sus {{count}} ofertas"
    },
    "requests": {
      "empty": "Este miembro no ha publicado ninguna necesidad",
      "subtitle": "{{amount}} necesidades",
      "title": "Sus necesidades",
      "count_title": "Sus {{count}} necesidades"
    },
    "stats": {
      "chatResponseRate": "Tasa de respuesta",
      "chatResponseTimeAvg": "Respuesta promedio",
      "impactLevel": "Nivel de impacto",
      "numberOfIncomingLoans": "Préstamos recibidos",
      "numberOfOutgoingLoans": "Préstamos",
      "numberOfRequests": "Necesidades",
      "trustPoints": "Recomendaciones",
      "numberOfOutgoingServiceLoans": "Servicios prestados",
      "numberOfIncomingServiceLoans": "Servicios recibidos",
      "numberOfOutgoingDonations": "Donaciones ofrecidas",
      "numberOfIncomingDonations": "Donaciones recibidas",
      "numberOfSales": "Ventas",
      "recommendationsShort": "Recom.",
      "shares": "Intercambios",
      "responseRateShort": "Tasa de resp.",
      "responseTimeShort": "Resp. media",
      "seeMore": "Ver más",
      "seeLess": "Ver menos",
      "less": "Menos",
      "lent": "Préstamo(s)",
      "borrowed": "Préstamo(s) recibido(s)",
      "requests": "Necesidad(es)",
      "memberSince": "Inscripción"
    },
    "seeMore": "Ver más",
    "goodToKnow": "Información útil",
    "trust": {
      "summary": "<strong>{{count}}</strong> miembros, incluidos <strong>{{names}}</strong>, confían en este miembro",
      "summary_one": "<strong>{{count}}</strong> miembro, <strong>{{names}}</strong>, confía en este miembro",
      "summaryMore": "<strong>{{count}}</strong> miembros, incluidos <strong>{{names}}</strong> y <strong>{{remaining}} más</strong>, confían en este miembro",
      "noMembers": "Nadie confía aún en esta persona",
      "add": "Añadir al círculo de confianza",
      "trusted": "Confío en este miembro",
      "info": "Las personas de tu círculo de confianza pueden ver las ofertas que decidas reservarles.",
      "manage": "Gestionar mi círculo de confianza",
      "circleTitle": "Círculo de confianza",
      "memberCount_one": "{{count}} miembro",
      "memberCount": "{{count}} miembros",
      "commonHeading": "Estas personas de tu círculo de confianza también confían en {{name}}",
      "otherHeading": "Otras personas que confían en {{name}}",
      "empty": "No hay miembros para mostrar",
      "distance": "{{distance}} km",
      "since": "desde {{date}}",
      "removeTitle": "¿Quitar a {{name}}?",
      "removeMessage": "{{name}} dejará de ver las ofertas reservadas para tu círculo de confianza.",
      "remove": "Quitar",
      "cancel": "Cancelar",
      "manager": {
        "title": "Miembros de confianza",
        "addMembers": "Añadir miembros",
        "search": "Buscar miembros",
        "clear": "Borrar todo",
        "results": "Resultados de búsqueda",
        "suggestions": "Sugerencias",
        "noResults": "No se encontraron otros miembros",
        "save": "Guardar",
        "close": "Cerrar"
      },
      "badge": "En tu círculo de confianza"
    },
    "shares": {
      "lentTitle": "Objetos que {{name}} prestó",
      "borrowedTitle": "Objetos que {{name}} tomó prestados",
      "recentTitle": "Intercambios recientes",
      "allTitle": "Todos los intercambios",
      "commonTitle": "Todos los intercambios en común",
      "borrowed": "tomó prestado",
      "lent": "prestó",
      "lentToYou": "te prestó",
      "borrowedFromYou": "te pidió prestado",
      "empty": "No hay intercambios para mostrar",
      "viewHistory": "Ver historial",
      "commonWidget": "Has compartido <strong>{{count}} veces</strong> con <strong>{{name}} ·</strong> Última vez {{ago}}",
      "filters": {
        "all": "Todo ({{count}})",
        "lent": "Préstamos ({{count}})",
        "borrowed": "Empréstitos ({{count}})"
      },
      "memberActions": {
        "more": "Más acciones para {{name}}",
        "view": "Ver perfil",
        "message": "Enviar un mensaje",
        "addTrust": "Añadir al círculo de confianza",
        "removeTrust": "Eliminar del círculo de confianza",
        "report": "Reportar al miembro"
      }
    },
    "title": "Perfil",
    "shareProfile": "Compartir perfil",
    "mainTabs": {
      "info": "Info",
      "reviews": "Reseñas ({{count}})"
    },
    "titleSharingPlace": "Lugar de intercambio",
    "reportUser": "Reportar a este usuario",
    "reportUserPrompt": "Hola, me gustaría reportar a un usuario cuyo comportamiento encuentro inapropiado o abusivo. ¿Podrían revisar su perfil?\n\nGracias.",
    "reportRatingPrompt": "Hola, me gustaría reportar una evaluación que considero inapropiada. ¿Podrían revisarla?\n\nGracias.",
    "ambassadorLabel": "Embajador·a",
    "discount": {
      "sheetTitle": "Detalles de la oferta",
      "learnMore": "Saber más"
    },
    "placeHelp": {
      "title": "Lugar de intercambio",
      "help": "Ayuda",
      "description": {
        "1": "Un lugar de intercambio es un ",
        "bold1": "espacio seguro y comunitario",
        "2": " donde los miembros pueden reunirse para ",
        "bold2": "compartir",
        "3": " objetos entre sí y también ",
        "bold3": "tomar prestados",
        "4": " objetos disponibles en el lugar"
      },
      "features": {
        "borrow": {
          "title": "Toma prestados objetos en el lugar",
          "description": "Elige y toma prestados objetos de la selección que ofrece el lugar"
        },
        "dropOff": {
          "title": "Deja y recoge objetos fácilmente",
          "description": "Este lugar de intercambio acepta guardar temporalmente los objetos prestados para que los prestatarios los recojan cuando quieran"
        },
        "deals": {
          "title": "Benefíciate de ofertas especiales",
          "description": "Las actividades de intercambio en un lugar de intercambio te permiten disfrutar de ciertas ventajas, como descuentos en los productos disponibles en el lugar"
        },
        "frequenting": {
          "title": "Indica a los demás miembros que frecuentas este lugar",
          "description": "Permite a los miembros ver los lugares de intercambio que frecuentas directamente en tu perfil"
        }
      }
    },
    "days": {
      "day1": "Lunes",
      "day2": "Martes",
      "day3": "Miércoles",
      "day4": "Jueves",
      "day5": "Viernes",
      "day6": "Sábado",
      "day7": "Domingo"
    },
    "place": {
      "open": "Abierto",
      "closed": "Cerrado",
      "until": "hasta {{time}}",
      "closedUntil": "hasta {{day}}",
      "members_one": "{{count}} miembro frecuenta este lugar",
      "members": "{{count}} miembros frecuentan este lugar",
      "membersTitle": "Miembros",
      "searchMembers": "Buscar por nombre",
      "noMembersFound": "No se encontraron miembros",
      "frequenting": "Lugar frecuentado",
      "joinButton": "Frecuento este lugar",
      "helpButton": "Ayuda sobre el lugar",
      "itinerary": "Itinerario",
      "share": "Compartir",
      "openingHoursTitle": "Horario de apertura",
      "openingHoursDisclaimer": "Los horarios pueden cambiar. Por favor, verifica directamente en el sitio web del comercio.",
      "viewHoursOnWebsite": "Ver horarios en el sitio",
      "joinTitle": "Frecuento este lugar",
      "join": {
        "profileTitle": "Mostrar este lugar en tu perfil público",
        "profileDesc": "Los demás usuarios podrán ver que frecuentas este lugar.",
        "offersTitle": "Haz disponibles tus ofertas a los miembros cerca del lugar",
        "offersDesc": "Tus ofertas serán visibles para los miembros que frecuentan este lugar."
      },
      "leaveTitle": "Dejar de frecuentar este lugar",
      "leave": {
        "profileDesc": "Este lugar ya no aparecerá en tu perfil público.",
        "offersDesc": "Tus ofertas ya no estarán disponibles para los miembros cerca de este lugar."
      },
      "confirm": "Confirmar",
      "noListingsOffer": "No hay ofertas disponibles",
      "noListingsRequest": "No hay necesidades",
      "noListingsOnSite": "No hay ofertas disponibles en el lugar",
      "noFrequentedPlaces": "No hay lugares de intercambio frecuentados"
    },
    "reviews": {
      "recentTitle": "Reseñas recientes",
      "noComments": "Sin comentarios",
      "defaultSubject": "Este miembro",
      "summaryTitle": "Resumen de recomendaciones",
      "howItWorks": "Cómo funcionan las evaluaciones",
      "topOpinions": "Lo que piensa la gente",
      "viewAllCount_zero": "No hay evaluaciones para esta oferta",
      "viewAllCount_one": "Ver 1 evaluación",
      "viewAllCount": "Ver las {{count}} evaluaciones",
      "recommended": "Recomendado",
      "notRecommended": "No recomendado",
      "loanLabel": "de préstamo",
      "unknownUser": "Miembro",
      "count": "{{count}} evaluaciones",
      "count_one": "{{count}} evaluación",
      "sortRecent": "Recientes",
      "pendingPrompt": {
        "title": "¿Tuviste una buena experiencia? ¡Compártela!",
        "bodyBorrowingStart": "Evalúa tu préstamo de ",
        "bodyLendingStart": "Evalúa tu préstamo de ",
        "bodyWith": " con {{name}} del ",
        "dateTo": "al",
        "button": "Dejar una evaluación"
      },
      "role": {
        "borrower": "Prestatario·a",
        "lender": "Prestamista"
      },
      "listingType": {
        "offer": "Oferta:",
        "request": "Necesidad:"
      },
      "listingFallback": "Anuncio",
      "labels": {
        "assetQuality": "Objeto conforme",
        "logisticsReliability": "Puntualidad",
        "communityTrust": "Cortesía"
      },
      "filters": {
        "all": "Todo ({{count}})",
        "positive": "Recomendado ({{count}})",
        "negative": "No recomendado ({{count}})",
        "borrower": "Del prestatario·a ({{count}})",
        "lender": "Del prestamista ({{count}})"
      },
      "empty": {
        "title": "{{name}} aún no tiene evaluaciones",
        "subtitle": "Las evaluaciones aparecerán aquí"
      },
      "sheet": {
        "title": "¿Cómo funcionan las evaluaciones?",
        "paragraph1": "En Partage Club, las evaluaciones ayudan a construir una comunidad de confianza para compartir de forma más segura.",
        "paragraph2": "Solo cuando un préstamo o un empréstito se finaliza, los miembros pueden evaluarse respondiendo preguntas temáticas y, si quieren, dejando un comentario y fotos.",
        "paragraph3": "Los resultados de las preguntas se muestran como etiquetas positivas, medias o negativas según las respuestas. Las evaluaciones se muestran en los perfiles y ofertas y son verificadas por nuestro equipo."
      },
      "actions": {
        "edit": "Editar evaluación",
        "delete": "Eliminar",
        "report": "Reportar evaluación",
        "deleteConfirmTitle": "¿Eliminar evaluación?",
        "deleteConfirmMessage": "Esta acción no se puede deshacer.",
        "deleteConfirmOk": "Eliminar",
        "deleteConfirmCancel": "Cancelar"
      }
    },
    "tabs": {
      "overview": "Resumen",
      "listings": "Anuncios",
      "reviewsShort": "Reseñas",
      "offers": "Ofertas",
      "requests": "Necesidades",
      "reviews": "Evaluaciones",
      "places": "Lugares",
      "available": "En el lugar",
      "regulars": "Habituales"
    }
  },
  "new": {
    "bonificationPrompt": "Las fotos claras y una buena descripción animan a pedir prestado.",
    "baconBanner": {
      "text": "Este proyecto piloto está reservado para los residentes de Beaconsfield. <strong>¡Gracias por participar!</strong>",
      "linkText": "Consulta los consejos prácticos",
      "link": "https://www.beaconsfield.ca/fr/culture-et-loisirs/loisirs-et-vie-communautaire/partage-club"
    },
    "categorySection": {
      "primary": {
        "subtitle": "Selecciona una categoría",
        "title": "Categoría",
        "placeholder": "Categorías"
      }
    },
    "dateSection": {
      "title": "Fechas",
      "titleOne": "Fecha",
      "flexibleDates": "¿Son flexibles las fechas?",
      "endBeforeStart": "La fecha de fin debe ser posterior o igual a la fecha de inicio."
    },
    "urgentSection": {
      "urgentRequiresExpirable": "La opción Urgente está reservada a las materias perecederas."
    },
    "duplicatesStepper": {
      "title": "Copias adicionales",
      "text": "Crea copias adicionales de esta oferta.",
      "increment": "Aumentar el número de copias",
      "decrement": "Disminuir el número de copias"
    },
    "generalSection": {
      "addPicture": "Agregar una foto",
      "addPictureLater": "Agregar la foto más tarde",
      "addPictures": "Agregar fotos",
      "coverPhoto": "Portada",
      "makeCover": "Hacer portada",
      "pictureCount": "{{count}}/{{max}} fotos",
      "oneOrMany": {
        "many": {
          "title": "Oferta múltiple",
          "subtext": "Publica varios objetos con un clic, sin foto ni reflexión previa. ¡Es simple y rápido!"
        },
        "one": {
          "title": "Oferta individual",
          "subtext": "Publica tu objeto tomándole una foto."
        }
      },
      "publishOffer": "Publicar una oferta",
      "publishRequest": "Publicar una necesidad",
      "title": "¿Oferta o necesidad?",
      "addPhotosCompact": "Añadir fotos"
    },
    "multiImagePicker": {
      "addImage": "Agregar una foto",
      "addImageHint": "Agrega otra foto a tu anuncio",
      "removeImage": "Eliminar foto",
      "removeImageHint": "Quita esta foto de tu anuncio",
      "coverHint": "La primera foto será tu portada",
      "emptyHint": "Agrega hasta {{max}} fotos. Las fotos claras y bien iluminadas se prestan más.",
      "uploading": "Cargando en progreso..."
    },
    "headerTitle": "Crear un anuncio",
    "discardChanges": {
      "title": "¿Salir de la creación del anuncio?",
      "description": "Tu anuncio no se ha publicado. Si sales ahora, se perderá el contenido que ingresaste.",
      "keepEditing": "Seguir editando",
      "leave": "Salir"
    },
    "bulk": {
      "headerTitle": "Crear varias ofertas",
      "progress": {
        "accessibility": "Paso {{current}} de {{total}}"
      },
      "steps": {
        "select": {
          "eyebrow": "Fotos",
          "title": "Agrega una foto por objeto",
          "subtitle": "Elige todos los objetos que quieres publicar en esta sesión."
        },
        "confirm": {
          "eyebrow": "Revisión",
          "title": "Confirma las fotos",
          "subtitle": "Revisa el orden y elimina lo que no quieras publicar."
        },
        "generating": {
          "eyebrow": "Preparando ofertas",
          "title": "Generando tus ofertas",
          "subtitle": "Mantén esta pantalla abierta mientras preparamos un borrador por foto."
        },
        "review": {
          "eyebrow": "Publicación",
          "title": "Revisa cada oferta",
          "subtitle": "Edita el título o la descripción, luego guarda y continúa con el siguiente borrador."
        },
        "complete": {
          "eyebrow": "Listo",
          "title": "Creación múltiple terminada",
          "subtitle": "Tus ofertas guardadas ahora aparecen como anuncios normales."
        },
        "visibility": {
          "eyebrow": "Visibilidad",
          "title": "¿Quién puede ver estas ofertas?",
          "subtitle": "Elige las direcciones y los grupos para todas las ofertas creadas en esta sesión."
        }
      },
      "photoSelection": {
        "addPhotos": "Agregar fotos",
        "selectedCount": "{{count}}/{{max}} seleccionadas",
        "reorderHint": "Usa las flechas para ordenar",
        "continue": "Revisar fotos",
        "generate": "Generar borradores",
        "photoNumber": "Foto {{number}}",
        "firstHint": "Se procesará primero",
        "eachPhotoHint": "Se creará un borrador",
        "moveLeft": "Mover foto antes",
        "moveRight": "Mover foto después",
        "remove": "Eliminar foto"
      },
      "confirmation": {
        "readyTitle": "Listo para generar",
        "readyDescription": "{{count}} fotos se subirán y analizarán.",
        "confirm": "Generar borradores"
      },
      "camera": {
        "capture": "Tomar foto",
        "close": "Cerrar cámara",
        "counter": "{{count}}/{{max}} fotos",
        "done": "Terminar",
        "limitReached": "Alcanzaste el límite de {{max}} fotos",
        "permissionAction": "Permitir cámara",
        "permissionDescription": "Se necesita acceso a la cámara para tomar varias fotos de objetos en una misma sesión.",
        "permissionTitle": "Se necesita acceso a la cámara",
        "remaining_one": "{{count}} fotos restantes",
        "remaining_other": "{{count}} fotos restantes",
        "removePhoto": "Eliminar foto tomada",
        "library": "Galería",
        "hint": "Una foto, un objeto",
        "draftHint": "Toma tus fotos y pulsa Terminar.",
        "finishHint": "Preparar borradores a partir de las fotos seleccionadas",
        "settings": "Abrir ajustes",
        "removePhotoNumber": "Eliminar foto {{number}}"
      },
      "generation": {
        "progress": "{{done}} de {{total}} borradores listos",
        "progressPercent": "{{percent}} % completado",
        "detail": "{{queued}} en espera, {{generating}} analizando, {{failed}} fallidos",
        "retryFailed": "Reintentar fallidos",
        "uploading": "Subiendo tus fotos…",
        "reviewHint": "Nada se publica sin tu aprobación.",
        "failed_one": "{{count}} foto necesita otro intento.",
        "failed_other": "{{count}} fotos necesitan otro intento.",
        "title": "De fotos a ofertas",
        "preparing": "Preparando tus ofertas…"
      },
      "review": {
        "remaining": "{{remaining}} restantes · {{saved}}/{{total}} guardados",
        "generationFailedTitle": "No se pudo analizar esta foto",
        "generationFailedDescription": "Reintenta esta foto o sáltala por ahora.",
        "saveFailedTitle": "Esta oferta no se guardó",
        "saveFailedDescription": "Edita el título o la descripción e inténtalo de nuevo.",
        "retry": "Reintentar",
        "accept": "Publicar",
        "reject": "Saltar",
        "regenerate": "Regenerar",
        "skip": "Saltar",
        "acceptSwipe": "Publicar",
        "rejectSwipe": "Saltar",
        "swipeHint": "← Saltar · Publicar →",
        "looksGood": "Está bien",
        "noDraftsTitle": "No hay borradores por revisar",
        "noDraftsDescription": "Todo lo generado en esta sesión se guardó o se saltó.",
        "finish": "Terminar",
        "edit": "Ver y editar detalles",
        "doneEditing": "Terminar edición",
        "untitled": "Agregar un título",
        "titleHint": "El título debe tener al menos 3 caracteres.",
        "title": "Revisa tus ofertas",
        "position": "{{current}} de {{total}}",
        "editTitle": "Editar detalles",
        "editHint": "Revisa los detalles. Tus cambios solo se publicarán cuando pulses Publicar."
      },
      "completion": {
        "title": "¡Gracias por compartir!",
        "description": "{{saved}} guardadas, {{skipped}} rechazadas",
        "close": "Terminar",
        "toast": "Ofertas publicadas",
        "emptyTitle": "Todas las fotos revisadas",
        "published_zero": "Ninguna oferta publicada.",
        "published_one": "{{count}} oferta creada.",
        "published_other": "{{count}} ofertas creadas.",
        "skipped_one": "{{count}} foto omitida.",
        "skipped_other": "{{count}} fotos omitidas."
      },
      "cancel": {
        "title": "¿Cancelar la creación múltiple?",
        "description": "Las fotos de borradores no guardados de esta sesión se eliminarán.",
        "keepWorking": "Seguir trabajando",
        "confirm": "Cancelar sesión"
      },
      "common": {
        "back": "Volver",
        "cancel": "Cancelar"
      },
      "errors": {
        "noPhotos": "Agrega al menos una foto antes de continuar.",
        "noVisibility": "Elige al menos una dirección o grupo antes de crear ofertas."
      },
      "visibility": {
        "confirm": "Guardar visibilidad",
        "privateHint": "Todas las opciones para compartir están desactivadas. Estas ofertas serán privadas."
      }
    },
    "itemInformationSection": {
      "new": "Nuevo",
      "title": "Información",
      "nameFieldLabel": "Nombre del objeto",
      "nameFieldPlaceholder": "Ej: Cortadora de césped",
      "serviceNameFieldLabel": "Título",
      "serviceNameFieldPlaceholder": "Ej: Rastrillar el terreno, consejos de jardinería…",
      "descriptionFieldLabel": "Descripción",
      "descriptionFieldPlaceholder": {
        "offer": "Agrega detalles útiles: dimensiones, marca, peso… ¡Cuanto más digas, más fácil será para los miembros entender tu oferta!",
        "request": "Agrega detalles útiles: dimensiones, marca, peso… ¡Cuanto más digas, más fácil será para los miembros entender tu necesidad!"
      },
      "clearDescription": "Borrar la descripción",
      "clearDescriptionAction": "Borrar todo",
      "descriptionFieldHelperText": "¡Cuanto más digas, más fácil será para los miembros entender tu oferta o tu necesidad!",
      "serviceDescriptionFieldPlaceholder": "Agrega detalles útiles para la comprensión del servicio solicitado. ¡Cuanto más digas, más fácil será para los miembros entender tu necesidad!",
      "aiGenerate": {
        "button": "Generar",
        "promptTitle": "Relleno automático",
        "promptDescription": "Un título y una descripción listos para editar.",
        "skip": "No gracias",
        "loading": "Analizando la imagen",
        "error": "No se pudo analizar la imagen. Inténtalo de nuevo.",
        "rateLimitError": "Demasiados intentos. Inténtalo más tarde."
      },
      "priceFieldLabel": "Precio",
      "valueFieldLabel": "Valor de mercado",
      "valueFieldPlaceholder": "Precio unitario",
      "transactionMode": {
        "sell": "Vendo",
        "lend": "Presto",
        "give": "Doy"
      },
      "requestTransactionMode": {
        "sell": "💵 Comprar",
        "lend": "🫴 Pedir prestado",
        "give": "🎁 Recuperar"
      },
      "assistant": {
        "knowMore": {
          "howItWorks": "¿Cómo funciona?",
          "title": "Asistente inteligente",
          "text1": "El asistente inteligente <strong>coincide</strong> con tus necesidades con <strong>ofertas relevantes</strong> y <strong>contacta automáticamente</strong> a posibles prestamistas basado en tu <strong>descripción</strong> y tu <strong>distancia deseada</strong>.",
          "text2": "Para ayudar al asistente inteligente a encontrar las mejores coincidencias, agrega tantos <strong>detalles útiles</strong> como sea posible en la descripción.",
          "text3": "Si no hay ofertas relevantes en los primeros días, no te preocupes. El asistente inteligente sigue vigilando por <strong>nuevas ofertas potenciales</strong> cuando se publican."
        },
        "optOutBanner": {
          "title": "Contactar automáticamente a los miembros que tienen lo que necesitas",
          "description": "Personaliza el mensaje enviado antes de publicar"
        },
        "firstCreated": {
          "title": "¡Vamos!",
          "text1": "¡Genial, el asistente inteligente ha comenzado a buscar ofertas relevantes! Serás <strong>notificado</strong> cuando los posibles prestamistas hayan <strong>respondido a tu mensaje</strong>.",
          "text2": "Esto puede tomar unos minutos",
          "text3": "Mientras tanto, <strong>encuentra</strong> el asistente inteligente directamente en los <strong>detalles de tu necesidad</strong>."
        }
      }
    },
    "chooseAutomaticMessage": {
      "text1": "Tu mensaje automático",
      "text2": "Siempre puedes editarlo más tarde",
      "automaticMessageLabel": "✏️ Personaliza el mensaje que será enviado:",
      "confirmButton": "Confirmar",
      "reset": "Restablecer",
      "defaultAutomaticMessage": {
        "greeting": "¡Hola {{firstName}}! Estoy buscando el siguiente artículo, y el sistema de recomendaciones cree que podrías ayudarme:\n\n",
        "itemWithDescription": "\"{{itemName}}: {{description}}\"",
        "itemWithoutDescription": "\"{{itemName}}\"",
        "dateBoth": "\n\nPara el período del {{startDay}} {{startMonth}} al {{endDay}} {{endMonth}}",
        "dateStartOnly": "\n\nPara el período a partir del {{startDay}} {{startMonth}}",
        "dateEndOnly": "\n\nPara el período hasta el {{endDay}} {{endMonth}}"
      },
      "automaticMessageRequired": "El mensaje no puede estar vacío."
    },
    "listingCreatedToast": {
      "text": {
        "offer": "Para modificarla, ve a Intercambios > Mis ofertas",
        "request": "Para modificarla, ve a Intercambios > Mis necesidades"
      },
      "title": "Anuncio publicado"
    },
    "locationSection": {
      "addressFieldSubtitle": "Basado en la dirección de tu domicilio",
      "addressFieldSubtitleCustom": "Basado en la dirección de {{clubName}}",
      "addressFieldTitle": "Club del barrio",
      "groupFieldTitle": "Club {{clubName}}",
      "oneGroupFieldTitle": "Visibilidad",
      "oneGroupFieldHelp": "¿Este anuncio debería ser visible para los otros miembros?",
      "invisible": "Tu anuncio ya no se mostrará a los otros usuarios.",
      "addressesTitle": "Direcciones",
      "clubsTitle": "Clubs asociados",
      "title": "Visible para",
      "makePrivate": "Hacer privada",
      "privateVisibility": "Visibilidad privada",
      "shareWithAll": "Compartir con todos"
    },
    "primaryButtonPostOffer": "Publicar la oferta",
    "primaryButtonPostOfferMultiple": "Publicar {{count}} ofertas",
    "primaryButtonPostRequest": "Publicar la necesidad",
    "primaryButtonConfirmRequest": "Confirmar",
    "secondaryButtonText": "Cancelar",
    "prompt": {
      "type": {
        "title": "¿Qué deseas publicar?",
        "offer": "Ofertas",
        "request": "Necesidades",
        "post": "Compartir una experiencia"
      },
      "post": {
        "title": "¿Qué intercambio quieres compartir?",
        "loading": "Cargando tus intercambios...",
        "empty": "No tienes ningún intercambio completado disponible para una nueva publicación."
      },
      "offer": {
        "title": "Ofertas",
        "one": "Prestar un objeto específico",
        "perishable": "Oferta perecedera",
        "donation": "Ofrecer un objeto para donar",
        "bulk": "Crear varias ofertas desde fotos",
        "many": "Elegir entre objetos sugeridos"
      },
      "request": {
        "title": "Necesidades",
        "one": "Tomar prestado un objeto",
        "donation": "Solicitar una donación",
        "service": "Solicitar un servicio"
      },
      "serviceRequest": {
        "title": "Selecciona una categoría",
        "missing": {
          "title": "¿No encuentras lo que buscas?",
          "text": "Envíanos tu solicitud y evaluaremos si puede agregarse a la lista próximamente.",
          "ctaButton": "Enviar",
          "chatPrompt": "Hola {{name}},\n\nNo dudes en <strong>comunicarnos la necesidad de servicio</strong> que te gustaría encontrar en la aplicación.\n\nSe la transmitiremos a la ciudad de Beaconsfield para que determine si podemos agregarla."
        }
      },
      "publishAnObject": "Publier un objet"
    },
    "timeSection": {
      "title": "Horas",
      "labelStart": "Inicio",
      "labelEnd": "Fin"
    },
    "addressSection": {
      "title": "Dirección"
    },
    "bonificationDetailsPrompt": "Una buena descripción anima a pedir prestado."
  },
  "notification-explainer": {
    "headerTitle": "Notificaciones",
    "context": {
      "chat": {
        "subtitle": "Recibe una notificación en cuanto esta persona te responda.",
        "title": "¿Te gustaría saber cuando {{name}} te responde?"
      },
      "listing": {
        "subtitle": "Recibe una notificación en cuanto alguien te contacte.",
        "title": "¿Te gustaría saber cuando alguien te contacta?"
      }
    },
    "primaryButtonText": "Sí, notificarme",
    "secondaryButtonText": "Ahora no"
  },
  "notification-super-changed": {
    "headerTitle": "Super Compartidor"
  },
  "notification-warn": {
    "authorize": "Autorizar",
    "later": "Ahora no",
    "subtitle": "Recibe una notificación en cuanto alguien te escriba para tomar prestados tus objetos o responder a tu necesidad.",
    "title": "¡Activa las notificaciones para mantenerte informado!"
  },
  "notifications": {
    "donationEndsSoonTitle": "{{listingName}} expira en {{numDays}} días",
    "donationEndsSoonMessage": "Cambia la fecha límite, o elimínalo si ya no es necesario.",
    "joinCoCreatorTitle": "¡Mejora la aplicación con nosotros!",
    "joinCoCreatorMessage": "Únete a nuestro grupo de cocreadores en Facebook.",
    "emptyState": "No tienes ninguna notificación",
    "favouriteReceived": "<strong>{{userName}}</strong> agregó tu anuncio a sus favoritos.",
    "favouriteReceivedOffer": "<strong>{{userName}}</strong> agregó tu oferta a sus favoritos.",
    "favouriteReceivedRequest": "<strong>{{userName}}</strong> agregó tu necesidad a sus favoritos.",
    "futureReminder": "Devolución en {{days}} día(s)",
    "futureReminderSale": "Venta prevista en {{days}} día(s)",
    "impactLevel": "Tu nivel actual: <strong>{{level}}</strong>!",
    "impactLevelCelebration": {
      "sharer1": {
        "message": "🥳 ¡Bravo! Sigue haciendo crecer tu impacto positivo.",
        "title": "¡Pasaste al nivel <strong>Compartidor</strong>!"
      },
      "sharer23": {
        "message": "🎉 Te faltan <strong>{{numLeft}}</strong> intercambios para el nivel máximo. ¡Sigue un préstamo a la vez!",
        "title": "¡Bravo!"
      },
      "sharer4": {
        "message": "💪🏻 <strong>Un</strong> intercambio más y accederás al nivel más alto: <strong>Super Compartidor</strong>.",
        "title": "¡Casi llegas!"
      },
      "superSharer": {
        "message": "¡Bravo! Con cada intercambio, haces crecer tu impacto para un futuro más verde. ¡Ve a ver tu impacto! 💚",
        "title": "¡Eres un <strong>Super Compartidor</strong>!"
      }
    },
    "impactLevelExplorerMessage": "Comienza tu experiencia en Partage Club. Publica un objeto para hacer crecer tu impacto y pasar al siguiente nivel.",
    "impactLevelMessage": "¡Bravo! Ve cómo puedes hacer crecer tu impacto y avanzar en tu nivel.",
    "introModal": {
      "intro": {
        "title": "Bienvenido al Club",
        "body": "¡Descubre el Partage Club!"
      },
      "b2c_paid": {
        "title": "¡Bienvenido al Club!",
        "body": "Como miembro oficial del Partage Club, tu suscripción te da acceso a nuevas ventajas."
      },
      "b2b_activated": {
        "title": "¡Bienvenido al Club!",
        "body": "Gracias a {{groupName}}, tu suscripción es gratuita."
      },
      "newly_insured": {
        "title": "¡Partage Club es responsable!",
        "body": "Gracias a tu suscripción, si ocurre algún daño a tus objetos por un valor de 25 $ o más durante un préstamo, nos comprometemos a indemnizarte hasta 300 $ al año."
      },
      "custom": {
        "support": {
          "title": "¿Un problema? ¡Contáctanos!",
          "body": "Nuestro equipo está aquí para ayudarte rápidamente."
        }
      }
    },
    "lateLoan": "¿Se devolvió el objeto?",
    "lateLoanService": "¿Servicio prestado?",
    "lateLoanDonation": "¿Donación recogida?",
    "lateLoanSale": "¿Venta completada?",
    "newListingPostedSubscribed": "<strong>{{userName}}</strong> ({{distance}}) publicó una oferta para un objeto que podría interesarte: {{itemName}}",
    "newReferralSubscribed": {
      "numLeftMessage": "¡Te faltan {{numLeft}} registros para ganar una suscripción anual gratuita!",
      "receivedPrizeMessage": "¡Bravo! 🥳 ¡Acabas de ganar una suscripción anual gratuita en Partage Club!",
      "receivedMonthPrizeMessage": "¡Bravo! 🥳 ¡Acabas de ganar un mes gratis en Partage Club!",
      "referredUserRegisteredMessage": "Has invitado a {{numInvited}} personas.\n¡Cuanto más invitas, más contribuyes a hacer crecer esta cadena de generosidad!",
      "title": "{{firstName}} se registró con tu código de invitación"
    },
    "onTime": "Devolución prevista hoy",
    "onTimeService": "Servicio previsto para hoy",
    "onTimeDonation": "Donación recogida hoy",
    "onTimeSale": "Venta prevista hoy",
    "superChanged": {
      "initialGained": {
        "title": "¡Felicitaciones!",
        "body": "Ahora eres Super Compartidor."
      },
      "initialLost": {
        "title": "Perdiste tu insignia de Super Compartidor 😢",
        "body": "Consulta los nuevos criterios para recuperarla."
      },
      "initialKept": {
        "title": "¡Felicitaciones!",
        "body": "Conservas tu insignia de Super Compartidor, incluso con los nuevos criterios."
      },
      "gained": {
        "title": "¡Felicitaciones!",
        "body": "Ahora eres Super Compartidor."
      },
      "lost": {
        "title": "Perdiste tu insignia de Super Compartidor 😢",
        "body": "Descubre cómo recuperarla en poco tiempo."
      }
    },
    "rate": {
      "borrower": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros del Partage Club.",
        "title": "¿Cómo fue tu experiencia con {{lenderName}}?"
      },
      "lender": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros del Partage Club.",
        "title": "¿Cómo fue tu experiencia con {{borrowerName}}?"
      }
    },
    "ratingReceived": {
      "cta": "Ver evaluaciones"
    },
    "trustAdded": {
      "title": "Nueva recomendación",
      "message": "Un miembro te ha recomendado."
    },
    "savedMoney": {
      "title": {
        "borrower": "¡Ahorraste!",
        "lender": "¡Hiciste ahorrar!"
      },
      "message": {
        "borrower": "Ahorraste <strong>{{amount}} $</strong> tomando prestado {{item}}.",
        "lender": "Ayudaste a un miembro a ahorrar <strong>{{amount}} $</strong> prestando {{item}}."
      }
    },
    "savedMoneyService": {
      "title": {
        "borrower": "¡Ahorraste!",
        "lender": "¡Hiciste ahorrar!"
      },
      "message": {
        "borrower": "Ahorraste <strong>{{amount}} $</strong> al pedir ayuda para {{item}}.",
        "lender": "Ayudaste a un miembro a ahorrar <strong>{{amount}} $</strong> ofreciendo ayuda para {{item}}."
      }
    },
    "savedMoneyDonation": {
      "title": {
        "borrower": "¡Ahorraste!",
        "lender": "¡Hiciste ahorrar!"
      },
      "message": {
        "borrower": "Ahorraste <strong>{{amount}} $</strong> al recibir una donación para {{item}}.",
        "lender": "Ayudaste a un miembro a ahorrar <strong>{{amount}} $</strong> ofreciéndole {{item}}."
      }
    },
    "loanReciprocity": {
      "title": "Tu turno de ayudar 🤝",
      "message": "Publica los objetos que uses poco y compártelos con tus vecinos."
    },
    "tabBarLabel": "Notificaciones",
    "closeButtonAccessibilityLabel": "Cerrar notificaciones",
    "welcome": "¡Bienvenido al Partage Club!",
    "welcomeMessage": "¡Gracias por confiar en nosotros!",
    "trustAdded": {
      "title": "¡{{name}} confía en ti! 🎉",
      "message": "Te ha añadido a su círculo de confianza. ¿Quieres hacer lo mismo?",
      "add": "Añadir al círculo de confianza",
      "decline": "No, gracias",
      "viewProfile": "Ver el perfil del miembro"
    }
  },
  "notifications-setting": {
    "title": "Notificaciones",
    "chatTitle": "Mensajes",
    "chatHelp": "Recibe una notificación cuando un miembro te envíe un mensaje privado, por ejemplo, para pedirte prestado un objeto.",
    "conciergerieTitle": "Asistente Inteligente",
    "conciergerieHelp": "Permite que el asistente inteligente te contacte cuando tus objetos puedan ayudar a cubrir la necesidad de un miembro.",
    "conciergerieToggle": "Permitir contactos del asistente inteligente",
    "needTitle": "Necesidades",
    "needHelp": "Recibe una notificación cuando los miembros publiquen nuevas necesidades, para ver si puedes ayudar.",
    "weeklyOffersTitle": "Novedades para tomar prestado",
    "weeklyOffersHelp": "Recibe una notificación cada semana con las nuevas ofertas disponibles cerca de ti.",
    "urgentOffersTitle": "Ofertas urgentes",
    "urgentOffersHelp": "Recibe una notificación cuando los miembros publiquen nuevas ofertas de productos perecederos que deben recogerse pronto.",
    "interestAlertsTitle": "Alertas sobre mis intereses",
    "interestAlertsHelp": "Recibe una notificación cuando se publique una nueva oferta en una categoría que sigues.",
    "pushNotif": "Notificaciones push",
    "email": "Correos electrónicos",
    "sms": "SMS"
  },
  "offerAvailability": {
    "conflictWhen": "Reservado el <strong>{{dates}}</strong>",
    "conflictsTitle": "Conflicto de reserva",
    "conflictsInformationText": "Algunos objetos <strong>ya están prestados</strong> para estas fechas. Puedes continuar la reserva, pero contacta al prestatario luego para resolver este/estos conflicto(s).",
    "informationText": "Reserva tus objetos para que no estén disponibles para préstamo durante los días seleccionados.",
    "informationTextDonation": "Puedes elegir una fecha límite para indicar que te gustaría que la recogida se realice antes de esa fecha.",
    "refrainPopup": {
      "hi": "Estimado festival,",
      "text": {
        "lender": {
          "before": "No olvides reservar tus fechas de festival y planificar tus días de montaje y desmontaje durante tu reserva.",
          "after": "No olvides reservar tus fechas de festival y planificar tus días de montaje y desmontaje."
        },
        "borrower": "No olvides planificar tus días de montaje y desmontaje durante tu préstamo."
      },
      "subtext": {
        "lender": {
          "before": "Reserva el número de días completos en los que el o los objetos no estarán disponibles.",
          "after": "Reserva el número de días completos en los que el objeto no está disponible."
        },
        "borrower": "Propón el número de días completos en los que el objeto estará prestado."
      },
      "continue": "Entendido",
      "reserveDates": "Reservar las fechas",
      "later": "Más tarde"
    },
    "saveButton": "Guardar",
    "title": "Reservas de la oferta",
    "titleMany": "Reservas para {{count}} ofertas",
    "titleDonation": "Fecha límite",
    "titleSell": "Fecha de venta"
  },
  "offers": {
    "empty": {
      "firstLine": "Todas las ofertas que publiques en la comunidad aparecerán aquí.",
      "primaryButtonText": "Publicar una oferta",
      "secondLine": "Aún no has publicado ninguna oferta."
    },
    "title": "Mis anuncios"
  },
  "onboarding": {
    "confirm": "Confirmar",
    "nextStep": "Continuar"
  },
  "onboardingIntro": {
    "title": "¿Listo para compartir?",
    "text": "Crea tu cuenta (¡es rápido, lo prometemos!) y empieza a compartir con tu comunidad."
  },
  "one-channel": {
    "add": "Agregar",
    "loadingMessages": "Cargando mensajes...",
    "supportReplyPreparing": "Preparando una respuesta...",
    "dismissConversation": "Cerrar la conversación",
    "messageDateSeparator": {
      "todayAt": "Hoy a las {{time}}",
      "yesterdayAt": "Ayer a las {{time}}",
      "dateAt": "{{date}} a las {{time}}"
    },
    "minimizeConversation": "Minimizar conversación",
    "noChannelSelected": "Aucune conversation sélectionnée",
    "titleUser": "Conversación con {{user}}",
    "titleListing": "Conversación con {{user}} - Tema: {{listing}}",
    "addToCalendar": {
      "event": {
        "buyItem": "Compra de {{item}} a {{name}}",
        "donateItem": "Donación de {{item}} a {{name}}",
        "receiveDonation": "Donación de {{item}} por {{name}}",
        "giveService": "Servicio a prestar a {{name}}: {{item}}",
        "receiveService": "Servicio a recibir de {{name}}: {{item}}",
        "sellItem": "Venta de {{item}} a {{name}}",
        "borrowObject": {
          "start": "Inicio del préstamo de {{name}} para {{item}}",
          "end": "Devolución del préstamo a {{name}} para {{item}}"
        },
        "lendObject": {
          "start": "Inicio del préstamo a {{name}} para {{item}}",
          "end": "Devolución del préstamo de {{name}} para {{item}}"
        }
      },
      "modal": {
        "always": "Sí, para todos los préstamos",
        "description": "¿Deseas agregar estas fechas en el calendario de tu teléfono?",
        "discard": "No, no esta vez",
        "never": "No, nunca",
        "once": "Sí, solo una vez",
        "title": "Agregar al calendario"
      }
    },
    "beaconsfieldNewLoanWarning": "Hola {{name}},\n\n¡En Beaconsfield, el intercambio se hace con respeto, confianza… y buen humor!\nAlgunos consejos para una experiencia agradable y segura:\n- Reúnanse en un lugar público si eso les da más confianza (ej.: Biblioteca, Ayuntamiento).\n- Comparte solo la información esencial para hacer posible el intercambio (ej.: número de teléfono, dirección).\n\n¡Buen intercambio!\n\nY sobre todo, aprovecha para crear lazos, a tu ritmo.",
    "firstLoanPrompt": {
      "title": "¡Felicidades por tu primer préstamo!",
      "savedAmount": "¡Felicidades, has ahorrado <highlight>{{amount}}</highlight>!",
      "description": "¡El primer préstamo es gratis!",
      "subscribeTitle": "Para seguir pidiendo prestado",
      "subscribeDescription": "Para seguir pidiendo prestado sin límites, suscríbete ahora y disfruta de <strong>¡un 25 % de descuento!</strong>",
      "subscribeDescriptionWithDeadline": "Suscríbete y disfruta de <strong>un 25 % de descuento hasta el {{date}}.</strong>",
      "cta": "Suscribirme",
      "discountDeadlineNote": "Válido hasta el {{date}}.",
      "note": "Si se cancela la reserva, tu préstamo gratuito volverá a estar disponible",
      "lending": {
        "title": "¡Felicidades por tu primer préstamo!",
        "description": "Disfruta de la cobertura para objetos compartidos",
        "subscribeDescription": "Suscríbete ahora y disfruta de <strong>¡un 25 % de descuento!</strong>"
      }
    },
    "banner": {
      "listingDeleted": "Anuncio eliminado",
      "oneDate": "Proponer una fecha",
      "donationDate": "Proponer una fecha de recogida",
      "saleDate": "Proponer una fecha de recogida",
      "twoDatesLender": "Proponer fechas",
      "twoDatesBorrower": "Ver disponibilidad",
      "borrowerCreditExhausted": "Esta persona está en período de prueba gratuito y ya no puede pedir prestado.",
      "manageLoan": {
        "lender": "Gestionar el préstamo",
        "borrower": "Gestionar el préstamo recibido"
      },
      "manageSale": {
        "lender": "Gestionar la venta",
        "borrower": "Gestionar la venta"
      },
      "manageParticipations": {
        "lender": "Gestionar la inscripción",
        "borrower": "Gestionar la solicitud de servicio"
      },
      "manageService": {
        "lender": "Gestionar el servicio",
        "borrower": "Gestionar la solicitud de servicio"
      },
      "manageDonation": {
        "lender": "Gestionar la recogida de la donación",
        "borrower": "Gestionar la recogida de la donación"
      },
      "memberNeed": "Necesidad de un miembro",
      "memberOffer": "Oferta de un miembro",
      "unavailable": {
        "lender": {
          "offer": "Ya prestado",
          "request": "Ya encontrado"
        },
        "borrower": {
          "offer": "Ya tomado prestado",
          "request": "Ya encontrado"
        }
      },
      "viewListing": "Ver el anuncio",
      "yourNeed": "Este miembro puede ayudarte",
      "yourOffer": "Tu oferta"
    },
    "levelModal": {
      "primaryButtonText": "Ver mi impacto",
      "secondaryButtonText": "Cerrar",
      "sharer1": {
        "message": "¡Aumentaste tu impacto realizando tu primer préstamo! Ahora accedes a un nivel superior: <strong>Compartidor</strong>.",
        "title": "¡Bravo!"
      },
      "sharer23": {
        "message": "Te faltan <strong>{{numLeft}}</strong> intercambios para el nivel máximo. ¡Sigue un préstamo a la vez!",
        "title": "¡Bravo!"
      },
      "sharer4": {
        "message": "<strong>Un</strong> intercambio más y accederás al nivel más alto: <strong>Super Compartidor</strong>.",
        "title": "¡Casi llegas!"
      },
      "superSharer": {
        "message": "¡Aumentaste tu impacto realizando 5 intercambios! Ahora accedes al nivel máximo: <strong>Super Compartidor</strong>, un ejemplo a seguir en Partage Club.\n\n¡Bravo! Con cada intercambio, haces crecer tu impacto para un futuro más verde.",
        "title": "¡Eres un Super Compartidor!"
      }
    },
    "loanManagement": {
      "cta": {
        "late": "Confirmar la devolución",
        "returned": "Confirmar la devolución"
      },
      "body": {
        "late": {
          "lender": "El período de préstamo ha vencido. Puedes contactar a {{name}} para organizar un momento en que te devuelva el objeto. Cuando hayas recuperado el objeto, usa el botón de abajo.",
          "borrower": "El período de préstamo ha vencido. Puedes contactar a {{name}} para organizar un momento y devolver el objeto lo antes posible. Cuando hayas devuelto el objeto, usa el botón de abajo."
        },
        "returned": {
          "lender": "{{name}} indicó haber devuelto el objeto. ¿Puedes confirmarlo?",
          "borrower": "En espera de confirmación de {{name}}."
        }
      },
      "title": {
        "scheduled": "Préstamo programado",
        "late": "Este préstamo está atrasado",
        "returned": {
          "lender": "¿Se devolvió el objeto?",
          "borrower": "Devolviste este objeto"
        },
        "past": "Este préstamo ha finalizado"
      },
      "status": "Estado"
    },
    "saleManagement": {
      "cta": {
        "ongoing": {
          "borrower": "Confirmar la recepción",
          "lender": "Confirmar la venta"
        },
        "late": {
          "borrower": "Confirmar la recepción",
          "lender": "Confirmar la venta"
        },
        "returned": {
          "lender": "Confirmar la venta"
        }
      },
      "body": {
        "ongoing": {
          "borrower": "Ha llegado la fecha prevista para la venta. Cuando hayas recibido el objeto de {{name}}, confirma la recepción con el botón de abajo.",
          "lender": "Ha llegado la fecha prevista para la venta. Cuando hayas entregado el objeto a {{name}}, confirma la venta con el botón de abajo."
        },
        "late": {
          "borrower": "La fecha prevista para la venta ha pasado. Puedes contactar a {{name}} para organizar la recogida. Cuando hayas recibido el objeto, confirma la recepción con el botón de abajo.",
          "lender": "La fecha prevista para la venta ha pasado. Puedes contactar a {{name}} para organizar la recogida. Cuando hayas entregado el objeto, confirma la venta con el botón de abajo."
        },
        "returned": {
          "borrower": "Confirmaste que recibiste el objeto. En espera de la confirmación de {{name}}.",
          "lender": "{{name}} confirmó que recibió el objeto. Confirma la venta para finalizarla."
        }
      },
      "title": {
        "scheduled": "Venta programada",
        "ongoing": "La venta está prevista para hoy",
        "late": "Esta venta está atrasada",
        "returned": {
          "borrower": "Recepción confirmada",
          "lender": "El objeto fue recibido"
        },
        "past": "Esta venta ha finalizado"
      },
      "status": "Estado"
    },
    "serviceManagement": {
      "cta": {
        "late": "Confirmar servicio prestado",
        "returned": "Confirmar servicio prestado"
      },
      "body": {
        "late": {
          "lender": "El período previsto para el servicio ha vencido. Puedes contactar a {{name}} para organizar un nuevo momento para realizarlo. Una vez prestado el servicio, usa el botón de abajo.",
          "borrower": "El período previsto para el servicio ha vencido. Puedes contactar a {{name}} para organizar un nuevo momento lo antes posible. Una vez completado el servicio, usa el botón de abajo."
        },
        "returned": {
          "lender": "{{name}} indicó que el servicio fue prestado. ¿Puedes confirmarlo?",
          "borrower": "En espera de confirmación de {{name}}."
        }
      },
      "title": {
        "late": "Este servicio está atrasado",
        "returned": {
          "lender": "¿Se prestó el servicio?",
          "borrower": "Recibiste este servicio"
        },
        "past": "El servicio fue prestado con éxito"
      },
      "status": "Estado"
    },
    "donationManagement": {
      "cta": {
        "late": "Confirmar la donación",
        "returned": "Confirmar la donación"
      },
      "body": {
        "late": {
          "lender": "La fecha prevista para la recogida de la donación ha pasado. Puedes contactar a {{name}} para organizar un nuevo momento. Una vez realizada la recogida, usa el botón de abajo.",
          "borrower": "La fecha prevista para la recogida de la donación ha pasado. Puedes contactar a {{name}} para organizar un nuevo momento. Una vez realizada la recogida, usa el botón de abajo."
        },
        "returned": {
          "lender": "{{name}} indicó que la donación fue recogida. ¿Puedes confirmarlo?",
          "borrower": "En espera de confirmación de {{name}}."
        }
      },
      "title": {
        "late": "Esta recogida está atrasada",
        "returned": {
          "lender": "¿Se realizó la recogida?",
          "borrower": "Recogiste la donación"
        },
        "past": "La donación fue recogida con éxito"
      },
      "status": "Estado"
    },
    "loanMessage": {
      "cancel": "Cancelar",
      "edit": "Modificar",
      "accept": "Aceptar",
      "contentAccepted": "La reserva del objeto ha sido confirmada.",
      "contentAsBorrower": "El prestador debe confirmar para que el objeto sea reservado.",
      "contentAsLender": "El prestatario debe confirmar para que el objeto sea reservado.",
      "contentCompleted": "Este préstamo ha finalizado.",
      "contentPending": "La propuesta de fechas debe ser aceptada para que el objeto sea reservado.",
      "contentPendingIsUpdate": "Las fechas del préstamo han sido modificadas. Acepta para confirmar estas nuevas fechas.",
      "contentRejected": "La reserva del objeto ha sido cancelada.",
      "endDatePassed": "La fecha propuesta de fin del préstamo ha pasado.",
      "flexibleDates": "(flexibles)",
      "loanStatusAsBorrower": "Estado del préstamo recibido",
      "loanStatusAsLender": "Estado del préstamo",
      "period": "Período",
      "date": "Fecha",
      "reject": "Rechazar",
      "startDatePassed": "La fecha propuesta de inicio del préstamo ha pasado.",
      "status": {
        "accepted": "Aceptado",
        "completed": "Finalizado",
        "pending": "En espera",
        "rejected": "Cancelado",
        "returned": "Devuelto"
      },
      "to": "al"
    },
    "serviceMessage": {
      "contentAccepted": "La reserva del servicio está confirmada.",
      "contentAsBorrower": "El miembro debe confirmar para que el servicio sea reservado.",
      "contentAsLender": "La solicitud debe confirmarse para que el servicio sea reservado.",
      "contentCompleted": "El servicio fue prestado.",
      "contentPending": "La propuesta de fechas debe ser aceptada para que el servicio sea reservado.",
      "contentPendingIsUpdate": "Las fechas del servicio han sido modificadas. Acepta para confirmar estas nuevas fechas.",
      "contentRejected": "La solicitud de servicio fue rechazada.",
      "loanStatusAsBorrower": "Estado",
      "loanStatusAsLender": "Estado",
      "startDatePassed": "La fecha propuesta para el inicio del servicio ha pasado.",
      "status": {
        "accepted": "Aceptado",
        "completed": "Prestado",
        "pending": "En espera",
        "rejected": "Rechazado",
        "returned": "Prestado"
      }
    },
    "donationMessage": {
      "contentAccepted": "La fecha de recogida de la donación ha sido confirmada.",
      "contentAsBorrower": "La fecha de recogida propuesta está en espera de confirmación.",
      "contentAsLender": "La fecha de recogida propuesta está en espera de confirmación.",
      "contentCompleted": "La donación fue recogida.",
      "contentPending": "La propuesta de fecha debe ser aceptada para que la recogida tenga lugar.",
      "contentPendingIsUpdate": "La fecha de recogida ha sido modificada. Acepta para confirmar esta nueva fecha.",
      "contentRejected": "La propuesta de fecha fue rechazada.",
      "loanStatusAsBorrower": "Estado",
      "loanStatusAsLender": "Estado",
      "startDatePassed": "La fecha propuesta para la recogida ha pasado.",
      "status": {
        "accepted": "Aceptado",
        "completed": "Recogido",
        "pending": "En espera",
        "rejected": "Rechazado",
        "returned": "Recogido"
      }
    },
    "sellMessage": {
      "contentAccepted": "La fecha de recogida ha sido confirmada.",
      "contentAsBorrower": "La fecha de recogida propuesta está en espera de tu confirmación.",
      "contentAsLender": "La fecha de recogida propuesta está en espera de la confirmación del comprador.",
      "contentCompleted": "El artículo ha sido entregado al comprador.",
      "contentPending": "La propuesta de fecha debe ser aceptada para que la recogida tenga lugar.",
      "contentPendingIsUpdate": "La fecha de recogida ha sido modificada. Acepta para confirmar esta nueva fecha.",
      "contentRejected": "La propuesta de fecha fue rechazada.",
      "loanStatusAsBorrower": "Estado",
      "loanStatusAsLender": "Estado",
      "startDatePassed": "La fecha propuesta para la recogida ha pasado.",
      "status": {
        "accepted": "Aceptado",
        "completed": "Entregado",
        "pending": "En espera",
        "rejected": "Rechazado",
        "returned": "Entregado"
      }
    },
    "participationsMessage": {
      "contentAccepted": "La inscripción ha sido confirmada.",
      "contentAsBorrower": "",
      "contentAsLender": "",
      "contentCompleted": "El servicio fue prestado.",
      "contentPending": "",
      "contentPendingIsUpdate": "",
      "contentRejected": "La inscripción fue cancelada.",
      "loanStatusAsBorrower": "Estado",
      "loanStatusAsLender": "Estado",
      "startDatePassed": "La fecha del evento ha pasado.",
      "status": {
        "accepted": "Aceptado",
        "completed": "Pasado",
        "pending": "En espera",
        "rejected": "Cancelado",
        "returned": "Pasado"
      }
    },
    "message_was_read": "Leído por {{name}}",
    "notifNowInsured": "<strong>¡No te preocupes y comparte!\n\nPartage Club puede indemnizarte hasta 300 $</strong> en caso de problema con artículos prestados de un valor de 25 $ o más.\n\nSi ocurre cualquier cosa, puedes contactarnos aquí, o bien por correo electrónico a <strong>info@partage.club</strong>",
    "promptIntroduceYourself": "Escríbele unas palabras al miembro para presentarte y expresar tu interés.",
    "quickOffer": {
      "text": "¡Publica en 10 segundos!",
      "title": "Publicación rápida"
    },
    "membersCount_one": "{{count}} miembro",
    "membersCount": "{{count}} miembros",
    "membersTitle": "Miembros",
    "admin": "Admin",
    "isYou": "Tú",
    "memberMenu": {
      "makeAdmin": "Agregar como administrador",
      "makeRegular": "Eliminar derechos de administrador",
      "seeProfile": "Ver perfil",
      "remove": "Eliminar de la conversación",
      "report": "Reportar miembro",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "makeAdminModal": {
        "title": "Agregar como administrador",
        "body": "¿Estás seguro de que quieres agregar a {{name}} como administrador de esta conversación?"
      },
      "makeRegularModal": {
        "title": "Eliminar derechos de administrador",
        "body": "¿Estás seguro de que quieres eliminar los derechos de administrador de {{name}} en esta conversación?"
      },
      "removeModal": {
        "title": "Eliminar de la conversación",
        "body": "¿Estás seguro de que quieres eliminar a {{name}} de esta conversación?"
      },
      "reportModal": {
        "title": "Reportar miembro",
        "body": "¿Estás seguro de que quieres reportar a {{name}}?"
      }
    },
    "muteConversation": "Silenciar conversación",
    "linkOffer": "Vincular oferta",
    "linkedOffer": "Oferta vinculada",
    "linkOfferModal": {
      "title": "Vincular una oferta",
      "description": "Elige una de tus ofertas para usar su calendario de disponibilidad en esta conversación.",
      "empty": "No tienes una oferta activa para vincular."
    },
    "linkOfferInline": {
      "title": "Vincular una oferta",
      "description": "Elige una de tus ofertas relacionadas con \"{{itemName}}\" y luego confirma para usar su calendario de disponibilidad en esta conversación.",
      "loading": "Buscando tus ofertas...",
      "empty": "No se encontró ninguna oferta que coincida con esta búsqueda.",
      "confirm": "Vincular esta oferta",
      "confirmSelected": "Vincular esta oferta"
    },
    "seeListing": "Ver anuncio",
    "transportListing": {
      "date": "Fecha",
      "departure": "Salida",
      "destination": "Destino",
      "notAvailable": "N/D",
      "view": "Ver"
    },
    "silenceDurationPrompt": "¿Durante cuánto tiempo quieres silenciar esta conversación?",
    "silenceFor1Minute": "Durante 1 minuto",
    "silenceFor15Minutes": "Durante 15 minutos",
    "silenceFor1Hour": "Durante 1 hora",
    "silenceFor8Hours": "Durante 8 horas",
    "silenceFor24Hours": "Durante 24 horas",
    "silenceFor48Hours": "Durante 48 horas",
    "silenceFor1Week": "Durante 1 semana",
    "silenceUntilChanged": "Hasta que lo cambie",
    "silenceNotifications": "Silenciar notificaciones",
    "toolbar": {
      "defaultValue": "¡Hola {{name}}! ",
      "openCamera": "Abrir la cámara",
      "openLibrary": "Abrir la galería de fotos",
      "placeHolder": "Tu mensaje...",
      "sendLike": "Enviar un pulgar arriba",
      "sendMessage": "Enviar el mensaje"
    },
    "unmuteConversation": "Volver a activar notificaciones",
    "viewMembers": "Ver miembros",
    "conciergeMessage": {
      "canHelp": {
        "title": "¡Genial! Puedes ayudar a {{interlocutorName}}:",
        "proposeDates": "• Propone fechas de préstamo",
        "sendMessage": "• Envíale un mensaje para discutir los detalles",
        "lastMessageText": "Quieres ayudar a {{interlocutorName}} con esta necesidad"
      },
      "canYouHelp": {
        "title": "¿Crees que puedes ayudar?",
        "subtitle": "Si no, archivaré la conversación por ti",
        "buttonNo": "No",
        "buttonYes": "Sí",
        "whyDidIReceiveThisMessage": "¿Por qué recibí este mensaje?",
        "bottomSheet": {
          "title": "Asistente inteligente",
          "paragraph1": "Recibiste este mensaje porque el asistente inteligente cree que podrías tener el objeto solicitado por este miembro.",
          "paragraph2": "Mientras no respondas “sí”, la conversación permanece invisible para la persona que quiere pedir prestado, así que no dudes en rechazarla.",
          "paragraph3": {
            "beforeBold": "Para dejar de recibir estos mensajes, ",
            "bold": "desactiva la opción en tus preferencias",
            "afterBold": "."
          },
          "cta": "Modificar mis preferencias →"
        },
        "lastMessageText": "¿Puedes ayudar a {{interlocutorName}} con esta necesidad?"
      },
      "matchAccepted": {
        "title": "¡Qué suerte! {{interlocutorName}} quiere ayudarte",
        "proposeDates": "• Propone fechas de préstamo",
        "sendMessage": "• Envíale un mensaje para discutir los detalles",
        "lastMessageText": "¡{{interlocutorName}} ha aceptado ayudarte!"
      },
      "cantHelp": {
        "title": "¡Sin problema!",
        "subtitle": "No dudes en contactar a {{interlocutorName}} si cambias de opinión",
        "lastMessageText": "No puedes ayudar a {{interlocutorName}} con esta necesidad"
      },
      "resolved": {
        "title": "¡Buenas noticias!",
        "subtitle": "{{interlocutorName}} encontró lo que necesitaba",
        "lastMessageText": "{{interlocutorName}} encontró lo que necesitaba"
      }
    },
    "archivedConvoToast": {
      "title": "Conversación archivada",
      "message": "Puedes encontrarla en la sección Conversaciones archivadas."
    },
    "visibleOnlyToYou": "Visible solo para ti",
    "transportPrompt": {
      "title": "¿Necesitas ayuda con el transporte?",
      "description": "Puedes contactar con el servicio de asistencia de transporte para organizar la recogida.",
      "cta": "Escribir al servicio de asistencia"
    },
    "postSaleListingPrompt": {
      "title": "¿Qué quieres hacer con tu anuncio?",
      "description": "¿Aún te queda algo por vender? ¿Crees que tendrás más en el futuro?",
      "keep": "No hacer nada",
      "hide": "Ocultar",
      "delete": "Eliminar"
    },
    "loanReciprocityPrompt": {
      "title": "Tu turno de ayudar 🤝",
      "description": "La comunidad te permite pedir prestado en vez de comprar. Publica varios objetos que uses poco y ayuda a tu vez.",
      "publish": "Publicar mis objetos",
      "later": "Más tarde"
    },
    "bonification": {
      "borrowerPrompt": {
        "title": "🌟 ¡Haz brillar este objeto!",
        "text": "Este objeto se beneficiaría de una foto real o de una mejor descripción. ¡Propón una mejora!",
        "cta": "Proponer una mejora"
      },
      "borrowerSubmitted": {
        "title": {
          "reviewing": "✨ ¡Buen trabajo!",
          "accepted": "🎉 ¡Sugerencia aceptada!",
          "rejected": "✏️ Sugerencia rechazada"
        },
        "text": {
          "reviewing": "Tus sugerencias se enviaron al prestador para su evaluación.",
          "accepted": "El prestador aceptó tus sugerencias. ¡Gracias por tu ayuda!",
          "rejected": "El prestador rechazó tus sugerencias. Gracias por tomarte el tiempo de proponer mejoras para este anuncio."
        }
      },
      "lenderNudge": {
        "title": {
          "lend": "Alguien quiere tomar prestado tu objeto 👋",
          "sell": "Alguien quiere comprar tu objeto 👋",
          "give": "Alguien quiere recibir tu objeto 👋"
        },
        "text": "Para que el intercambio sea aún mejor, agrega una foto real y una breve descripción. ¡Inspira confianza y hace tu objeto más atractivo!",
        "cta": "Completar la ficha del objeto"
      },
      "lenderReview": {
        "title": "📩 ¡Nueva sugerencia recibida!",
        "text1": "<strong>{{name}}</strong> propuso mejoras para tu objeto.",
        "text2": "👉 Puedes revisarla y decidir si la aceptas, la rechazas o la modificas",
        "ctaView": "Ver la sugerencia",
        "ctaReject": "Rechazar"
      },
      "lenderReviewed": {
        "title": {
          "accepted": "🎉 Sugerencia aceptada",
          "rejected": "✏️ Sugerencia rechazada",
          "modified": "🎉 Modificaciones aplicadas"
        },
        "text": {
          "accepted": "¡Genial! Acabas de completar la ficha de tu objeto.",
          "rejected": "Rechazaste las modificaciones sugeridas para este anuncio. Puedes mejorar la ficha de tu objeto tú mismo desde tus ofertas.",
          "modified": "Las modificaciones sugeridas se han aplicado a tu anuncio."
        }
      }
    },
    "bonificationScreen": {
      "title": "Proponer mejoras",
      "suggestionBadge": "Sugerencia",
      "borrower": {
        "bannerTitle": "✏️ Estás en modo sugerencia",
        "bannerText": "La foto y la descripción que propongas se enviarán al prestador para su aprobación.",
        "addPhoto": "Agregar una foto",
        "titleLabel": "Título",
        "descriptionLabel": "Descripción",
        "submit": "Proponer modificaciones"
      },
      "lender": {
        "bannerTitle": "✏️ Estás consultando una sugerencia",
        "bannerText": "Aquí tienes la foto y/o la descripción propuesta por el prestatario. Puedes aceptarla, modificarla o rechazarla.",
        "banner": "Estás consultando una sugerencia de un prestatario.",
        "photoLabel": "Foto del artículo",
        "titleLabel": "Nombre del objeto",
        "descriptionLabel": "Descripción",
        "currentValue": "Actual: {{value}}",
        "accept": "Aceptar sugerencias",
        "acceptModified": "Aceptar modificaciones",
        "modify": "Actualizar",
        "reject": "Rechazar",
        "cancel": "Cancelar",
        "rejectConfirm": {
          "title": "¿Rechazar sugerencias?",
          "text": "¿Seguro que quieres rechazar estas sugerencias?",
          "cancel": "Cancelar",
          "confirm": "Rechazar"
        }
      },
      "summary": {
        "title": {
          "pending": "Sugerencias pendientes",
          "reviewing": "Sugerencias enviadas",
          "accepted": "Sugerencias aceptadas",
          "rejected": "Sugerencias rechazadas"
        },
        "text": {
          "pending": "Estas sugerencias están pendientes de evaluación por el propietario.",
          "reviewing": "Tus sugerencias se enviaron al prestador para su evaluación.",
          "accepted": "Estas sugerencias han sido aceptadas y aplicadas al anuncio.",
          "rejected": "Estas sugerencias han sido rechazadas."
        }
      }
    },
    "replyingTo": "Respondiendo a {{name}}",
    "editing": "Editando",
    "edited": "Editado",
    "deletedMessage": {
      "author": "Has eliminado este mensaje",
      "other": "Este mensaje ha sido eliminado"
    },
    "menu": {
      "reply": "Responder",
      "copy": "Copiar",
      "edit": "Editar",
      "delete": "Eliminar",
      "messageActions": "Acciones del mensaje",
      "photo": "📷 Foto"
    },
    "automaticMessageLabel": "Mensaje automatizado",
    "helpButton": "Cómo funciona",
    "howItWorks": {
      "title": "¿Cómo funciona?",
      "screenTitle": {
        "borrow": "Pedir prestado",
        "lend": "Prestar"
      },
      "assistanceQuestion": "¿Necesitas más ayuda?",
      "visitHelpCenter": "Visitar el centro de ayuda",
      "borrow": {
        "step1": "<bold>Escribe un mensaje</bold> para presentarte y <bold>expresar tu interés</bold>",
        "step2": "<bold>Propón</bold> fechas de préstamo, <bold>espera la confirmación</bold> de tu vecino/a y <bold>planifiquen la recogida</bold> juntos",
        "step3": "<bold>Recoge el objeto</bold> en casa de tu vecino/a o en un lugar público seguro. <bold>¡Sin intercambio de dinero, es gratis!</bold>",
        "step4": "<bold>Devuélvelo</bold> en buen estado y comparte tu experiencia"
      },
      "lend": {
        "step1": "<bold>Responde al mensaje</bold> para conocerse y <bold>discutir los detalles</bold>",
        "step2": "<bold>Acepta o propón</bold> fechas de préstamo y <bold>planifiquen la recogida</bold> juntos",
        "step3": "<bold>Presta el objeto</bold> a tu vecino/a. <bold>¡Sin intercambio de dinero, es gratis!</bold>",
        "step4": "<bold>Recupera tu objeto</bold> en buen estado y comparte tu experiencia"
      }
    },
    "groupCreatedByYou": "Has creado esta conversación",
    "addMembers": "Agregar miembros",
    "seeProfile": "Ver perfil",
    "seeMembers": "Ver miembros",
    "leaveConversation": "Salir de la conversación",
    "renameConversation": "Renombrar conversación",
    "deleteConversation": "Eliminar conversación",
    "confirmLeaveTitle": "Salir de la conversación",
    "confirmLeave": "¿Estás seguro de que quieres salir de esta conversación?",
    "confirmDeleteTitle": "Eliminar conversación",
    "confirmDelete": "¿Estás seguro de que quieres eliminar esta conversación? Esta acción no se puede deshacer.",
    "renameTitle": "Renombrar conversación",
    "save": "Guardar",
    "cancel": "Cancelar",
    "changeLinkedOffer": "Cambiar oferta vinculada",
    "unlinkOffer": "Desvincular oferta"
  },
  "recommendations": {
    "one-to-many-similar-listings": {
      "title": {
        "offer": "Ofertas similares",
        "request": "Necesidades similares"
      }
    },
    "your-favourites": {
      "title": "Tus favoritos",
      "emptyStateButton": "Explorar el catálogo",
      "emptyStateTitle": "¡Agrega tu primera oferta a favoritos!",
      "emptyStateText": "Los favoritos aparecerán aquí"
    },
    "most-popular": {
      "title": "Más compartidos"
    },
    "urgent-needs": {
      "title": "¡Ayuda a tus vecinos!"
    },
    "recent-offers": {
      "title": "Ofertas recientes"
    },
    "match-needs-with-offers": {
      "title": "Podrías ayudar"
    },
    "mixed-recommendations": {
      "title": "Recomendado para ti"
    },
    "your-interest": {
      "title": "{{tagName}}"
    },
    "by-category": {
      "title": "{{categoryName}}"
    },
    "recent-loans": {
      "title": "Préstamos recientes",
      "and": "y",
      "shared": "han compartido",
      "timeAgo": "hace {{time}}"
    },
    "neighbour-offers": {
      "title": "Sus ofertas"
    },
    "neighbour-requests": {
      "title": "Sus necesidades"
    },
    "nearest-sharing-place": {
      "title": "Lugares de intercambio cercanos"
    }
  },
  "one-listing": {
    "trustCircle": {
      "offerLabel": "Oferta de confianza",
      "requestLabel": "Solicitud de confianza",
      "offerExplanation": "Ves esta oferta porque {{name}} confía en ti.",
      "requestExplanation": "Ves esta solicitud porque {{name}} confía en ti."
    },
    "urgent": "Urgente",
    "availabilitySection": {
      "reservations": {
        "title": "Reservas",
        "text": "Confirmar tus fechas"
      },
      "quantity": {
        "fieldPlaceholder": "1",
        "title": "Inventario",
        "text": "Indicar la cantidad"
      },
      "title": "Disponibilidad",
      "donation": {
        "reservations": {
          "title": "Fecha límite",
          "text": "Pasar a recoger antes del..."
        },
        "title": "Disponibilidad"
      },
      "loan": {
        "reservations": {
          "title": "Reserva",
          "text": "Marcar como no disponible para mi uso"
        }
      }
    },
    "categorySection": {
      "primary": {
        "subtitle": "Selecciona la categoría principal del objeto",
        "title": "Categoría",
        "placeholder": "Categorías"
      }
    },
    "confirmReturnModal": {
      "primaryButtonText": "Confirmar",
      "secondaryButtonText": "Cancelar",
      "text": {
        "borrower": "Al confirmar la devolución de este objeto, indicas que se lo devolviste a {{name}}.",
        "lender": "Al confirmar la devolución de este objeto, indicas que {{name}} te lo ha devuelto."
      },
      "title": "¿Confirmar la devolución?"
    },
    "confirmSaleModal": {
      "primaryButtonText": {
        "borrower": "Confirmar la recepción",
        "lender": "Confirmar la venta"
      },
      "secondaryButtonText": "Cancelar",
      "text": {
        "borrower": "Al confirmar la recepción, indicas que recibiste el objeto de {{name}}. El vendedor deberá confirmar la venta después.",
        "lender": "Al confirmar la venta, indicas que entregaste el objeto a {{name}}. El anuncio se archivará."
      },
      "title": {
        "borrower": "¿Confirmar la recepción?",
        "lender": "¿Confirmar la venta?"
      }
    },
    "confirmServiceDoneModal": {
      "primaryButtonText": "Confirmar",
      "secondaryButtonText": "Cancelar",
      "text": {
        "borrower": "Al confirmar que el servicio fue prestado, indicas que {{name}} te prestó correctamente este servicio.",
        "lender": "Al confirmar, reconoces haber prestado el servicio solicitado por {{name}}."
      },
      "title": "¿Servicio prestado?"
    },
    "confirmDonationDoneModal": {
      "primaryButtonText": "Confirmar",
      "secondaryButtonText": "Cancelar",
      "text": {
        "borrower": "Al confirmar que la donación fue recogida, indicas que {{name}} te dio correctamente este objeto.",
        "lender": "Al confirmar, reconoces haber dado a {{name}} el objeto en cuestión."
      },
      "title": "¿Donación recogida?"
    },
    "createOfferModal": {
      "primaryButtonText": "Publicar esta oferta",
      "secondaryButtonText": "No, gracias",
      "text": "Seguramente otros miembros lo necesitarán. ¿Te gustaría hacérselo disponible publicando una oferta?",
      "title": "Gracias por haber prestado tu objeto"
    },
    "deleteButtonText": "Eliminar",
    "deleteConfirmation": {
      "offer": "Eliminar la oferta",
      "request": "Eliminar la necesidad"
    },
    "deleteErrorModal": {
      "primaryButtonText": "Cerrar",
      "title": {
        "offer": "La oferta no puede ser eliminada",
        "request": "La necesidad no puede ser eliminada"
      }
    },
    "hasAcceptedLoan": "ha prestado el objeto",
    "hasAcceptedLoanAgo": "ha prestado el objeto hace {{ago}}",
    "beTheFirstToHelpTitle": "Aún no hay ofertas de ayuda",
    "beTheFirstToHelp": "Puedes ser la primera persona en contactar a este miembro.",
    "wantToHelpTitle_one": "{{count}} miembro quiere ayudar",
    "wantToHelpTitle_other": "{{count}} miembros quieren ayudar",
    "wantToHelpSubtitle": "Ver los miembros que quieren ayudar",
    "borrowers": {
      "title_one": "Prestado {{count}} vez",
      "title_other": "Prestado {{count}} veces",
      "borrowedAgo": "Hace {{ago}}",
      "borrowedTimesAgo_one": "Prestado {{count}} vez · hace {{ago}}",
      "borrowedTimesAgo_other": "Prestado {{count}} veces · hace {{ago}}"
    },
    "currentBorrower": {
      "title": "Prestado actualmente a",
      "scheduledEnd": "El préstamo está previsto que finalice el {{date}}",
      "viewProfile": "Ver el perfil de {{name}}"
    },
    "sections": {
      "about": "Acerca de",
      "noDescription": "Este anuncio aún no tiene descripción",
      "availabilityAndPickup": "Disponibilidad y recogida",
      "owner": "Miembro"
    },
    "availability": {
      "availableNow": "Disponible ahora",
      "borrowedUntil": "Prestado hasta el {{date}}",
      "availableUntil": "Disponible hasta el {{date}}",
      "availableIn_one": "Disponible en {{count}} día",
      "availableIn_other": "Disponible en {{count}} días",
      "currentlyUnavailable": "No disponible por el momento",
      "currentlyBorrowed": "Prestado actualmente",
      "flexibleDates": "Fechas flexibles",
      "requestDate": "Se necesita el {{date}}",
      "requestDateRange": "Se necesita del {{start}} al {{end}}"
    },
    "availabilityCalendar": {
      "title": "¿Cuándo está disponible?",
      "noUpcomingReservation": "Disponible toda la semana",
      "currentReservation": "Reservado hasta el {{date}}",
      "nextReservation": "La próxima reserva empieza el {{date}}",
      "availableDaysThisWeek_one": "Disponible 1 día esta semana",
      "availableDaysThisWeek_other": "Disponible {{count}} días esta semana",
      "available": "Disponible",
      "reserved": "Reservado",
      "viewMore": "Calendario completo",
      "viewLess": "Ver menos",
      "yourDates": "Tu propuesta de fechas",
      "selectionHint": "Elige las fechas de inicio y fin",
      "selectedRange": "{{start}} – {{end}}",
      "proposeDates": "Proponer estas fechas",
      "proposalSent": "Tu propuesta de fechas se ha enviado",
      "dayAvailable": "{{date}} está disponible",
      "dayUnavailable": "{{date}} ya está reservado"
    },
    "socialProof": {
      "savedBy_one": "Guardado por {{count}} miembro",
      "savedBy_other": "Guardado por {{count}} miembros",
      "views_one": "{{count}} vista",
      "views_other": "{{count}} vistas"
    },
    "owner": {
      "member": "Miembro",
      "lastActive": "Última actividad hace {{ago}}",
      "memberSince": "Miembro desde",
      "loans": "Préstamos",
      "recommendations": "Recomendaciones",
      "responseRate": "Tasa de respuesta",
      "responseTime": "Suele responder en",
      "trust": "Confianza",
      "ratingCount_one": "{{count}} evaluación",
      "ratingCount_other": "{{count}} evaluaciones",
      "viewProfile": "Ver perfil completo",
      "openAvatar": "Abrir la foto de perfil de {{name}}",
      "openProfile": "Abrir el perfil de {{name}}"
    },
    "headerSection": {
      "address": "Dirección",
      "available": "Disponible",
      "contactButtonText": "Contactar al miembro",
      "dateBefore": "Fecha límite",
      "date": "Fecha: ",
      "dates": "Fechas: ",
      "distance": "Distancia",
      "approximatePickupArea_one": "Zona aproximada de recogida",
      "approximatePickupArea_other": "Zonas aproximadas de recogida",
      "approximateLocationHint": "El círculo muestra la zona aproximada donde se puede recoger esta oferta.",
      "approximateLocationSecurity": "Este mapa nunca revela una dirección exacta. Los detalles de recogida permanecen privados y se coordinan por separado entre miembros.",
      "approximateBorrowerArea_one": "Ubicación aproximada del prestatario",
      "approximateBorrowerArea_other": "Ubicaciones aproximadas del prestatario",
      "approximateBorrowerLocationHint": "El círculo muestra dónde se encuentra aproximadamente el prestatario para esta necesidad.",
      "approximateBorrowerLocationSecurity": "Este mapa nunca revela una dirección exacta. Cualquier detalle adicional permanece privado y se coordina directamente entre miembros.",
      "viewMap": "Ver el mapa",
      "editButtonText": "Modificar",
      "lessThan": "Menos de {{distance}}",
      "lessThanKm": "Menos de {{distance}} {{unit}}",
      "loanedLater": "Disponible hasta el {{date}}",
      "loanedUntil": "Prestado hasta el {{date}}",
      "myRequest": "Mi necesidad",
      "neighborRequest": "Necesidad de un miembro",
      "noDates": "Fechas flexibles",
      "flexibleDates": "(flexibles)",
      "postedOn": "Publicado el {{date}}",
      "quantity": "<strong>{{num}}</strong> unidades",
      "timeBoth": "De <strong>{{start}}</strong> a <strong>{{end}}</strong>",
      "timeStart": "A partir de <strong>{{start}}</strong>",
      "timeEnd": "Hasta <strong>{{end}}</strong>",
      "unavailable": "No disponible",
      "inventory": "Inventario",
      "price": "Precio",
      "marketValue": "Valor de mercado",
      "sharingFee": "Cargo de intercambio",
      "transactionModeLabel": "Transacción",
      "transactionMode": {
        "offer": {
          "sell": "Venta",
          "lend": "Préstamo",
          "give": "Donación"
        },
        "request": {
          "sell": "Compra",
          "lend": "Préstamo",
          "give": "Donación"
        }
      }
    },
    "loanFee": {
      "title": "Cargo de intercambio: {{amount}}"
    },
    "itemReturnedButtonText": "Confirmar la devolución",
    "serviceDoneButtonText": "Confirmar servicio prestado",
    "donationDoneButtonText": "Confirmar la donación",
    "sellDoneButtonText": "Confirmar la venta",
    "participateButtonText": "Inscribirme",
    "unparticipateButtonText": "Darme de baja",
    "cantParticipateButtonText": "Completo",
    "viewParticipationButtonText": "Gestionar mi inscripción",
    "viewParticipationsButtonText": "Ver inscripciones",
    "needFoundModal": {
      "step1": {
        "title": "Retirar el anuncio",
        "body": "Marca tu anuncio como encontrado si tu necesidad fue cubierta.",
        "primaryButtonText": "Marcar como encontrado"
      },
      "step2": {
        "title": "Marcar como encontrado",
        "gotoSelectLender": "La necesidad fue cubierta en Partage Club",
        "gotoFoundElsewhere": "La necesidad fue cubierta en otro lugar",
        "primaryButtonText": "Siguiente"
      },
      "step3": {
        "title": "Felicitaciones por tu préstamo",
        "body": "Tu anuncio fue marcado como encontrado.",
        "primaryButtonText": "Ir al catálogo",
        "secondaryButtonText": "Ver mi anuncio"
      },
      "step4": {
        "title": "Seleccionar el prestador",
        "body": "Este paso es importante para hacer seguimiento del préstamo y las fechas de devolución.",
        "primaryButtonText": "Siguiente"
      },
      "step5": {
        "title": "Seleccionar las fechas acordadas",
        "body": "Este paso es importante para hacer seguimiento del préstamo y las fechas de devolución.",
        "primaryButtonText": "Finalizar"
      },
      "step6": {
        "title": "Felicitaciones por tu préstamo",
        "body": "Tu anuncio fue marcado como encontrado, y el prestador habrá recibido una solicitud de confirmación para las fechas.",
        "primaryButtonText": "Ir al catálogo",
        "secondaryButtonText": "Ver mi anuncio"
      }
    },
    "posterSection": {
      "memberSince": "Miembro desde {{date}}",
      "offer": {
        "title": "Miembro"
      },
      "primaryButtonText": "Ver el perfil",
      "request": {
        "title": "Miembro"
      }
    },
    "primaryButtonText": "Guardar",
    "primaryButtonTextWithCopies_one": "Guardar y crear {{count}} copia",
    "primaryButtonTextWithCopies_other": "Guardar y crear {{count}} copias",
    "saveToast": {
      "title": "Cambios guardados",
      "text": "El anuncio se ha actualizado.",
      "copies_one": "{{count}} nueva oferta creada.",
      "copies_other": "{{count}} nuevas ofertas creadas.",
      "errorTitle": "No se pudieron guardar los cambios",
      "errorText": "Inténtalo de nuevo."
    },
    "removeButtonText": "Retirar",
    "subscriptionsSection": {
      "title": "Inscripciones",
      "titlePublic": "Inscripción",
      "text": "Máx. de participantes",
      "textPublic": "¿Para cuántas personas?",
      "participants_one": "{{count}} participante confirmado",
      "participants": "{{count}} participantes confirmados",
      "participantsFull": "¡Completo!",
      "participantsLeft_one": "{{count}}/{{max}} lugar disponible",
      "participantsLeft": "{{count}}/{{max}} lugares disponibles",
      "participationsSavedToast": {
        "title_one": "Inscripción para {{count}} persona exitosa",
        "title": "Inscripción para {{count}} personas exitosa",
        "text": "Para modificar, cambia el número aquí y haz clic en Guardar."
      },
      "participationsDeletedToast": {
        "title": "Baja exitosa",
        "text": "Puedes volverte a inscribir en cualquier momento si aún hay lugares disponibles."
      }
    },
    "title": {
      "offer": "Oferta",
      "request": "Necesidad",
      "offerDonation": "Oferta (donación)",
      "requestDonation": "Necesidad (donación)"
    },
    "unavailableMessage": "Es posible que el anuncio haya sido eliminado o que no esté visible por el momento.",
    "unavailableTitle": "Este anuncio ya no está disponible",
    "urlCopied": "La dirección (URL) para compartir ha sido copiada.",
    "viewsSection": {
      "title": "Alcance",
      "views": "Vistas",
      "favourites": "Favoritos"
    },
    "tabs": {
      "info": "Detalles",
      "stories": "Historias ({{count}})"
    },
    "automaticMessageCard": {
      "title": "Estamos contactando a posibles miembros por ti...",
      "titleSearching": "Buscando miembros...",
      "titleContactedAll": "Se ha contactado a todos los posibles miembros",
      "titleNoCandidates": "¡El asistente inteligente sigue atento!",
      "titleDisabled": "El asistente inteligente está desactivado",
      "titleWithResponses": "El asistente inteligente está contactando a posibles prestadores... ¡Tienes respuestas!",
      "subtitle": "Cuantos más detalles compartas, más fácil será para los miembros entender tu oferta o tu necesidad.",
      "subtitleNoCandidates": "No se encontraron ofertas. Estamos esperando que un miembro publique una nueva oferta que coincida con tu necesidad.",
      "subtitleDisabled": "Vuelve a activar el asistente para reanudar la búsqueda de posibles prestadores.",
      "subtitleSearching": "Esto puede tardar unos minutos.",
      "subtitleWithResponses": "¡Posibles miembros te han respondido!",
      "subtitleContactedAll": "En espera de su respuesta, seguimos atentos a una nueva oferta que coincida con tu necesidad",
      "contacted": "Miembros contactados :",
      "responses": "Respuestas: {{count}}",
      "viewResponses_zero": "Ver conversación(es)",
      "viewResponses": "Ver ({{count}}) respuesta(s)",
      "learnMore": "Más información",
      "automaticMessageLabel": "Mensaje automático",
      "editAutomaticMessageLabel": "Editar mensaje automático",
      "enabled": "Asistente inteligente activado",
      "disabled": "Asistente inteligente desactivado"
    },
    "reportListing": "Reportar este anuncio",
    "reportListingPrompt": "Hola, me gustaría reportar un anuncio que encuentro inapropiado. ¿Podrían revisarlo?\n\nGracias.",
    "invalidFormError": "El anuncio no se puede guardar porque el formulario es inválido. Por favor, verifica cada campo arriba e inténtalo de nuevo."
  },
  "one-loan": {
    "dueDate": "Fecha límite",
    "returned": "Devuelto",
    "addToCalendarButtonText": "Agregar al calendario del teléfono",
    "cancelLoanButtonText": {
      "borrowing": "Cancelar el préstamo recibido",
      "lending": "Cancelar el préstamo",
      "service": "Cancelar el servicio",
      "donation": "Cancelar la donación",
      "sale": "Cancelar la venta"
    },
    "cancelLoanModal": {
      "primaryButtonText": {
        "borrowing": "Cancelar el préstamo recibido",
        "lending": "Cancelar el préstamo",
        "service": "Cancelar el servicio",
        "donation": "Cancelar la donación",
        "sale": "Cancelar la venta"
      },
      "secondaryButtonText": {
        "borrowing": "No cancelar",
        "lending": "No cancelar",
        "service": "No cancelar",
        "donation": "No cancelar",
        "sale": "No cancelar"
      },
      "text": {
        "borrowing": "Al confirmar la cancelación del préstamo recibido, le indicas al prestador que ya no necesitas este objeto.",
        "lending": "Al confirmar la cancelación del préstamo, le indicas al prestatario que este préstamo no tendrá lugar.",
        "service": "Al cancelar tu solicitud, informas al miembro que el intercambio de servicio no tendrá lugar.",
        "donation": "Al cancelar tu solicitud, informas al miembro que la recogida de esta donación no tendrá lugar.",
        "sale": "Al cancelar la venta, informas al miembro que la recogida no tendrá lugar."
      },
      "title": {
        "borrowing": "¿Cancelar el préstamo recibido?",
        "lending": "¿Cancelar el préstamo?",
        "service": "¿Cancelar el servicio?",
        "donation": "¿Cancelar la donación?",
        "sale": "¿Cancelar la venta?"
      }
    },
    "editParticipationButtonText": "Modificar la inscripción",
    "ratingAccessory": {
      "rate": "👍 Evaluar a {{name}}",
      "mine": "Mi evaluación:",
      "recommended": "Recomendado",
      "notRecommended": "No recomendado"
    },
    "ratingPrompt": {
      "title": "¿Tuviste una buena experiencia con {{name}}? ¡Compártela!",
      "subtitle": "Tus comentarios ayudan a construir una comunidad más confiable",
      "dismiss": "No gracias"
    },
    "changeDatesButtonText": {
      "borrowing": "Modificar las fechas del préstamo recibido",
      "lending": "Modificar las fechas del préstamo",
      "service": "Modificar la fecha del servicio",
      "donation": "Modificar la fecha de la donación",
      "sale": "Modificar la fecha de recogida"
    },
    "contactSupportAboutIncident": "Reportar un problema",
    "contactSupportAboutIncidentPrompt": {
      "insured": "¡Hola {{name}}! 😊\n\nNo te preocupes, los imprevistos ocurren.\n\nPara poder ayudarte, ¿podrías explicarnos qué pasó y, si es posible, enviarnos algunas fotos del objeto dañado?\n\nTranquilo/a, si ocurre algún daño a los objetos que prestas o tomas prestados por un valor de 25 $ o más, <strong>nos comprometemos a indemnizarte hasta 300 $ al año</strong>.\n\n¡Gracias!",
      "uninsured": "¡Hola {{name}}! 😊\n\nNo te preocupes, los imprevistos ocurren.\n\nPara poder ayudarte, ¿podrías explicarnos qué pasó y, si es posible, enviarnos algunas fotos del objeto dañado?\n\n<strong>Estamos aquí para ayudarte.</strong>\n\n¡Gracias!"
    },
    "donationDate": "Fecha",
    "end": "Devolución",
    "endService": "Fin",
    "expectedEnd": "Devolución prevista",
    "myParticipations": "Mis inscripciones",
    "allParticipations": "Número de inscripciones",
    "counterpart": {
      "borrower": "Prestatario/a",
      "buyer": "Comprador/a",
      "donor": "Donante",
      "lender": "Prestamista",
      "recipient": "Beneficiario/a",
      "seller": "Vendedor/a"
    },
    "listParticipants": "Ver los participantes inscritos",
    "history": {
      "accepted_when": "Aceptado el {{date}}",
      "end_when": "Devolución prevista · {{date}}",
      "late_x_days": "Objeto con retraso · {{numDays}} días",
      "late_yesterday": "Objeto con retraso · 1 día",
      "offered_when": "Solicitud de préstamo enviada el {{date}}",
      "returned_by_you": "tú",
      "returned_when": "Devolución confirmada por {{who}} · {{date}}",
      "started_when": "Préstamo en curso · {{date}}",
      "title": "Historial"
    },
    "serviceHistory": {
      "accepted_when": "Aceptado el {{date}}",
      "end_when": "Fin previsto · {{date}}",
      "late_x_days": "Servicio con retraso · {{numDays}} días",
      "late_yesterday": "Servicio con retraso · 1 día",
      "offered_when": "Solicitud de servicio enviada el {{date}}",
      "returned_by_you": "tú",
      "returned_when": "Servicio prestado confirmado por {{who}} · {{date}}",
      "started_when": "Servicio en curso · {{date}}",
      "title": "Historial"
    },
    "donationHistory": {
      "accepted_when": "Aceptado el {{date}}",
      "late_x_days": "Recogida con retraso · {{numDays}} días",
      "late_yesterday": "Recogida con retraso · 1 día",
      "offered_when": "Solicitud de recogida enviada el {{date}}",
      "returned_by_you": "tú",
      "returned_when": "Donación recogida - confirmado por {{who}} · {{date}}",
      "started_when": "Recogida de la donación prevista el {{date}}",
      "title": "Historial"
    },
    "saleHistory": {
      "accepted_when": "Aceptado el {{date}}",
      "end_when": "Recogida prevista · {{date}}",
      "late_x_days": "Recogida con retraso · {{numDays}} días",
      "late_yesterday": "Recogida con retraso · 1 día",
      "offered_when": "Solicitud de recogida enviada el {{date}}",
      "returned_by_you": "tú",
      "returned_when": "Recepción confirmada por {{who}} · {{date}}",
      "started_when": "Recogida prevista el {{date}}",
      "title": "Historial"
    },
    "sendMessage": "Enviar un mensaje a {{name}}",
    "start": "Inicio",
    "status": "Estado",
    "transactionDate": "Fecha de la transacción",
    "title": {
      "borrowing": "Detalles del préstamo recibido",
      "lending": "Detalles del préstamo",
      "service": "Detalles del servicio",
      "donation": "Detalles de la recogida de una donación",
      "sell": "Detalles de la venta"
    },
    "viewListing": "Ver los detalles del anuncio"
  },
  "payment": {
    "activateButton": "Activar tu suscripción",
    "benefitsTitle": "Ventajas",
    "askForMode": {
      "title": "Elige un método de pago",
      "mode": {
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "stripe": "Tarjeta de crédito"
      }
    },
    "cancellationPolicy": "Tu suscripción se renovará automáticamente cada año. Puedes cancelar tu suscripción hasta 24 h antes de la fecha de tu próximo pago.",
    "couponButton": "Aplicar",
    "couponFieldPlaceholder": "Código promocional",
    "discountLabel": "Descuento",
    "expiredCoupon": "Este código ha expirado",
    "expiredFreeTrial": "Tu período de prueba terminó el {{date}}",
    "expiredPlan": "Tu suscripción terminó el {{date}}",
    "intro": "Pide prestado <highlight>sin límites</highlight> con la suscripción <highlight>Partage+</highlight>.",
    "willExpirePlan": "Esta nueva suscripción comenzaría el {{date}}",
    "invalidCoupon": "Este código no es válido",
    "modal": {
      "firstParagraph": "Gracias por tu confianza. Gracias a tu suscripción, ahora puedes tomar prestado y prestar objetos a tus vecinos sin límite.",
      "primaryButtonText": "Ver tu suscripción",
      "title": "¡Gracias!"
    },
    "payButton": "Pagar",
    "popular": "Popular",
    "loanDiscount": {
      "percentage": "-25 %",
      "price": {
        "CAD": "45 $",
        "EUR": "54 €",
        "USD": "54 USD"
      },
      "footnote": "*{{discountedPrice}} facturados anualmente; luego {{renewalPrice}} en la fecha de renovación"
    },
    "yearlyMonthlyEquivalent": "{{price}}/mes",
    "monthlyEquivalent": {
      "CAD": "5 $",
      "EUR": "6 €",
      "USD": "6 USD"
    },
    "period": {
      "monthly": "mes",
      "yearly": "año"
    },
    "price": {
      "monthly": {
        "CAD": "8 $",
        "EUR": "9 €",
        "USD": "9 USD"
      },
      "yearly": {
        "CAD": "60 $",
        "EUR": "72 €",
        "USD": "72 USD"
      }
    },
    "savings": {
      "yearly": {
        "CAD": "(Ahorra 36 $)",
        "EUR": "(Ahorra 36 €)",
        "USD": "(Ahorra 36 USD)"
      }
    },
    "mobileRedirect": {
      "subtitle": "La suscripción de Partage Club está disponible por el momento únicamente en la app móvil.\nUna vez suscrito/a, podrás seguir usando el sitio web para prestar y tomar prestados objetos.",
      "forWhat": ""
    },
    "web": {
      "activationPending": "La activación está tardando más de lo esperado. Tu pago está confirmado y no se te volverá a cobrar.",
      "initializationError": "No se pudo cargar el pago seguro. Inténtalo de nuevo.",
      "retryCheckout": "Reintentar el pago",
      "genericError": "No se pudo confirmar el pago. Comprueba tus datos e inténtalo de nuevo.",
      "loading": "Cargando el pago seguro…",
      "paymentConfirmed": "Pago confirmado",
      "paymentDetails": "Método de pago",
      "paymentPending": "Pago pendiente",
      "paymentPendingDetails": "Tu pago todavía se está procesando. Activaremos tu suscripción cuando Stripe lo confirme.",
      "processing": "Estamos activando tu suscripción. Normalmente tarda unos segundos.",
      "removeCoupon": "Quitar el código promocional",
      "taxes": "Impuestos",
      "total": "Total",
      "unavailable": "El pago web no está disponible para esta suscripción.",
      "verifyingPayment": "Verificando tu pago",
      "verifyingPaymentDetails": "Estamos comprobando el estado más reciente del pago con Stripe.",
      "viewSubscription": "Ver tu suscripción"
    },
    "subtotal": "Subtotal",
    "taxes": "Impuestos",
    "title": "Activa tu suscripción"
  },
  "paywall": {
    "firstHero": "Tu período de prueba gratuito ha terminado.",
    "firstHeroBis": "Tu suscripción ha expirado.",
    "firstSubhero": "Puedes seguir prestando sin suscripción, pero para tomar prestado, debes suscribirte.",
    "pricesDescription": {
      "monthly": "Suscripción mensual",
      "yearly": "Suscripción anual"
    },
    "firstFeature": "Préstamos ilimitados",
    "secondFeature": "Una referencia = 1 mes gratis",
    "thirdFeature": "Partage Club es responsable de los daños causados a los objetos",
    "fourthFeature": "Cancela en cualquier momento",
    "ctaLabel": "Suscríbete ahora",
    "redesign": {
      "cancelAnytime": "Cancela en cualquier momento",
      "coverageFootnote": "*La Responsabilidad Partage Club cubre hasta 300 $ los objetos prestados o tomados prestados.",
      "damageCoverage": "Cobertura para objetos compartidos*",
      "expired": {
        "subtitle": "Tu suscripción terminó. Recupera todas tus ventajas en un clic.",
        "title": "¿Listo para volver a empezar?"
      },
      "included": "Lo que está incluido:",
      "learnMore": "Más información",
      "noThanks": "No, gracias",
      "standard": {
        "subtitle": "Desbloquea la experiencia completa para seguir tomando prestado con tranquilidad.",
        "title": "¡Vas por buen camino!"
      },
      "subscribe": "Suscribirme ahora",
      "unlimitedBorrowing": "Préstamos ilimitados",
      "unlimitedLending": "Préstamos de objetos ilimitados"
    }
  },
  "paywall2": {
    "title": {
      "trial": "Prueba gratuita terminada, pero...",
      "regular": "Suscripción terminada, pero..."
    },
    "offer": {
      "trial": "¡Obtén un 25 % de descuento en la suscripción anual y aprovecha plenamente la Responsabilidad Partage Club!",
      "regular": "¡Aquí hay una buena razón para suscribirte!"
    },
    "details": {
      "trial": "Con tu suscripción, si ocurre algún daño a los objetos que prestas o tomas prestados por un valor de 25 $ o más, <strong>nos comprometemos a indemnizarte hasta 300 $ al año</strong>.\n\nCódigo promocional: <strong>PARTAGE25</strong>",
      "regular": "Con tu suscripción, si ocurre algún daño a los objetos que prestas o tomas prestados por un valor de 25 $ o más, <strong>nos comprometemos a indemnizarte hasta 300 $ al año</strong>."
    },
    "button": {
      "trial": "Suscribirme",
      "regular": "Suscribirme"
    }
  },
  "personal-information": {
    "activitySectorsFieldLabel": "Sector(es) de actividad",
    "activitySectorsFieldSubtitle": "Selecciona al menos 1 opción",
    "firstNameFieldLabel": "Nombre",
    "firstNameFieldPlaceholder": "Nombre",
    "lastNameFieldLabel": "Apellido",
    "lastNameFieldPlaceholder": "Apellido",
    "phoneFieldLabel": "Número de teléfono celular",
    "phoneFieldError": "El número de teléfono no es válido.",
    "phoneFieldSubtitle": "No te preocupes, nunca compartiremos tu número con otro miembro o empresa.",
    "pictureFieldSubtitle": "La foto de perfil aumenta la confianza entre miembros",
    "pictureFieldTitle": "Agregar una foto de perfil",
    "title": "Tu información personal",
    "phoneFieldHelp": {
      "title": "Número de celular",
      "boldText": "¡Un pequeño gesto que lo cambia todo!",
      "text": "Tu número valida tu identidad, fortaleciendo la confianza de la comunidad.\n\nSolo lo usamos en caso de urgencia (mensaje no leído, correo bloqueado) para asegurarnos de que cada intercambio se concrete sin problemas.\n\nNunca lo compartiremos con nadie más."
    }
  },
  "privacy": {
    "title": "Condiciones y privacidad",
    "button1Text": "Términos y condiciones",
    "link1": "https://www.partage.club/es-ca/terms-and-conditions",
    "button2Text": "Política de privacidad",
    "link2": "https://www.partage.club/es-ca/privacy-policy",
    "button3Text": "Responsabilidad de Partage Club",
    "link3": "https://www.partage.club/es-ca/terms-and-conditions#responsabilite"
  },
  "profile": {
    "tabBarLabel": "Perfil"
  },
  "profile-overview": {
    "contactUsButtonLabel": "Ayuda",
    "editProfileButtonLabel": "Modificar",
    "inviteNeighboursButtonLabel": "Invitar vecinos",
    "logoutButtonLabel": "Cerrar sesión",
    "memberSince": "Miembro desde {{date}}",
    "myClubButtonLabel": "Lista de miembros",
    "myClubsButtonLabel": "Modificar mis clubs",
    "myFinancialImpactButtonLabel": "Económico",
    "myRatingsButtonLabel": "Evaluaciones",
    "streak": "Racha",
    "streakHood": "Racha de barrio",
    "superButtonLabel": "<strong>Super Compartidor</strong>",
    "superButtonLabelNotYet": "Convertirse en <strong>Super Compartidor</strong>",
    "myImpactTitle": "Mi impacto",
    "ambassadorButtonLabel": "<strong>Espacio Embajador·a</strong>",
    "ambassadorButtonLabelNotYet": "Convertirse en <strong>Embajador·a</strong>",
    "myInformationButtonLabel": "Configuración de la cuenta",
    "myInformationTitle": "Información personal",
    "myPreferencesButtonLabel": "Gestionar mis preferencias",
    "myInterestsButtonLabel": "Gestionar mis intereses",
    "myActivitySectorsButtonLabel": "Mis sectores de actividad",
    "myProfileButtonLabel": "Perfil público",
    "mySubscriptionButtonLabel": "Gestionar mi suscripción",
    "otherTitle": "Otros",
    "darkModeLabel": "Modo oscuro",
    "title": "Mi perfil",
    "tosButtonLabel": "Condiciones y privacidad",
    "editAvatarButton": "Editar avatar",
    "profilePictureChangedToast": "Foto de perfil modificada",
    "unavailableButtonLabel": "Marcarme como <strong>no disponible...</strong>",
    "unavailableStatusInformation": "Desde <strong>{{startDate}}</strong> hasta <strong>{{endDate}}</strong>",
    "unavailableStatusTitle": "Estado",
    "unavailableStatusBadge": "No disponible",
    "deleteStatus": "Eliminar mi estado",
    "deleteStatusToast": {
      "title": "Tu estado de indisponibilidad ha sido eliminado"
    },
    "editStatusAccessibilityLabel": "Editar estado de no disponibilidad",
    "unavailableStatusWarning": "Indisponibilidad prevista del <strong>{{startDate}}</strong> al <strong>{{endDate}}</strong>"
  },
  "my-ratings": {
    "title": "Evaluaciones",
    "loading": "Cargando evaluaciones...",
    "tabs": {
      "given": "Dadas ({{count}})",
      "received": "Recibidas ({{count}})"
    }
  },
  "publicUserWelcome": {
    "title": "¡Gracias!",
    "instructions": "¡Tu cuenta está lista! Pronto podrás ayudar a los horticultores y recibir donaciones de excedentes.",
    "enableNotificationsPrompt": "¡Activa las notificaciones para ser avisado/a desde la apertura!",
    "notificationsEnabled": "Las notificaciones están activadas. ¡Serás avisado/a desde la apertura!",
    "buttonEnableNotifications": "Activar mis notificaciones",
    "buttonLater": "Más tarde"
  },
  "quick-new-choose": {
    "buttonText": "Continuar",
    "secondaryButtonText": "Annuler",
    "headerText": "Al publicar objetos, aumentas la confianza de los demás hacia ti.",
    "headerTextHalloween": "Se acerca <strong>Halloween</strong>, los miembros buscan estos disfraces. ¿Los tienes?",
    "headerTitle": "Publicar una oferta múltiple",
    "nothingSelectedError": {
      "buttonText": "Volver",
      "text": "Debes seleccionar al menos un objeto para continuar.",
      "title": "Selecciona 1+ objeto(s)"
    }
  },
  "quick-new-confirm": {
    "buttonText": "Publicar ({{num}})",
    "secondaryButtonText": "Volver",
    "headerText": "Al <strong>presionar Publicar</strong>, los objetos seleccionados se publicarán <strong>en tu perfil</strong> y otras personas <strong>podrán pedírtelos prestados</strong>",
    "headerTitle": "Confirmación",
    "almostThere": "¡Ya casi llegamos!"
  },
  "quick-new-thanks": {
    "bodyText": "Puedes en cualquier momento ir a modificar tus ofertas en tu centro de intercambios.\n\nTu perfil está completo, ¡estás listo/a para empezar a <strong>prestar!</strong>",
    "buttonBackText": "Ir al tablón de anuncios",
    "buttonListingsText": "Ver mis anuncios",
    "buttonAddLoanFeeText": "Agregar un cargo de intercambio",
    "didYouKnowTitle": "¿Sabías que...?",
    "didYouKnowBody": "Los objetos con una foto real tienen 3 veces más probabilidades de ser prestados. ¡Puedes ir a ver tus anuncios para mejorarlos!",
    "headerText": "¡Gracias!",
    "headerTitle": "¡Gracias!",
    "myImpactLevelButtonText": "Ver mi impacto",
    "userNowContributorText": "Accedes a un nivel superior: <strong>Colaborador</strong>. Al publicar tu primera oferta, has aumentado tu impacto."
  },
  "ratings": {
    "confirmation": {
      "cancel": "Cancelar la recomendación",
      "text1": "<strong>¡Recomendaste a {{name}}!</strong>",
      "text2": "<strong>Gracias</strong> (de su parte también) 😊",
      "text3": "Puedes ver el número de recomendaciones de los miembros en su perfil y en varios lugares donde aparece su foto."
    },
    "notGreat": {
      "chatPrompt": "¡Hola {{name}}! 😊\n\nGracias por tomarte el tiempo de compartir tu experiencia. Entonces, ¿qué pasó?",
      "ctaButton": "Contactar a Partage Club",
      "text1": "Gracias por tu comentario.",
      "text2": "Lamentamos que la experiencia no haya sido positiva. 😔 ¿Quieres que hablemos al respecto para que podamos entender qué pasó?"
    },
    "prompt": {
      "text1": "¿Dejar una reseña para {{name}}?",
      "text2": "Comparte tu experiencia para que otros no duden en hacer lo mismo :)",
      "ctaButton": "Dejar una reseña"
    },
    "promptFigma": {
      "title": "¿Tuviste una gran experiencia?\n¡Compártela!",
      "subtitle": "Tus comentarios ayudan a construir una comunidad más confiable"
    },
    "ratingPrompt": {
      "text": "¡Tu reseña ha sido publicada! Gracias por tomarte el tiempo de compartir tu experiencia."
    },
    "rated": {
      "recommended": "Ya recomendaste a {{name}}",
      "notRecommended": "No recomendaste a {{name}}"
    },
    "newRating": {
      "title": "Evalúa este intercambio",
      "intro": "Tu evaluación honesta ayuda a construir una comunidad más confiable. Califica cada aspecto del 1 al 5.",
      "finalNotice": "Las evaluaciones son definitivas y no podrán editarse después.",
      "tapToRate": "Toca un número para evaluar",
      "commentTitle": "¿Algo que quieras agregar?",
      "commentHelp": "Visible solo para el equipo de Partage Club. Úsalo para reportar problemas o aportar contexto.",
      "commentPlaceholder": "Nota interna (opcional)...",
      "submitButton": "Enviar evaluaciones",
      "errorTitle": "Algo salió mal",
      "errorMessage": "No pudimos guardar tus evaluaciones. Inténtalo de nuevo.",
      "notReadyMessage": "Este intercambio debe estar completamente terminado antes de dejar una evaluación. Si devolviste el objeto, espera la confirmación de la otra persona.",
      "figmaHeaderTitle": "Escribir una evaluación",
      "figmaStepLabel": "Paso {{count}} de 2",
      "figmaStepCounter": "{{current}} de {{total}}",
      "figmaSubjectBorrowerLabel": "Prestatario/a",
      "figmaRecommended": "Recomendado",
      "figmaNotRecommended": "No recomendado",
      "figmaOverallQuestion": {
        "lender": "¿Tu experiencia prestando salió bien?",
        "borrower": "¿Tu experiencia pidiendo prestado salió bien?"
      },
      "figmaInfoPrompt": "Objeto devuelto el {{date}} · {{count}} d de préstamo",
      "figmaQuestions": {
        "lender": {
          "assetQuality": {
            "question": "¿En qué estado estaba el objeto al devolverlo?",
            "labels": {
              "1": "Muy dañado",
              "2": "Dañado",
              "3": "Estado aceptable",
              "4": "Buen estado",
              "5": "Como nuevo"
            }
          },
          "logisticsReliability": {
            "question": "¿Esta persona respetó la hora del encuentro?",
            "labels": {
              "1": "Muy tarde",
              "2": "Tarde",
              "3": "Ligeramente tarde",
              "4": "Puntual",
              "5": "Muy puntual"
            }
          },
          "communityTrust": {
            "question": "¿Cómo fue la acogida y el contacto con esta persona?",
            "labels": {
              "1": "Muy desagradable",
              "2": "Algo frío",
              "3": "Correcto",
              "4": "Cálido",
              "5": "Excelente"
            }
          }
        },
        "borrower": {
          "assetQuality": {
            "question": "¿El objeto coincidía con el anuncio y funcionaba correctamente?",
            "labels": {
              "1": "Nada conforme",
              "2": "Poco conforme",
              "3": "Bastante conforme",
              "4": "Conforme",
              "5": "Totalmente conforme"
            }
          },
          "logisticsReliability": {
            "question": "¿Esta persona respetó la hora del encuentro?",
            "labels": {
              "1": "Muy tarde",
              "2": "Tarde",
              "3": "Ligeramente tarde",
              "4": "Puntual",
              "5": "Muy puntual"
            }
          },
          "communityTrust": {
            "question": "¿Cómo fue la acogida y el contacto con esta persona?",
            "labels": {
              "1": "Muy desagradable",
              "2": "Algo frío",
              "3": "Correcto",
              "4": "Cálido",
              "5": "Excelente"
            }
          }
        }
      },
      "figmaAddDetailsTitle": "Añade detalles",
      "figmaImproveListingTitle": "Mejora el anuncio",
      "figmaAddPhotoTitle": "Añadir una foto del objeto",
      "figmaModifyPhotoTitle": "Modificar la foto del objeto",
      "figmaCommentTitle": "Deja un comentario",
      "figmaOptional": "(opcional)",
      "figmaRequired": "(obligatorio)",
      "figmaCommentPlaceholder": "Recientemente pedí prestado un libro a Jean y fue una experiencia muy positiva...",
      "figmaPublicCommentHint": "Tu evaluación será visible públicamente",
      "figmaDetailSectionTitle": "Evalúa los aspectos clave",
      "figmaContinueButton": "Continuar",
      "figmaSubmitButton": "Enviar",
      "thanks": {
        "title": "¡Gracias por tu evaluación!",
        "subtitle": "Ayudas a construir una comunidad más <strong>confiable</strong>",
        "negativeSubtitle": "Lamentamos que la experiencia no haya sido positiva. Revisaremos tu evaluación en detalle.",
        "button": "Terminar",
        "editButton": "Modificar mi evaluación"
      },
      "reciprocity": {
        "title": "Tu turno de compartir",
        "description": "¿Tu préstamo salió bien? Publica los objetos que uses poco y ayuda a la comunidad a tu vez.",
        "publish": "Publicar mis objetos",
        "later": "Más tarde"
      },
      "badges": {
        "lender": {
          "assetQuality": {
            "negative": "Devuelto en mal estado",
            "neutral": "Cuidó el objeto",
            "positive": "Cuidó el objeto"
          },
          "logisticsReliability": {
            "neutral": "Puntualidad",
            "negative": "Puntualidad",
            "medium": "Puntualidad",
            "positive": "Puntualidad"
          },
          "communityTrust": {
            "neutral": "Cortesía",
            "negative": "Cortesía",
            "medium": "Cortesía",
            "positive": "Cortesía"
          }
        },
        "borrower": {
          "assetQuality": {
            "negative": "Objeto no conforme",
            "neutral": "Conformidad del objeto",
            "positive": "Conformidad del objeto"
          },
          "logisticsReliability": {
            "neutral": "Puntualidad",
            "negative": "Puntualidad",
            "medium": "Puntualidad",
            "positive": "Puntualidad"
          },
          "communityTrust": {
            "neutral": "Cortesía",
            "negative": "Cortesía",
            "medium": "Cortesía",
            "positive": "Cortesía"
          }
        }
      }
    }
  },
  "reset-password": {
    "codeFieldLabel": "Código de confirmación recibido",
    "codeFieldPlaceholder": "ej: 123456",
    "details": "Te enviamos un código de confirmación por correo electrónico. Ingrésalo a continuación y luego elige una nueva contraseña.",
    "passwordFieldLabel": "Tu nueva contraseña",
    "passwordFieldPlaceholder": "Elige una nueva contraseña",
    "primaryButtonText": "Cambiar mi contraseña",
    "title": "Elegir una nueva contraseña"
  },
  "settingsPrompt": {
    "camera": {
      "title": "Autorizar el acceso a la cámara",
      "text": "Para permitirnos acceder a la cámara, ve a la configuración de tu dispositivo y activa el permiso correspondiente."
    },
    "notification": {
      "title": "Autorizar las notificaciones",
      "text": "Para permitirnos enviarte notificaciones, ve a la configuración de tu dispositivo y activa las notificaciones."
    },
    "primaryButtonText": "Ir a Configuración",
    "secondaryButtonText": "Cancelar"
  },
  "signup": {
    "guestTitle": "¡Únete a {{appName}}!",
    "guestCreateAccount": "Crear una cuenta",
    "title": "Crear mi cuenta",
    "alreadyHaveAccountPrefix": "¿Ya tienes una cuenta?",
    "alreadyHaveAccount": "Iniciar sesión",
    "signUpWithEmail": "Registrarse con un correo electrónico",
    "signUpWithApple": "Registrarse con Apple",
    "signUpWithFacebook": "Registrarse con Facebook",
    "signUpWithGoogle": "Registrarse con Google",
    "continueWithApple": "Continuar con Apple",
    "continueWithFacebook": "Continuar con Facebook",
    "continueWithGoogle": "Continuar con Google",
    "enterValidationCode": "Ingresar el código de validación"
  },
  "splash": {
    "poweredBy": "Desarrollado por"
  },
  "presentPartageClub": {
    "headerTitle": "Bienvenido a Partage Club",
    "title": "Bienvenido a Partage Club",
    "community": {
      "headerText": "Partage Club es la aplicación de <strong>intercambio de objetos</strong> entre vecinos.",
      "footerText": "Disfruta <strong>plenamente</strong> de la vida, sin limitarte a lo que posees."
    },
    "accessMore": {
      "headerText": "En Partage Club, accedes a una <strong>abundancia de objetos</strong>.",
      "footerText": "Equipamiento deportivo, herramientas, juegos para niños, etc.: aquí encuentras <strong>de todo de verdad.</strong>"
    },
    "offerMore": {
      "headerText": "En Partage Club, tu <strong>generosidad</strong> marca una verdadera <strong>diferencia</strong>.",
      "footerText": "Haz <strong>disfrutar</strong> a los demás de tus objetos poco utilizados. Hace bien."
    },
    "button": {
      "noAccountYet": "Unirse a la comunidad",
      "alreadyHaveAnAccount": "Ya tengo una cuenta"
    }
  },
  "presentCommunity": {
    "headerTitle": "Bienvenido a la comunidad",
    "title": "Presentación de la comunidad",
    "newFlow": {
      "continue": "Continuar",
      "continueWithoutArrow": "Continuar",
      "startSharing": "¡Empieza a compartir!",
      "continueFree": "Continuar gratis",
      "subscribeNow": "Suscribirse ahora",
      "yearlyPrice": "{{annualPrice}}/año ({{monthlyPrice}}/mes). Cancela en cualquier momento",
      "includedToday": "Lo que incluye hoy:",
      "includedWith": "Lo que incluye",
      "unlimitedLending": "Préstamos ilimitados",
      "unlimitedLendingDescription": "Publica ofertas y presta tus objetos a tus vecinos tantas veces como quieras",
      "oneFreeBorrow": "1 préstamo gratuito",
      "oneFreeBorrowPrefix": "1 préstamo",
      "oneFreeBorrowHighlight": "gratuito",
      "oneFreeBorrowDescription": "Pide prestado tu primer objeto a tus vecinos gratis",
      "unlimitedBorrowing": "Préstamos ilimitados",
      "damageCoverage": "Cobertura para objetos compartidos",
      "learnMore": "Más información",
      "coverageFootnote": "*La Responsabilidad de Partage Club cubre hasta 300 $ por los objetos prestados o tomados prestados.",
      "free": {
        "title": "¡Empieza gratis!",
        "subtitle": "Descubre la alegría de compartir sin costo."
      },
      "sponsored": {
        "title": "¡Tu suscripción\nes gratis!",
        "subtitle": "Disfruta de la experiencia completa gracias a",
        "offeredBy": "Ofrecido por:"
      },
      "upsell": {
        "title": "Comparte\ncon tranquilidad",
        "subtitle": "Suscríbete para activar la cobertura de tus objetos compartidos.",
        "withSubscription": "Al suscribirte a",
        "damageCoverageDescription": "Para los objetos prestados y tomados prestados"
      },
      "success": {
        "title": "¡Gracias, {{name}}!",
        "subtitle": "Tu suscripción está activa y ahora tienes acceso a la experiencia completa",
        "yourSubscription": "Tu suscripción",
        "currentPlan": {
          "monthly": "Actualmente tienes una suscripción mensual.",
          "yearly": "Actualmente tienes una suscripción anual.",
          "no": "Tu suscripción está activa."
        },
        "billingNote": {
          "monthly": "*Se te cobrará {{price}} / mes en la fecha de renovación. Cancela hasta 24 horas antes de la fecha de tu próximo pago.",
          "yearly": "*Se te cobrará {{price}} / año en la fecha de renovación. Cancela hasta 24 horas antes de la fecha de tu próximo pago."
        },
        "nextPayment": "Próximo pago",
        "cancelAnytime": "Cancela en cualquier momento",
        "cancellationDescription": "Puedes cancelar tu suscripción hasta 24 h antes de la fecha de tu próximo pago. Tu suscripción se renovará cada año."
      }
    },
    "congratulation": {
      "congratulation": "¡Felicitaciones!",
      "text1": "{{name}}, eres oficialmente compartidor/a.",
      "text2": "Obtuviste una suscripción gratuita",
      "text3": "Gracias a {{name}}, tu suscripción es gratuita. 🎉\n\n",
      "text4": "¡Aprovecha para compartir de forma ilimitada con la comunidad!",
      "freeTrial": {
        "text1": "Ahora tienes\nacceso a la comunidad.",
        "text2": "1 préstamo gratuito",
        "text3": "¿Prestar? Siempre gratis.",
        "text4": "Después, si quieres seguir tomando prestado, elige tu suscripción:",
        "text5": "No cobramos nada sin tu consentimiento.",
        "price": {
          "yearly": {
            "CAD": "60 $ (anual, ahorra 36 $)",
            "EUR": "72 € (anual, ahorra 36 €)",
            "USD": "72 USD (anual, ahorra 36 USD)"
          }
        }
      },
      "buttonText": "Siguiente"
    },
    "responsibility": {
      "headerText": "¡Partage Club es <strong>responsable</strong>!",
      "footerText": "Gracias a tu suscripción, si un objeto de un valor de 25 $ o más resulta dañado durante un préstamo, te indemnizamos <strong>hasta 300 $ al año.</strong>"
    },
    "respect": {
      "headerText": "¡Una comunidad <strong>atenta</strong> y <strong>respetuosa</strong>!",
      "footerText": "<strong>Menos del 1 %</strong> de los objetos prestados resultan dañados. Y a menudo, vuelven incluso más limpios. Es mágico."
    },
    "transaction": {
      "headerText": "En Partage Club, <strong>no hay ningún intercambio de dinero</strong>",
      "footerText": "El intercambio no es un alquiler. Aquí, nos <strong>ayudamos</strong>. <strong>Prestamos</strong>. \n<strong>Tomamos prestado</strong>."
    },
    "trust": {
      "headerText": "En Partage Club, la <strong>confianza</strong> es lo <strong>primero</strong>",
      "footerText": "Priorizamos los <strong>intercambios en lugares públicos</strong> y usamos un sistema de recomendaciones para mantenerte <strong>seguro/a</strong>."
    },
    "free": {
      "headerText": "En Partage Club, <strong>prestar</strong> es 100 % gratuito",
      "footerText": "Y si eres de los que ayudan seguido, podemos incluso reconocerte como <strong>embajador/a</strong> y ofrecerte tu suscripción."
    },
    "button": {
      "next": "Siguiente",
      "previous": "Anterior",
      "skip": "Omitir"
    }
  },
  "quickInterest": {
    "headerTitle": "Intereses",
    "title": "¿Cuáles son tus intereses?",
    "subtitle": "Personaliza tus recomendaciones y recibe notificaciones de nuevas ofertas.",
    "instruction": "Selecciona uno o más intereses:",
    "nothingSelectedError": {
      "buttonText": "Volver",
      "text": "Debes seleccionar al menos un interés para continuar.",
      "title": "Selecciona 1+ interés(es)"
    },
    "button": {
      "confirm": "Confirmar",
      "skip": "Quizás más tarde"
    }
  },
  "borrowerNext": {
    "headerTitle": "Pedir prestado",
    "title": "¿Qué te gustaría hacer ahora?",
    "searchLabel": "Busca un objeto específico",
    "searchPlaceholder": "Gofrera, limpiador de alfombras…",
    "inspirationButton": "Necesito inspiración"
  },
  "lenderNext": {
    "headerTitle": "Prestar",
    "title": "¿Qué te gustaría hacer ahora?",
    "specificObjectButton": "Tengo un objeto específico para prestar",
    "inspirationButton": "Necesito inspiración"
  },
  "interests": {
    "headerTitle": "Intereses",
    "title": "Intereses",
    "nothingSelectedError": {
      "buttonText": "Volver",
      "text": "Debes seleccionar al menos un objeto para continuar.",
      "title": "Selecciona 1+ objeto(s)"
    },
    "explain": {
      "title": {
        "borrower": "¡Estimado/a\nprestatario/a!",
        "lender": "¡Estimado/a\nprestador/a!",
        "both": "¡Estimado/a\nprestatario/a!"
      },
      "subtitle": {
        "borrower": "Cuéntanos qué te gusta y qué sueñas con probar para que te propongamos objetos hechos para ti.",
        "lender": "Muestra a los otros miembros lo que tienes para ofrecer.\n\n¿Necesitas inspiración?\nCuéntanos un poco sobre ti y te sugeriremos ideas de objetos para prestar.",
        "both": "Cuéntanos qué te gusta y qué sueñas con probar para que te propongamos objetos hechos para ti."
      }
    },
    "chooseTag": {
      "title": {
        "borrower": "¿Cuáles son tus intereses?",
        "lender": "Elige las categorías de objetos que posees",
        "both": "¿Cuáles son tus intereses?"
      },
      "subtitle": {
        "borrower": "¿Te gusta el camping o los juegos de mesa? Agrega tus intereses a tu perfil y déjanos mostrarte lo que podría gustarte.",
        "lender": "Eso nos ayudará a sugerirte ideas de objetos para prestar.",
        "both": "¿Te gusta el camping o los juegos de mesa? Agrega tus intereses a tu perfil y déjanos mostrarte lo que podría gustarte."
      }
    },
    "chooseListing": {
      "title": {
        "borrower": "{{name}}",
        "lender": "{{name}}",
        "both": "{{name}}"
      },
      "subtitle": {
        "borrower": "¡Encontramos objetos que corresponden a tus intereses! Agrégalos a tus favoritos.",
        "lender": "Encontramos objetos frecuentemente solicitados que podrías prestar.",
        "both": "¡Encontramos objetos que corresponden a tus intereses! Agrégalos a tus favoritos."
      },
      "aggregateTitle": {
        "borrower": "Según las categorías elegidas, aquí tienes objetos que podrían interesarte.",
        "lender": "Según las categorías elegidas, encontramos objetos muy solicitados que podrías prestar.",
        "both": "Según las categorías elegidas, aquí tienes objetos que podrían interesarte."
      }
    },
    "button": {
      "continue": "Continuar",
      "completeProfile": "Completar mi perfil",
      "skip": "Quizás más tarde",
      "modifyInterests": "Modificar mis intereses",
      "pass": "Omitir"
    },
    "loading": "Cargando sugerencias...",
    "noListingsFound": "Lamentablemente, no se encontró ningún objeto para esta categoría."
  },
  "ambassador": {
    "title": "Espacio Embajador·a",
    "banner": {
      "title": "¡Haz brillar el intercambio!",
      "subtitle": "Conviértete en Embajador·a y desarrolla la comunidad"
    },
    "subtitle": {
      "isAmbassador": "Eres\n<strong>Embajador·a</strong>",
      "notYetAmbassador": "Convertirse en\n<strong>Embajador·a</strong>"
    },
    "description": {
      "isAmbassador": "Un·a embajador·a es un miembro comprometido que <strong>contribuye activamente a hacer vivir el intercambio en su comunidad</strong>.\n\nActúa como <strong>referente local</strong>, facilita los intercambios y ayuda a Partage Club a crecer de forma humana y auténtica.",
      "notYetAmbassador": "Un·a embajador·a es un miembro comprometido que <strong>contribuye activamente a hacer vivir el intercambio en su comunidad</strong>.\n\nActúa como <strong>referente local</strong>, facilita los intercambios y ayuda a Partage Club a crecer de forma humana y auténtica."
    },
    "showMore": "ver más",
    "showLess": "ver menos",
    "ctaButton": "Convertirse en embajador·a",
    "channelDiscussion": "Canal de discusión",
    "advantages": {
      "titleIsAmbassador": "Tus ventajas",
      "titleNotYet": "Las ventajas",
      "advantage1": {
        "title": "Formar parte de una comunidad",
        "body": "Personas de tu barrio que, como tú, quieren crear resiliencia local"
      },
      "advantage2": {
        "title": "Suscripciones gratuitas",
        "body": "Tu suscripción es gratuita y podemos proporcionarte más al organizar eventos"
      },
      "advantage3": {
        "title": "Poder de decisión",
        "body": "Da tu opinión sobre las futuras prioridades y proyectos de Partage Club y del programa embajador"
      },
      "advantage4": {
        "title": "Invitaciones especiales a eventos de Partage Club",
        "body": "Participa en encuentros anuales con embajadores·as de la zona"
      },
      "advantage5": {
        "title": "Acceso a objetos proporcionados por Partage Club",
        "body": "Guarda objetos en acogida y disfruta del acceso a ellos"
      },
      "advantage6": {
        "title": "Promociones especiales en lugares de intercambio (próximamente)",
        "body": "Disfruta de promociones ofrecidas por los lugares de intercambio cerca de ti: descuentos, regalos y más..."
      }
    },
    "mission": {
      "title": "La misión",
      "description": "<strong>Ser Embajador·a...</strong>\nEs hacer brillar la misión del intercambio a tu escala, de la forma que te caracteriza. Cada uno se implica según su tiempo, sus ganas y sus fortalezas.",
      "mission1": "Representar la marca con autenticidad",
      "mission2": "Inspirar y movilizar a su comunidad: dar ganas de compartir, dar ejemplo y crear un efecto contagio en su barrio",
      "mission3": "Reclutar nuevos miembros",
      "mission4": "Compartir objetos",
      "concreteTitle": "Concretamente, esto puede significar:",
      "concreteIntro": "",
      "concrete1": "Dar a conocer Partage Club en tu entorno",
      "concrete2": "Guardar objetos en acogida en casa",
      "concrete3": "Organizar actividades y momentos de intercambio",
      "concrete4": "Participar en la creación de contenido",
      "concrete5": "Proponer tus propias ideas...",
      "learnMore": "Saber más"
    }
  },
  "streak": {
    "headerTitle": "Racha del barrio",
    "headerTitleDaily": "Racha diaria",
    "title": "Racha del barrio",
    "thisMonth": "Este mes",
    "monthlyStreak": "Racha mensual",
    "members": "Miembros",
    "membersCount_one": "{{displayCount}} miembro",
    "membersCount_other": "{{displayCount}} miembros",
    "noMembers": "Todavía no hay miembros en esta racha del barrio.",
    "objective": "Objetivo de este mes",
    "shares": "compartidos",
    "daysRemaining_one": "{{count}} día restante",
    "daysRemaining_other": "{{count}} días restantes",
    "myContribution": "Mi contribución: {{count}}",
    "savedThisMonth": "ahorrados este mes",
    "viewMyImpact": "Ver mi impacto",
    "objectiveDetailsTitle": "Detalles del objetivo",
    "objectiveDetails": "El objetivo del mes se determina en función del número de vecinos que comparten a tu alrededor y la madurez de tu vecindario.",
    "seriesDetailsTitle": "Racha mensual",
    "seriesDetails": "Para mantener viva la llama del compartir, tú y tus vecinos deben alcanzar el objetivo de compartidos indicado para el mes.",
    "dailyContributions": "Contribuciones diarias",
    "contributionDetailsTitle": "Contribución diaria",
    "contributionDetails": "Las contribuciones son todas las acciones que fomentan el compartir, como publicar ofertas/solicitudes, agregar ofertas a favoritos y responder a solicitudes.",
    "currentStreakLabel": "Racha actual",
    "days": "días",
    "day": "Día {{day}}",
    "contributeDailyTitle": "¡Contribuye a diario para mantener tu llama!",
    "makeMyDailyContribution": "Hacer mi contribución de hoy",
    "alreadyContributedToday": "Contribución de hoy realizada ✓",
    "myProgress": "¿Cómo hacer mi primera acción de intercambio?",
    "tips": {
      "publishRequest": {
        "title": "Publica una solicitud para pedir prestado",
        "description": "¿Necesitas un objeto? Los miembros a tu alrededor intentarán ayudarte."
      },
      "browseCatalog": {
        "title": "Explora el catálogo",
        "description": "Explora el catálogo y propón fechas de préstamo."
      },
      "helpNeighbours": {
        "title": "Intenta ayudar a tus vecinos·as",
        "description": "Explora las solicitudes de los miembros a tu alrededor; puedes ocultar las que no puedas atender."
      },
      "publishOffer": {
        "title": "Publica una oferta para prestar",
        "description": "Publica un objeto específico o elige entre los objetos sugeridos."
      }
    },
    "neighbourhoodFirstShare": "En tu barrio, <strong>{{percent}}% de tus vecinos·as</strong> hicieron su primer intercambio <strong>en menos de una semana</strong>",
    "empty": {
      "title": "¡Inicia tu racha y contribuye ahora!",
      "cta": "Enciende la llama del compartir"
    },
    "contributions": {
      "add_avatar": {
        "title": "Añade una foto",
        "description": "Una foto de perfil tranquiliza a tus vecinos·as y te hace reconocible en el barrio.",
        "cta": "Añadir mi foto"
      },
      "add_bio": {
        "title": "Añade una bio",
        "description": "Preséntate en pocas palabras para animar a otros miembros a prestarte y a pedirte cosas prestadas.",
        "cta": "Añadir mi bio"
      },
      "publish_offer": {
        "title": "Publicar una oferta",
        "description": "Publica un objeto específico, o elige entre los objetos sugeridos ya compartidos por nuestros vecinos.",
        "cta": "Publicar una oferta"
      },
      "publish_request": {
        "title": "Publicar una necesidad",
        "description": "¿Necesitas un objeto? Publica una necesidad y los miembros a tu alrededor intentarán responder.",
        "cta": "Publicar una necesidad"
      },
      "dismiss_request": {
        "title": "Intenta ayudar a tus vecinos",
        "description": "Explora las necesidades de los miembros a tu alrededor; puedes ocultar las que no puedas atender.",
        "cta": "Explorar necesidades"
      },
      "send_message": {
        "title": "Envía un mensaje",
        "description": "¡Rompe el hielo! Escribe a un·a vecino·a para ofrecer tu ayuda o para saber más sobre un anuncio.",
        "cta": "Ir a mis conversaciones"
      },
      "add_favourite": {
        "title": "Guardar ofertas en favoritos",
        "description": "Explora el catálogo y guarda las ofertas relevantes para volver a ellas más tarde.",
        "cta": "Explorar ofertas"
      }
    },
    "skip": "Ver otra sugerencia"
  },
  "superPartageur": {
    "title": "Super Compartidor",
    "subtitle": {
      "isSuper": "Eres\n<strong>Super Compartidor</strong>",
      "notYetSuper": "Convertirse en\n<strong>Super Compartidor</strong>"
    },
    "requirements": {
      "trustPoints": {
        "emoji": "👍",
        "title": "{{value}} recomendaciones",
        "description": "De {{requiredValue}} requeridas"
      },
      "responseRate": {
        "emoji": "🛎️",
        "title": "Tasa de respuesta de {{value}} %",
        "description": "Debe ser superior a {{requiredValue}} %"
      },
      "lastActiveDays": {
        "emoji": "⏱️",
        "title": "Activo/a",
        "description": "En los últimos {{requiredValue}} días"
      }
    },
    "learnMore": "Detalles de los criterios"
  },
  "superPartageurDetails": {
    "title": "Detalles de los criterios",
    "title2": "Super Compartidor",
    "description": "¿Qué es un Super Compartidor?\nUn miembro compartidor que se compromete de forma constante con la comunidad.\n\n¡Buena noticia: cualquiera puede convertirse en uno! Los criterios son simples y se evalúan automáticamente cada día.\n\nPara obtener tu insignia, solo tienes que cumplir estas 3 condiciones:",
    "requirements": {
      "trustPoints": {
        "title": "Recomendaciones",
        "description": "Obtén <strong>{{requiredValue}} recomendaciones positivas (👍)</strong> de miembros después de un intercambio, ya sea un préstamo o un préstamo recibido."
      },
      "responseRate": {
        "title": "Tasa de respuestas",
        "description": "¡No juegues a desaparecer! 👻\n\nMantén una tasa de respuesta a los mensajes de los miembros <strong>superior a {{requiredValue}} %</strong>."
      },
      "lastActiveDays": {
        "title": "Activo/a",
        "description": "Debes haber abierto la aplicación <strong>al menos una vez en los últimos {{requiredValue}} días</strong>."
      }
    }
  },
  "superPartageurNotification": {
    "title": {
      "isSuper": "¡Felicitaciones\n{{name}}!",
      "lostSuper": "¿Tu insignia desapareció?\nEs normal."
    },
    "description": {
      "lostSuper": "Actualizamos los criterios de la insignia Super Compartidor. Ya no basta con compartir: tu insignia evoluciona ahora según tu actividad, tus recomendaciones y tu tasa de respuesta.",
      "keptSuper": "Conservas tu insignia de <strong>Super Compartidor</strong>, incluso con los nuevos criterios.",
      "isNowSuper": "Ahora eres\n<strong>Super Compartidor</strong>."
    },
    "progress": {
      "one": "<strong>¡Genial, vas por buen camino!</strong>",
      "two": "<strong>¡Genial, casi llegas!</strong>"
    },
    "goToDetailsButton": "Ver los detalles"
  },
  "trialPromo": {
    "title": "¡Contribuye a hacer crecer el catálogo de Partage Club y gana tu suscripción!",
    "details": "¡Contribuye a hacer crecer el catálogo del <strong>Partage Club</strong>! ¡Publica 5 objetos y gana tu <strong>suscripción anual</strong>! 🥳",
    "primaryButtonText": "¡Crear un anuncio!",
    "numCreated0": "{{numOffersCreated}}/5 ofertas publicadas",
    "numCreated1": "{{numOffersCreated}}/5 oferta publicada",
    "numCreated": "{{numOffersCreated}}/5 ofertas publicadas"
  },
  "tutorial": {
    "guardian": {
      "step1": {
        "title": "Nuevo",
        "text": "Deja tu objeto al cuidado de la persona que lo tiene prestado durante el tiempo que quieras. Podrá utilizarlo y prestarlo a otras personas.",
        "cta": "Entendido"
      }
    },
    "finish": "Finalizar",
    "stepIndicator": "Paso {{current}} de {{total}}",
    "back": "Atrás",
    "chatCreation": {
      "step1": {
        "title": "Nuevo",
        "text": "Pulsa aquí para crear una conversación privada con otro miembro o una conversación de grupo",
        "cta": "Entendido"
      }
    },
    "firstConversation": {
      "step1": {
        "title": "Preséntate",
        "text": "Escríbele unas palabras al miembro para presentarte y expresar tu interés.",
        "cta": "Entendido"
      }
    },
    "chatIntro": {
      "step1": {
        "title": "👋 Preséntate",
        "text": "Escríbele unas palabras al miembro para presentarte y expresar tu interés.",
        "cta": "Siguiente"
      },
      "step2": {
        "title": "Proponer fechas para pedir prestado",
        "text": "Toca aquí para abrir el calendario y elegir una fecha de inicio y de fin para el préstamo. El prestador podrá luego aceptarla o rechazarla.",
        "cta": "Entendido"
      },
      "step2AltRequest": {
        "title": "Proponer fechas de préstamo",
        "text": "Toca aquí para abrir el calendario y elegir una fecha de inicio y de fin para el préstamo. El prestatario podrá luego aceptarla o rechazarla.",
        "cta": "Entendido"
      }
    },
    "firstMessageSent": {
      "step1": {
        "title": "Proponer fechas",
        "text": "Una vez cerrado el acuerdo, no olvides ingresar las fechas del préstamo para finalizar la reserva.",
        "cta": "Entendido"
      }
    },
    "next": "Siguiente",
    "multipleOffers": {
      "step1": {
        "title": "Publicar tu primer objeto",
        "text": "Al ofrecer tus objetos, animas incluso a los vecinos más tímidos a pedir."
      }
    },
    "publishOffers": {
      "step1": {
        "title": "Cuidar los objetos",
        "text": "Aquí reina la <strong>confianza</strong>. Todos los miembros se comprometen a respetar las reglas de oro.\n\nEn caso de problema, <strong>el equipo de Partage Club</strong> está a tu servicio en todo momento. (1/5)"
      },
      "step2": {
        "title": "Dar el primer paso",
        "text": "Al ofrecer tus objetos, animas incluso a <strong>tus vecinos más tímidos</strong> a pedir. Siempre puedes prestar tus objetos, <strong>incluso sin suscripción</strong>.\n\nPresiona el ícono para continuar. (2/5)"
      },
      "step2AltCorp": {
        "title": "Dar el primer paso",
        "text": "Al ofrecer tus objetos, animas incluso a <strong>tus vecinos más tímidos</strong> a pedir.\n\nPresiona el ícono para continuar. (2/5)"
      },
      "step3": {
        "title": "2 formas de ofrecer tus objetos en intercambio",
        "text": "Publica un objeto a la vez o varios objetos al mismo tiempo, con un clic. <strong>Selecciona la oferta múltiple</strong> para continuar. (3/5)"
      },
      "step4": {
        "title": "Tu anuncio está publicado",
        "text": "Puedes modificar tus anuncios en cualquier momento. (4/5)"
      },
      "step4AltPlural": {
        "title": "Tus anuncios están publicados",
        "text": "Puedes modificar tus anuncios en cualquier momento. (4/5)"
      },
      "step5": {
        "title": "Publicar un objeto a la vez",
        "text": "Puedes en cualquier momento publicar una oferta individual tomando una foto de tu objeto. (5/5)"
      },
      "stepFinal": {
        "title": "¡Bravo!",
        "text": "Ahora dominas el arte de compartir objetos.\n\nAumentaste tu impacto al publicar tu primera oferta. A partir de ahora accedes al nivel superior: Colaborador."
      }
    },
    "conciergerie": {
      "step1": {
        "title": "Nuevo",
        "text": "Cuando el asistente contacta a un miembro y este responde, la conversación se marca con un símbolo para ayudarte a identificarla"
      }
    },
    "homeExplore": {
      "stepIndicator": "Paso {{current}} de {{total}}",
      "back": "Atrás",
      "step1": {
        "title": "Busca un objeto",
        "text": "Usa la barra de búsqueda y los filtros para encontrar un objeto y hacer una solicitud de préstamo.",
        "cta": "Siguiente"
      },
      "step2": {
        "title": "Publica una oferta o una necesidad",
        "text": "Usa este botón rápido para publicar una oferta de préstamo de un objeto específico o elige entre las ofertas que ya hemos preparado. También puedes pedir ayuda a la comunidad publicando una necesidad.",
        "cta": "Siguiente"
      },
      "step3": {
        "title": "¿Cómo funciona?",
        "text": "Haz clic aquí para recibir ayuda sobre el proceso de intercambio.",
        "cta": "Entendido"
      }
    },
    "contactMember": {
      "step1": {
        "title": "¡Ya casi! Contáctalo",
        "text": "Tómate un momento para revisar los detalles de la publicación. Si corresponde a lo que buscas, toca aquí para contactar al prestador.",
        "cta": "Entendido"
      }
    }
  },
  "tutorialModal": {
    "publishOffers": {
      "ctaButton": "Comenzar (2 min)",
      "text": "<strong>Cómo ofrecer tus objetos en intercambio</strong>",
      "title": "Aprender el arte del intercambio"
    }
  },
  "listing-activity": {
    "headerTitle": "Actividad",
    "wantToHelp_one": "{{count}} miembro quiere ayudar",
    "wantToHelp": "{{count}} miembros quieren ayudar",
    "wantedToHelp_one": "{{count}} miembro quiso ayudar",
    "wantedToHelp": "{{count}} miembros quisieron ayudar",
    "leaveAMessage": "dejó un mensaje",
    "hasLent": "ha prestado"
  },
  "posts": {
    "newPost": {
      "title": "Comparte tu experiencia",
      "intro": "Ayuda a tu comunidad compartiendo una publicación corta sobre este intercambio. Podrás editarla más tarde.",
      "loading": "Cargando tu intercambio...",
      "exchangeLabel": "Tu intercambio",
      "exchangeHint": "Esta publicación estará vinculada a este objeto.",
      "unavailableTitle": "Este intercambio no está disponible",
      "unavailableText": "Solo la persona prestataria puede publicar, una vez por intercambio.",
      "goBack": "Volver",
      "addPhotos": "Agregar fotos",
      "optional": "Opcional",
      "publicBadge": "Post público",
      "publicHint": "Aparecerá en el feed de tu comunidad. No es una evaluación privada.",
      "dismissPublicHint": "Cerrar el aviso de publicación pública",
      "storyTitle": "Cuenta la historia",
      "storyHint": "Comparte lo que pasó, lo que te gustó o un detalle útil para los demás.",
      "textPlaceholder": "Cuéntanos sobre tu experiencia...",
      "photoHint": "Agrega hasta 10 fotos para darle vida a tu historia.",
      "submitButton": "Publicar post"
    },
    "editPost": {
      "listingLabel": "Anuncio relacionado",
      "title": "Editar reseña",
      "intro": "Puedes editar el mensaje que compartiste sobre este intercambio. Recuerda, este mensaje es público y visible para tu comunidad.",
      "addPhotos": "Agregar fotos",
      "publicBadge": "Post público",
      "publicHint": "Aparecerá en el feed de tu comunidad. No es una evaluación privada.",
      "storyTitle": "Cuenta la historia",
      "storyHint": "Comparte lo que pasó, lo que te gustó o un detalle útil para los demás.",
      "textPlaceholder": "Cuéntanos sobre tu experiencia...",
      "submitButton": "Guardar cambios"
    },
    "banner": {
      "lender": "Prestador",
      "borrower": "Prestatario"
    },
    "reviews": {
      "readMore": "Leer más",
      "loading": "Cargando reseñas...",
      "trustedMember": "{{count}} reseña de miembro de confianza",
      "trustedMember_plural": "{{count}} reseñas de miembros de confianza",
      "count": "{{count}} reseña",
      "count_plural": "{{count}} reseñas"
    },
    "feed": {
      "endOfFeed": {
        "status": "¡Ya lo has visto todo!",
        "title": "Ahora te toca contar tu historia.",
        "description": "Un objeto prestado, un nuevo encuentro…\nComparte tu historia con el vecindario.",
        "action": "Contar mi historia",
        "actionHint": "Elige un préstamo anterior para compartir tu historia."
      },
      "loading": "Cargando publicaciones...",
      "timeAgo": "hace {{time}}",
      "emptyTitle": "Aún no hay publicaciones",
      "emptyText": "Las historias de la comunidad aparecerán aquí después de un intercambio.",
      "readMore": "Leer más",
      "readLess": "Ver menos",
      "likes_one": "{{count}} me gusta",
      "likes_other": "{{count}} me gusta",
      "comments_one": "{{count}} comentario",
      "comments_other": "{{count}} comentarios",
      "aboutItem": "Sobre {{item}}",
      "listingLabel": "Anuncio",
      "likeAction": "Me gusta esta publicación",
      "unlikeAction": "Quitar me gusta de la publicación",
      "photoPosition": "Foto {{current}} de {{total}}",
      "openPhoto": "Abrir foto {{current}} de {{total}}",
      "postOptions": "Opciones de la publicación",
      "lenderLabel": "Prestamista",
      "lentBy": "Prestado por {{name}}",
      "loanContext": "{{lenderName}} prestó {{listingName}} a {{borrowerName}}",
      "loanContextShort": "Préstamo de {{listingName}}",
      "shareAction": "Compartir publicación",
      "editAction": "Editar publicación",
      "reportAction": "Reportar publicación",
      "cancel": "Cancelar",
      "shareCopied": "Se copiaron los detalles de la publicación",
      "reportPostPrompt": "Hola, me gustaría reportar una publicación de {{name}} sobre {{item}} porque me parece inapropiada. ¿Podrían revisarla?\n\nGracias."
    },
    "comments": {
      "title": "Comentarios",
      "emptyTitle": "Inicia la conversación",
      "empty": "Sé la primera persona en dejar un comentario.",
      "count_one": "1 comentario",
      "count_other": "{{count}} comentarios",
      "send": "Enviar comentario",
      "placeholder": "Escribe un comentario atento…",
      "postBy": "Publicación de {{name}}",
      "aboutItem": "Sobre {{item}}",
      "showPost": "Ver publicación completa",
      "showLess": "Ver menos",
      "publicHint": "Visible para la comunidad",
      "loadError": "No se pudieron cargar los comentarios.",
      "submitError": "No se pudo publicar tu comentario. Inténtalo de nuevo."
    },
    "storyComposer": {
      "addPhotos": "Añade ese momento en imágenes",
      "publicHint": "Compartido públicamente con tu comunidad.",
      "storyTitle": "Tu historia",
      "textPlaceholder": "Gracias a este préstamo, pude…",
      "photoHint": "Opcional · hasta 10 fotos",
      "submitButton": "Compartir mi historia",
      "composeTitle": "Dale vida a ese momento.",
      "composeHint": "Un proyecto, un descubrimiento, un gesto amable. Cuéntalo a tu manera.",
      "changeMemory": "Otro préstamo",
      "neighbour": "un vecino",
      "borrowedFrom": "Prestado por {{name}}",
      "borrowedOn": "Préstamo del {{date}}",
      "timeAgo": "Terminó hace {{time}}",
      "shortStoryHint": "Bastan unas pocas palabras",
      "starterHint": "¿Necesitas una idea para empezar?",
      "prompts": {
        "made": "Una creación",
        "tried": "Una primera vez",
        "thanks": "Un gracias"
      },
      "starters": {
        "made": "Gracias a este préstamo, creé ",
        "tried": "Fue la primera vez que probé ",
        "thanks": "Muchas gracias a {{name}} por "
      },
      "dismissPublicHint": "Cerrar el aviso de publicación pública",
      "discardTitle": "¿Descartar esta historia?",
      "discardMessage": "Si eliges otro préstamo, perderás el texto y las fotos de este borrador.",
      "keepWriting": "Seguir escribiendo",
      "discardStory": "Descartar historia"
    }
  },
  "unavailable": {
    "clearButtonLabel": "Eliminar",
    "clearHint": "Elimina este periodo si vuelves a estar disponible.",
    "selectRangeHint": "Selecciona una fecha de inicio y luego una de fin (toca el mismo día otra vez para un solo día).",
    "singleDayRangeHint": "Un día seleccionado: estarás no disponible todo ese día.",
    "title": "Marcarme como no disponible",
    "topInformation": "No estoy disponible durante este periodo...",
    "suspendNotificationsLabel": "¿Suspender las notificaciones?",
    "saveButtonLabel": "Guardar"
  },
  "listing-comments": {
    "title_zero": "Comentarios",
    "title_one": "1 comentario",
    "title_other": "{{count}} comentarios",
    "title": "Comentarios",
    "placeholder": "Agregar un comentario...",
    "send": "Enviar",
    "delete": "Eliminar",
    "empty": "Todavía no hay comentarios. ¡Sé el primero en hacer una pregunta!",
    "loginToComment": "Inicia sesión para dejar un comentario.",
    "showMore": "Ver {{count}} comentario(s) más",
    "showLess": "Ver menos"
  },
  "new-conversation": {
    "title": "Nuevo mensaje",
    "searchPlaceholder": "Introducir un nombre",
    "dmChat": "Conversación privada (solo 2 personas)",
    "groupChat": "Conversación grupal (3+ personas)",
    "noResults": "No se encontraron usuarios"
  },
  "new-group-chat": {
    "title": "Nuevo grupo",
    "groupNamePlaceholder": "Nombre del grupo (opcional)",
    "addMembers_one": "Añadir un miembro ({{count}})",
    "addMembers": "Añadir miembros ({{count}})",
    "minimumMembersError": "Añade al menos 2 miembros para crear una conversación grupal.",
    "searchPlaceholder": "Buscar un miembro",
    "next": "Siguiente",
    "noResults": "No se encontraron usuarios",
    "defaultGroupName_one": "Grupo ({{count}} miembro)",
    "defaultGroupName": "Grupo ({{count}} miembros)",
    "choosePhoto": "Elegir una foto",
    "choosePhotoHint": "Elige una imagen para personalizar la conversación de grupo"
  },
  "add-chat-members": {
    "title": "Añadir miembros",
    "addButton": "Añadir ({{count}})",
    "searchPlaceholder": "Buscar un miembro",
    "noResults": "No se encontraron usuarios",
    "alreadyMember": "Ya es miembro",
    "forbiddenTitle": "Solo los administradores pueden añadir miembros",
    "forbiddenBody": "Debes ser administrador del grupo para añadir miembros a esta conversación.",
    "backButton": "Volver"
  },
  "web-footer": {
    "apps": "Aplicaciones",
    "openingHours": {
      "title": "Horario de atención",
      "weekdays": "De lunes a viernes",
      "hours": "De 9 a 17 h"
    },
    "follow": {
      "title": "Síguenos"
    },
    "about": {
      "title": "Acerca de",
      "fundraising": "Recaudación de fondos",
      "pressKit": "Kit de prensa",
      "joinTeam": "Únete al equipo",
      "myCity": "Mi ciudad",
      "faq": "Preguntas frecuentes",
      "terms": "Términos y condiciones",
      "privacy": "Política de privacidad"
    },
    "community": {
      "title": "Comunidad",
      "gift": "Regalar",
      "ambassador": "Hazte embajador",
      "neighbourhood": "Tu barrio"
    }
  },
  "offer-hub": {
    "completedLists_one": "Lista completada",
    "completedLists_other": "Listas completadas",
    "title": "Crear ofertas",
    "heading": "¿Lo tienes? Compártelo.",
    "explanation": "Desliza a la derecha o toca «Lo tengo» para publicar al instante.",
    "accept": "Tengo esto",
    "reject": "No lo tengo",
    "visibility": "Compartido con {{destinations}}",
    "noDestinations": "ningún destino seleccionado",
    "editVisibility": "Cambiar dónde comparto",
    "doneEditing": "Listo",
    "selectDestination": "Elige al menos un barrio o club para publicar ofertas.",
    "loading": "Preparando tus sugerencias…",
    "retryLoading": "Volver a cargar",
    "storageError": "No se pudieron guardar algunas decisiones en este dispositivo. Mantén la aplicación abierta e inténtalo de nuevo para conservarlas.",
    "retry": "Reintentar",
    "loadError": "No se pudieron cargar tus sugerencias. Inténtalo de nuevo.",
    "progress": "{{current}} / {{total}}",
    "encouragement": "Unas decisiones. Más para compartir.",
    "completeTitle": "¡Bien hecho!",
    "completeDescription": "Cada elección cuenta. ¡Gracias por dedicarle un momento!",
    "caughtUp": "¡Todo explorado!",
    "caughtUpDescription": "Tu próximo objeto para compartir está en casa.",
    "more_one": "Probar 1 más",
    "more_other": "Probar {{count}} más",
    "challenge": "3 objetos para compartir.",
    "challengeDescription": "Los objetos cotidianos pueden alegrar el día a alguien. Busca en…",
    "viewOffers": "Ver mis ofertas",
    "failedTitle": "Estas decisiones necesitan atención",
    "otherWays": "¿Tienes otra idea?",
    "single": "Crear una oferta",
    "photos": "Unas fotos",
    "donate": "Donar un objeto",
    "edit": "Editar",
    "lastItem": "¡El último! Ya casi terminas.",
    "roundProgress": "Objetos revisados",
    "acceptHint": "Publica una oferta en los barrios y clubes seleccionados.",
    "published_one": "oferta publicada",
    "published_other": "ofertas publicadas",
    "pending_one": "elección guardándose",
    "pending_other": "elecciones guardándose",
    "failed_one": "por revisar",
    "failed_other": "por revisar",
    "pendingDescription": "Tus elecciones se están guardando. Puedes seguir explorando.",
    "singleDescription": "Añade un objeto que elijas.",
    "photosDescription": "Crea varias ofertas.",
    "eyebrow": "OFERTAS RÁPIDAS",
    "challengeEyebrow": "UNA PEQUEÑA BÚSQUEDA DEL TESORO",
    "huntCupboard": "Cocina",
    "huntLivingRoom": "Sala",
    "huntGarage": "Garaje",
    "startHunt": "Encontrar mis 3 tesoros",
    "huntPhotos": "Te ayudamos a convertir las fotos en ofertas.",
    "huntSingle": "Empieza por un objeto. Puedes añadir más después.",
    "remaining_one": "¡El último!",
    "remaining_other": "Quedan {{count}}",
    "chooseRoom": "¿Por dónde empezamos?",
    "roomPrompt": "Quizás tengas…",
    "kitchenIdeas": "Una gofrera, un molde para tartas, una batidora…",
    "livingIdeas": "Un juego de mesa, un proyector, una esterilla de yoga…",
    "garageIdeas": "Un taladro, una escalera, una bomba de bicicleta…",
    "photographFinds": "Fotografiar mis hallazgos",
    "tabs": {
      "suggestions": "Sugerencias",
      "photos": "Fotos",
      "manual": "Manual",
      "stories": "Historias"
    },
    "help": "Repetir el tutorial",
    "close": "Cerrar",
    "backToHub": "Volver a las sugerencias",
    "listRemaining": "{{count}} restante(s)",
    "beginTutorial": "¡Empezar ahora!",
    "startList": "Empezar una lista",
    "quickSignal_one": "¡Publica 1 objeto en {{seconds}} segundos!",
    "quickSignal_other": "¡Publica {{count}} objetos en {{seconds}} segundos!",
    "quickTitle": "Publicar objetos",
    "quickCardStart": "Empezar",
    "whyPublish": "¿Por qué publicar ofertas?",
    "benefitReciprocity": "Hace que los demás quieran devolverte el favor",
    "benefitTrust": "Los demás confiarán más en ti",
    "benefitKarma": "Es bueno para el karma",
    "resumeList": "Continuar la lista",
    "startTitle": "¿Tienes estos objetos?",
    "startDescription": "Revisa una lista de objetos listos para publicar al instante",
    "resumeTitle": "¡Ya casi terminas!",
    "resumeDescription": "Termina tu lista actual",
    "listComplete": "¡Terminaste esta lista!",
    "lifetimeStats": "Tus estadísticas desde que creaste tu cuenta",
    "publishedLabel": "Oferta(s) publicada(s)",
    "manageOffers": "Gestionar mis anuncios",
    "finish": "Terminar",
    "restart": "Reiniciar",
    "swipeTutorial": {
      "0": {
        "title": "¿Listo para publicar\nrápidamente?",
        "description": "Revisa una lista de objetos listos para publicar al instante"
      },
      "1": {
        "title": "¿Tienes el objeto? Desliza a la derecha",
        "description": "Podrás editar los detalles más tarde"
      },
      "2": {
        "title": "¿No tienes el objeto? Desliza a la izquierda",
        "description": "No volverás a ver este objeto en la lista"
      },
      "3": {
        "title": "¡Ya estás listo!",
        "description": "Ya sabes lo necesario para empezar tu primera lista"
      }
    },
    "tutorial": {
      "step": "Paso {{current}} de {{total}}",
      "back": "Atrás",
      "next": "Siguiente",
      "finish": "Terminar",
      "close": "Cerrar el tutorial",
      "steps": {
        "suggestions": {
          "title": "Ofertas rápidas sugeridas",
          "description": "Recorre una lista de ofertas preexistentes para publicarlas al instante"
        },
        "photos": {
          "title": "Publicar en lote",
          "description": "Haz fotos de varios objetos. Generamos las descripciones para que solo tengas que revisarlas antes de publicar las ofertas"
        },
        "manual": {
          "title": "Entrada manual",
          "description": "Crea tu oferta para un único objeto específico"
        }
      }
    },
    "listingTypes": {
      "offer": "Oferta",
      "request": "Necesidad"
    },
    "object": "Objeto",
    "storyLoadingError": "No se pudieron cargar tus anuncios.",
    "storyPickTitle": "¿Qué hizo posible ese préstamo?",
    "storyPickHint": "Detrás de cada objeto prestado hay un momento que contar. Recuerda un préstamo pasado para empezar tu historia.",
    "storyMemories": "Tus préstamos pasados",
    "storyLoading": "Buscando tus recuerdos de compartir…",
    "storyEmpty": "Tu próxima historia está por llegar. Cuando termines un préstamo, podrás compartir ese momento aquí."
  },
  "featurePresentations": {
    "title": "Novedad",
    "close": "Cerrar",
    "guardian": {
      "title": "¡Ahora puedes dejar tus objetos al cuidado de otra persona!",
      "description": "Si prestas un objeto de forma <strong>recurrente</strong> a la misma persona, puedes dejarlo a su <strong>cuidado</strong> durante el tiempo que quieras.\n\nCon tu permiso, también podrá prestar tu objeto a otras personas de la comunidad.\n\nEncontrarás esta opción en los detalles de un préstamo."
    }
  },
  "guardian": {
    "badge": "En custodia",
    "action": "Designar a {{name}} como guardián·a",
    "confirmation": "Confirmación",
    "confirmAssign": "Vas a designar a {{name}} como guardián·a de tu objeto.\n\nTu oferta pasará al estado « En custodia ». Contacta con {{name}} desde los detalles de la oferta para organizar su devolución cuando quieras.",
    "endsLoan": "Esta acción finalizará el préstamo actual",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "member": "este miembro",
    "reclaim": "He recuperado el objeto",
    "confirmReclaim": "¿Confirmas que has recuperado tu objeto? Esta acción finalizará su custodia. La persona guardiana ya no podrá prestarlo.",
    "history": "{{name}} fue designado·a guardián·a el {{date}}. Préstamo finalizado.",
    "banner": "Objeto enviado en custodia hace {{ago}}",
    "guardian": "🪽 Guardián·a",
    "since": "desde hace {{ago}}",
    "contact": "Contactar con el·la 🪽 guardián·a",
    "lastActive": "Activo·a hace {{ago}}",
    "owner": "👑 Propietario·a",
    "contactOwner": "Contactar con el·la 👑 propietario·a",
    "manageOffer": "Editar la oferta"
  },
  "support-profile": {
    "title": "Ayuda y soporte",
    "officialTeam": "Equipo oficial",
    "welcomeTitle": "¿Necesitas ayuda?",
    "welcomeDescription": "El equipo de {{team}} está disponible para ayudarte con tus intercambios y el uso de la aplicación.",
    "loanGuide": "¿Cómo funciona un préstamo?",
    "compensation": "Cobertura y compensación por daños/robo",
    "managePlan": "Gestionar mi suscripción Partage+",
    "manageAccount": "Gestionar mi cuenta",
    "helpCenter": "Consultar el centro de ayuda completo",
    "resourcesTitle": "Encuentra una respuesta",
    "email": "Escribir al soporte",
    "contactSupport": "Contactar con soporte",
    "faq": "Consultar nuestras preguntas frecuentes"
  }
}
